{
  "menu": {
    "category": {
      "userManagement": "Gestão de Usuários",
      "settings": "Configurações",
      "securityCompliance": "Segurança e Conformidade",
      "adminTools": "Ferramentas de Admin",
      "internalAdminTools": "Ferramentas Internas",
      "system": "Sistema",
      "orgAdmin": "Administrador da organização",
      "communication": "Comunicação",
      "widget": "Widget",
      "feature": "Funcionalidades",
      "admin": "Administração",
      "sidecar": "Móvel",
      "auth": "Autenticação",
      "sf": "Salesforce",
      "crm": "CRM",
      "tuvis-mobile": "Tuvis Remote Sync",
      "tuvis-desktop": "Tuvis Desktop App",
      "integrations": "Integrações",
      "integrationsChannels": "Canais",
      "other": "Canais",
      "platforms": "Plataformas",
      "archive": "Arquivo",
      "notifications": "Notificações",
      "tuvisAdmin": "Admin Tuvis"
    }
  },
  "bot_builder": {
    "title": "Construtor de Bots",
    "variable_name_required": "O nome da variável é obrigatório",
    "variable_name_reserved_prefix": "Nomes de variáveis não podem começar com $ (reservado para funções integradas)",
    "variable_name_no_spaces": "Nomes de variáveis não podem conter espaços",
    "nav_flows": "Fluxos",
    "nav_analytics": "Analítica",
    "nav_credentials": "Credenciais",
    "nav_sessions": "Sessões",
    "nav_triggers": "Acionamentos",
    "nav_settings": "Configurações",
    "sessions": {
      "title": "Sessões",
      "sender": "Remetente",
      "flow": "Fluxo",
      "status": "Status",
      "started_at": "Iniciado",
      "last_activity": "Última atividade",
      "duration": "Duração",
      "current_node": "Nó atual",
      "flow_version": "Versão do fluxo",
      "all_flows": "Todos os fluxos",
      "all_statuses": "Todos os status",
      "no_sessions": "Nenhuma sessão encontrada",
      "event_timeline": "Linha do tempo de eventos",
      "event_type": "Evento",
      "event_node": "Nó",
      "event_time": "Hora",
      "event_error": "Erro",
      "no_events": "Nenhum evento registrado para esta sessão",
      "debug_title": "Depuração de sessão",
      "back_to_sessions": "Voltar para sessões",
      "stop": "Parar",
      "stop_confirm_title": "Parar sessão?",
      "stop_confirm_body": "Isso encerrará a sessão imediatamente. A próxima mensagem do usuário iniciará uma nova sessão.",
      "handoff": "Transferência",
      "status_labels": {
        "active": "Ativa",
        "waiting_input": "Aguardando resposta",
        "handoff": "Transferência",
        "completed": "Concluída",
        "expired": "Expirada",
        "error": "Erro",
        "stopped": "Parada",
        "replaced": "Substituída"
      },
      "refresh": "Atualizar",
      "back_to_session": "Voltar para a sessão",
      "activity": {
        "title": "Atividade da sessão neste nó",
        "visits": "Visitas",
        "errors": "Erros",
        "no_activity": "Este nó não foi visitado nesta sessão"
      },
      "event_data": {
        "sender": "Remetente",
        "phone_id": "ID do telefone",
        "type": "Tipo",
        "text": "Texto",
        "template": "Modelo",
        "params": "Parâmetros",
        "flow_id": "ID do fluxo",
        "cta": "CTA",
        "input": "Entrada",
        "variable": "Variável",
        "request": "Requisição",
        "status": "Status",
        "duration": "Duração",
        "error": "Erro",
        "response_body": "Corpo da resposta",
        "model": "Modelo",
        "input_tokens": "Tokens de entrada",
        "output_tokens": "Tokens de saída",
        "response": "Resposta",
        "reason": "Motivo",
        "message": "Mensagem",
        "empty_value": "(vazio)"
      },
      "source": "Source",
      "triggered_by": "Triggered By",
      "trigger_batch": "Trigger Batch",
      "replaced_by": "Substituída por",
      "all_sources": "All Sources",
      "source_labels": {
        "message": "Message",
        "ui": "UI",
        "api": "API"
      }
    },
    "analytics": {
      "select_flow": "Selecionar um fluxo",
      "select_flow_hint": "Selecione um fluxo para ver analíticas",
      "date_range": "Período",
      "total_sessions": "Sessões Totais",
      "completed_sessions": "Sessões Concluídas",
      "completion_rate": "Taxa de Conclusão",
      "handoffs": "Transferências",
      "handoff_rate": "Taxa de Transferência",
      "errors": "Erros",
      "expired_sessions": "Sessões Expiradas",
      "active_sessions": "Sessões Ativas",
      "sessions_over_time": "Sessões ao Longo do Tempo",
      "load_error": "Falha ao carregar"
    },
    "palette": {
      "title": "Blocos de Construção",
      "ai_no_providers": "Conecte um provedor de IA em integrações para usar este nó",
      "transcribe_no_providers": "Conecte um provedor de transcrição de áudio em integrações para usar este nó"
    },
    "create_flow": "+ Criar Fluxo",
    "assign_to_phone": "Atribuir a telefone",
    "edit_flow": "Editar Fluxo",
    "edit_flow_metadata": "Editar Nome e Descrição",
    "update_flow_success": "Fluxo atualizado com sucesso",
    "update_flow_failure": "Falha ao atualizar o fluxo",
    "delete_flow": "Deletar Fluxo",
    "publish_flow": "Publicar Fluxo",
    "publish_latest_version": "Publicar Última Versão",
    "unpublish_flow": "Despublicar Fluxo",
    "archive_flow": "Arquivar Fluxo",
    "name": "Nome",
    "channel": "Canal",
    "description": "Descrição",
    "status": "Status",
    "status_draft": "Rascunho",
    "status_published": "Publicado",
    "status_archived": "Arquivado",
    "version": "Última Versão",
    "published_version": "Versão Publicada",
    "phone_number": "Número de Telefone",
    "published_at": "Publicado em",
    "updated_at": "Atualizado em",
    "created_at": "Criado em",
    "create_flow_success": "Fluxo criado com sucesso",
    "create_flow_failure": "Falha ao criar fluxo",
    "save_flow_success": "Fluxo salvo com sucesso",
    "save_flow_failure": "Falha ao salvar o fluxo",
    "publish_flow_success": "Fluxo publicado com sucesso",
    "publish_flow_failure": "Falha ao publicar o fluxo",
    "validation_errors": {
      "flow_missing_start_node": "O fluxo deve ter um nó de início",
      "start_node_no_outgoing": "O nó de início deve ter pelo menos uma conexão de saída",
      "edge_invalid_source": "Uma conexão referencia um nó de origem inexistente",
      "edge_invalid_target": "Uma conexão referencia um nó de destino inexistente",
      "wait_reply_missing_variable": "O nó Aguardar Resposta deve ter um nome de variável",
      "send_message_missing_content": "O nó Enviar Mensagem deve ter conteúdo",
      "send_message_missing_text": "O nó Enviar Mensagem deve ter um texto",
      "template_missing_name": "O nó Enviar Mensagem deve ter um template selecionado",
      "interactive_flow_missing_flow": "O nó Enviar Mensagem deve ter um WhatsApp Flow selecionado",
      "api_call_missing_url": "O nó Chamada API deve ter uma URL",
      "api_call_missing_method": "O nó Chamada API deve ter um método HTTP",
      "send_message_missing_message_type": "O nó Enviar Mensagem deve ter um tipo de mensagem",
      "duplicate_variable_name": "O nome da variável já está em uso por outro nó",
      "interactive_flow_missing_body": "O nó WhatsApp Flow deve ter um corpo de mensagem",
      "interactive_flow_missing_cta": "O nó WhatsApp Flow deve ter um texto de botão",
      "interactive_flow_missing_screen": "O nó WhatsApp Flow deve ter uma tela inicial selecionada",
      "ai_missing_prompt": "O nó IA deve ter um prompt",
      "ai_missing_response_variable": "O nó IA deve ter uma variável de resposta",
      "variable_name_reserved_prefix": "Nomes de variáveis não podem começar com $ (reservado para funções integradas)",
      "variable_name_no_spaces": "Nomes de variáveis não podem conter espaços",
      "set_variable_missing_assignments": "O nó Definir Variável deve ter pelo menos uma atribuição",
      "set_variable_missing_target": "A atribuição deve ter um nome de variável",
      "flow_variable_missing_name": "A variável do fluxo deve ter um nome",
      "transcribe_missing_source_variable": "Variável de origem ausente",
      "transcribe_missing_response_variable": "Variável de resposta ausente"
    },
    "unpublish_flow_success": "Fluxo revertido para rascunho",
    "unpublish_flow_failure": "Falha ao despublicar o fluxo",
    "delete_flow_success": "Fluxo excluído com sucesso",
    "delete_flow_failure": "Falha ao excluir o fluxo",
    "clone_flow": "Clonar fluxo",
    "clone_flow_success": "Fluxo clonado",
    "clone_flow_failure": "Falha ao clonar o fluxo",
    "clone_modal": {
      "title": "Clonar fluxo do bot",
      "name_label": "Nome do novo fluxo",
      "scope_label": "O que copiar",
      "scope_all": "Todas as versões",
      "scope_latest": "Somente a última versão",
      "submit": "Clonar"
    },
    "compare": {
      "title": "Comparar v{{left}} vs v{{right}}",
      "version_x": "Versão {{version}}",
      "fields_diff": "Configurações e variáveis",
      "fields_no_changes": "Sem alterações nas configurações ou variáveis",
      "minutes_value": "{{count}} min",
      "variable_label_plural": "Variáveis",
      "variable_required": "obrigatória",
      "variable_field_required": "Obrigatória",
      "variable_field_defaultValue": "Valor padrão",
      "variable_field_description": "Descrição",
      "select_two": "Selecione exatamente duas versões para comparar",
      "compare_button": "Comparar selecionadas",
      "start_compare": "Comparar versões",
      "cancel_compare": "Cancelar",
      "summary_modified": "{{count}} modificadas",
      "summary_added": "{{count}} adicionadas",
      "summary_removed": "{{count}} removidas",
      "legend_added": "Adicionado",
      "legend_removed": "Removido",
      "legend_modified": "Modificado",
      "legend_unchanged": "Sem alterações",
      "changes_panel_title": "Alterações",
      "changes_section_added": "Adicionadas",
      "changes_section_modified": "Modificadas",
      "changes_section_removed": "Removidas",
      "changes_empty": "Sem alterações",
      "mode_side_by_side": "Lado a lado",
      "mode_overlay": "Sobreposto",
      "drilldown_title": "Alterações de campos",
      "drilldown_no_data_changes": "Apenas metadados mudaram (posição, rótulo, etc.)",
      "page_title": "Comparar v{{left}} vs v{{right}}",
      "invalid_range": "Intervalo de versões inválido",
      "back": "Voltar ao fluxo"
    },
    "assign_phones_success": "Números de telefone atribuídos com sucesso",
    "assign_phones_failure": "Falha ao atribuir números de telefone",
    "confirm_publish_title": "Publicar Fluxo",
    "confirm_publish_body": "Este fluxo será ativado e começará a gerenciar conversas. Tem certeza?",
    "confirm_unpublish_title": "Despublicar Fluxo",
    "confirm_unpublish_body": "Este fluxo voltará para rascunho e deixará de gerenciar conversas. Tem certeza?",
    "confirm_delete_title": "Excluir Fluxo",
    "confirm_delete_body": "Este fluxo será excluído permanentemente e não poderá ser recuperado. Tem certeza?",
    "unsaved_confirm_title": "Alterações não salvas",
    "unsaved_confirm_body": "Você tem alterações não salvas. Tem certeza que deseja sair?",
    "settings": {
      "title": "Configurações do Bot",
      "session_history_retention": "Retenção do histórico de sessões",
      "session_history_retention_description": "Por quanto tempo manter os dados de sessões concluídas para depuração e análise.",
      "retention_days": "{{days}} dias",
      "retention_saved": "Configuração de retenção salva",
      "retention_save_failed": "Falha ao salvar configuração de retenção",
      "save": "Salvar"
    },
    "test": "Testar",
    "save": "Salvar",
    "publish": "Publicar",
    "test_chat": {
      "title": "Chat de Teste",
      "start": "Iniciar Teste",
      "reset": "Reiniciar",
      "send": "Enviar",
      "empty_state": "Teste seu fluxo simulando uma conversa. As mensagens não serão enviadas pelo WhatsApp.",
      "type_message": "Digite uma mensagem...",
      "waiting": "O bot está processando...",
      "session_ended": "Sessão encerrada",
      "session_handoff": "Transferido para agente",
      "variables": "Variáveis",
      "text_mode": "Texto",
      "flow_reply_mode": "Resposta Flow"
    },
    "unsaved": "Não salvo",
    "unpublished_changes": "Alterações não publicadas",
    "versions": "Versões",
    "version_history": "Histórico de Versões",
    "version_x": "Versão {{version}}",
    "current": "Atual",
    "no_versions": "Nenhuma versão publicada",
    "viewing_version": "Visualizando versão {{version}}",
    "back_to_draft": "Voltar ao rascunho",
    "publish_this_version": "Publicar esta versão",
    "was_published": "Publicado anteriormente",
    "save_modal": {
      "title": "Salvar Alterações",
      "subtitle": "Isso criará uma nova versão do seu fluxo.",
      "description_placeholder": "Descreva o que mudou (opcional)"
    },
    "publish_modal": {
      "title": "Publicar Fluxo",
      "body": "Tem certeza de que deseja publicar a versão {{version}}? Isso a tornará ativa para todos os números de telefone atribuídos."
    },
    "flow_settings_title": "Configurações do Fluxo",
    "session_duration_label": "Duração da Sessão (minutos)",
    "session_duration_placeholder": "Sem tempo limite",
    "session_duration_hint": "Deixe vazio ou 0 para sem tempo limite de sessão.",
    "session_expired_message_label": "Mensagem de Sessão Expirada",
    "session_expired_message_placeholder": "Sua sessão expirou. Envie uma mensagem para começar novamente.",
    "session_expired_message_hint": "Enviada quando a sessão expira. Use {{variable}} para inserir valores, ou {{variable|padrão}} para um valor alternativo se a variável não estiver definida.",
    "inactivity_timeout_label": "Tempo Limite de Inatividade (minutos)",
    "inactivity_timeout_placeholder": "Sem tempo limite",
    "inactivity_timeout_hint": "A sessão expira se o usuário não responder dentro deste tempo. Reinicia a cada mensagem.",
    "inactivity_timeout_message_label": "Mensagem de Tempo Limite de Inatividade",
    "inactivity_timeout_message_placeholder": "Não recebemos sua resposta. Sua sessão foi encerrada.",
    "inactivity_timeout_message_hint": "Enviada quando a sessão expira por inatividade. Use {{variable}} para inserir valores, ou {{variable|padrão}} para um valor alternativo se a variável não estiver definida.",
    "unsaved_confirm_leave": "Sair",
    "unsaved_confirm_stay": "Ficar",
    "modal": {
      "create_title": "Criar Fluxo",
      "edit_title": "Editar Fluxo",
      "edit_subtitle": "Atualize o nome e a descrição do fluxo. Isso não afetará nenhuma versão.",
      "name_label": "Nome do Fluxo",
      "name_placeholder": "Digite o nome do fluxo",
      "description_label": "Descrição",
      "description_placeholder": "Digite a descrição do fluxo"
    },
    "flow_type_label": "Tipo de fluxo",
    "flow_type_sms": "SMS",
    "flow_type_whatsapp": "WhatsApp",
    "flow_type_help": "Fluxos SMS só podem enviar texto livre. Fluxos WhatsApp podem enviar texto livre ou modelos.",
    "flow_type_locked_template": "Não é possível alterar o tipo de fluxo enquanto algum nó Enviar mensagem usar modelo. Remova ou altere esses nós primeiro.",
    "filter_modal": {
      "title": "Configurar um filtro",
      "close": "Fechar",
      "label": "Rótulo",
      "label_placeholder": "ex. caminho de sucesso",
      "label_max": "Máximo de 120 caracteres.",
      "condition": "Condição",
      "no_condition_hint": "Sem condição = este caminho é usado quando nenhuma outra aresta corresponde (reserva).",
      "all_rules_and": "Todas as regras (E)",
      "any_rule_or": "Qualquer regra (OU)",
      "add_and_rule": "Adicionar regra E",
      "add_or_rule": "Adicionar regra OU",
      "add_rule": "Adicionar regra",
      "value_placeholder": "Valor",
      "variables": "Variáveis",
      "flow_variables": "Variáveis do Fluxo",
      "fallback_description": "Definir a rota como reserva. Uma rota de reserva é usada se os dados não passaram por nenhuma outra rota. Um nó pode ter apenas uma rota de reserva.",
      "fallback_confirm_title": "Substituir rota de reserva",
      "fallback_confirm_body": "Outra aresta deste nó já está configurada como rota de reserva. Apenas uma rota de reserva é permitida por nó. Deseja substituí-la?",
      "yes": "Sim",
      "no": "Não",
      "order": "Ordem",
      "order_of": "{{current}} de {{total}}",
      "move_up": "Subir",
      "move_down": "Descer",
      "delete_edge": "Excluir aresta",
      "operator_equals": "Texto: Igual a",
      "operator_not_equals": "Texto: Diferente de",
      "operator_contains": "Texto: Contém",
      "operator_not_contains": "Texto: Não contém",
      "operator_starts_with": "Texto: Começa com",
      "operator_ends_with": "Texto: Termina com",
      "operator_regex": "Texto: Corresponde ao regex",
      "operator_greater_than": "Numérico: Maior que",
      "operator_less_than": "Numérico: Menor que",
      "operator_is_empty": "Existência: Está vazio",
      "operator_is_not_empty": "Existência: Não está vazio",
      "trigger_sources_label": "Active for trigger sources",
      "trigger_sources_hint": "This edge only fires if the session was triggered by one of the selected sources. Uncheck to restrict."
    },
    "assign_modal": {
      "title": "Atribuir bot ao número de telefone",
      "phone_label": "Número de telefone",
      "phone_placeholder": "Selecionar telefone WABA",
      "trigger_all_messages": "Acionar em todas as mensagens",
      "trigger_new_conversations_only": "Apenas em novas conversas",
      "trigger_keywords_label": "Palavras-chave (separadas por vírgula)",
      "trigger_keywords_placeholder": "olá, início, menu",
      "current_assignments": "Atribuições atuais",
      "remove": "Remover",
      "assign_success": "Bot atribuído ao número",
      "assign_failure": "Falha ao atribuir o bot",
      "fill_required": "Preencha todos os campos obrigatórios"
    },
    "node_config": {
      "configure_node": "Configurar Nó",
      "close": "Fechar",
      "label": "Rótulo",
      "label_placeholder": "Rótulo do nó",
      "type_start": "Início",
      "type_send_message": "Enviar Mensagem",
      "type_wait_for_reply": "Aguardar Resposta",
      "type_api_call": "Chamada de API",
      "type_human_handoff": "Transferir para Agente",
      "type_ai": "IA",
      "type_transcribe": "Transcrever",
      "type_set_variable": "Definir Variável",
      "set_variable_hint": "Atribua uma ou mais variáveis. Cada valor pode combinar texto, variáveis existentes {{var}} e funções {{$uuid}}, {{$sessionId}}, {{$random:1:100}}, {{$randomFloat:0:1}}, {{$timestamp}}, {{$now}}.",
      "set_variable_target": "Nome da variável",
      "set_variable_target_placeholder": "ex. orderId",
      "set_variable_value": "Valor",
      "set_variable_value_placeholder": "ex. order-{{$uuid}}",
      "set_variable_add_assignment": "+ Adicionar atribuição",
      "set_variable_functions_group": "Funções",
      "delete_node": "Excluir Nó",
      "unknown_node_type": "Tipo de nó desconhecido",
      "captures": "Captura",
      "all_messages": "Todas as mensagens",
      "no_content": "Sem conteúdo",
      "trigger_keywords": "Palavras-chave de ativação (separadas por vírgula)",
      "text": "Texto",
      "free_text": "Texto",
      "template": "Modelo",
      "message_type": "Tipo de Mensagem",
      "message_text": "Texto da Mensagem",
      "message_text_hint": "Use {{variable}} para inserir valores, ou {{variable|padrão}} como alternativa. Ex: Olá {{userName|amigo}}!",
      "message_separator": "Separador de mensagens",
      "message_separator_hint": "Opcional, máximo 32 caracteres. Quando definido, o texto é dividido em várias mensagens do WhatsApp onde esta string aparece em sua própria linha (ex. ---). Deixe vazio para enviar como uma única mensagem.",
      "media_url": "URL de Mídia",
      "media_type": "Tipo de Mídia",
      "image": "Imagem",
      "video": "Vídeo",
      "audio": "Áudio",
      "document": "Documento",
      "template_name": "Nome do Modelo",
      "language": "Idioma",
      "select_template": "Selecionar modelo",
      "no_templates_available": "Nenhum modelo disponível",
      "no_templates_hint": "Acesse as configurações do WhatsApp Business para criar e publicar modelos.",
      "header_params": "Parâmetros do Cabeçalho",
      "body_params": "Parâmetros do Corpo",
      "button_params": "Botão",
      "template_preview": "Pré-visualização do Modelo",
      "template_params_hint": "Use {{variable}} para inserir valores da sessão. Ex: {{userReply.text}}",
      "offer_code": "Código de Oferta",
      "whatsapp_flow": "WhatsApp Flow",
      "flow_name": "Fluxo",
      "flow_cta": "Texto do botão",
      "flow_cta_placeholder": "Continuar",
      "flow_body": "Corpo da mensagem",
      "flow_header": "Cabeçalho (opcional)",
      "flow_footer": "Rodapé (opcional)",
      "no_flows_available": "Nenhum fluxo do WhatsApp disponível",
      "select_flow": "Selecionar um fluxo",
      "flow_screen": "Tela inicial",
      "select_screen": "Selecionar uma tela",
      "no_screens_available": "Nenhuma tela disponível",
      "select_flow_first": "Selecione um fluxo primeiro",
      "refresh_templates": "Recarregar modelos",
      "refresh_flows": "Recarregar fluxos",
      "interactive_type": "Tipo Interativo",
      "buttons_up_to_3": "Botões (até 3)",
      "list": "Lista",
      "body_text": "Texto do Corpo",
      "header_optional": "Cabeçalho (opcional)",
      "footer_optional": "Rodapé (opcional)",
      "buttons": "Botões",
      "add_button": "Adicionar Botão",
      "list_button_text": "Texto do Botão da Lista",
      "list_rows": "Linhas da Lista",
      "add_row": "Adicionar Linha",
      "store_reply_variable": "Armazenar resposta em variável",
      "expected_message_types": "Tipos de mensagem aceitos",
      "expected_message_types_hint": "Aceitar apenas estes tipos de mensagem. Deixar vazio para aceitar todos os tipos. Se o usuário enviar outro tipo, a mensagem de erro é enviada e o nó continua aguardando.",
      "expected_types_placeholder": "Todos os tipos aceitos",
      "max_file_size_label": "Tamanho máximo do arquivo (MB)",
      "max_file_size_hint": "Tamanho máximo do arquivo em MB (1-16). Padrão de 16 MB.",
      "body_variable_hint": "Digite {{ para inserir uma variável",
      "expected_type_text": "Texto",
      "expected_type_interactive": "Interativo (WhatsApp Flow)",
      "expected_type_button": "Botão",
      "expected_type_image": "Imagem",
      "expected_type_document": "Documento",
      "expected_type_audio": "Áudio",
      "expected_type_video": "Vídeo",
      "timeout_seconds": "Tempo limite (segundos)",
      "on_timeout_go_to": "Ao expirar ir para",
      "select_node": "Selecionar nó",
      "validation_regex": "Regex de Validação",
      "invalid_input_message": "Mensagem de Entrada Inválida",
      "invalid_input_message_placeholder": "Por favor forneça uma resposta válida.",
      "authentication_type": "Tipo de autenticação *",
      "auth_none": "Nenhum",
      "auth_bearer": "Token Bearer",
      "auth_basic": "Autenticação Básica",
      "auth_api_key": "Chave de API",
      "auth_hint": "Selecione o tipo de autenticação para uma chamada de API ou webhook autenticado.",
      "bearer_token_label": "Token Bearer",
      "username": "Usuário",
      "password": "Senha",
      "header_name": "Nome do cabeçalho",
      "value": "Valor",
      "url_label": "URL *",
      "url_hint": "Insira a URL de um endpoint de API (incluindo a URL base), começando com https://.",
      "method_label": "Método *",
      "method_hint": "Selecione o método de requisição HTTP.",
      "headers": "Cabeçalhos",
      "headers_hint": "Adicione cabeçalhos personalizados para a requisição.",
      "name_placeholder": "Nome",
      "value_placeholder": "Valor",
      "add_header": "+ Adicionar cabeçalho",
      "query_parameters": "Parâmetros de consulta",
      "query_parameters_hint": "Adicione parâmetros para métodos GET e DELETE.",
      "add_parameter": "+ Adicionar parâmetro",
      "body_content": "Conteúdo do corpo",
      "body_content_hint": "Selecione o formato do corpo. Usado principalmente para POST, PUT e PATCH.",
      "body_json": "JSON",
      "body_form_urlencoded": "application/x-www-form-urlencoded",
      "body_multipart": "multipart/form-data (suporta upload de arquivos)",
      "body_raw": "Raw",
      "add_field": "+ Adicionar campo",
      "parse_response": "Analisar resposta",
      "yes": "Sim",
      "no": "Não",
      "parse_response_hint": "Estruture a saída para uso em variáveis. Execute o fluxo uma vez para mapear resultados.",
      "pagination_type": "Tipo de paginação",
      "pagination_offset": "Deslocamento",
      "pagination_cursor": "Cursor",
      "pagination_page_number": "Número da página",
      "pagination_hint": "Use se a API retorna resultados divididos em várias páginas.",
      "select_pagination_type": "Selecionar tipo de paginação",
      "response_variable": "Variável de resposta",
      "response_variable_hint": "Nome da variável para armazenar a resposta (ex.: para condições ou mensagens).",
      "retry": "Tentativas",
      "retry_count": "Quantidade de tentativas",
      "retry_delay": "Atraso entre tentativas (ms)",
      "retry_hint": "Tenta novamente apenas em erros de rede, timeouts ou falhas de conexão. Respostas HTTP (incluindo 4xx/5xx) não são repetidas - são armazenadas na variável de resposta para avaliação de condições.",
      "request_timeout": "Tempo limite da requisição",
      "request_timeout_seconds": "Tempo limite (segundos)",
      "request_timeout_hint": "Tempo máximo de espera por uma resposta. Padrão é 10 segundos, máximo é 120 segundos.",
      "file_attachment": "Anexo de arquivo",
      "file_variable": "Variável do arquivo",
      "file_field_name": "Nome do campo",
      "file_attachment_hint": "Variável que contém o arquivo (ex. userReply). O arquivo do S3 é enviado como multipart. Para corpo JSON, use {{userReply.filePath}} - resolve automaticamente para uma URL de download.",
      "debounce_label": "Espera de mensagens",
      "debounce_hint": "Aguardar por mensagens adicionais antes de processar. Útil quando os usuários dividem sua entrada em várias mensagens.",
      "debounce_unit_ms": "ms",
      "debounce_unit_sec": "seg",
      "debounce_unit_min": "min",
      "handoff_reason": "Motivo da Transferência",
      "handoff_reason_placeholder": "Usuário solicitou agente",
      "handoff_message": "Mensagem de Transferência",
      "handoff_message_placeholder": "Transferindo você para um agente...",
      "ai_model": "Modelo",
      "ai_model_default": "Padrão",
      "ai_system_prompt": "Prompt do Sistema",
      "ai_system_prompt_placeholder": "Configure o papel e comportamento da IA...",
      "ai_prompt": "Prompt",
      "ai_prompt_placeholder": "Insira o prompt para a IA...",
      "ai_response_variable": "Variável de Resposta",
      "ai_temperature": "Temperatura",
      "ai_max_tokens": "Tokens Máximos de Saída",
      "ai_improve_prompt": "Melhorar prompt",
      "ai_context_instructions": "Instruções de Contexto",
      "ai_context_instructions_placeholder": "Defina o papel, personalidade e conhecimento da IA...",
      "ai_context_instructions_hint": "Define o comportamento e conhecimento da IA para este nó",
      "ai_include_history": "Incluir histórico de conversa",
      "ai_max_history_turns": "Máximo de turnos de histórico",
      "ai_max_history_turns_hint": "Número de pares de mensagens recentes a incluir (1-50)",
      "ai_history_enabled": "Histórico habilitado",
      "ai_improving_prompt": "Melhorando...",
      "ai_prompt_strength_weak": "Prompt fraco",
      "ai_prompt_strength_medium": "Prompt médio",
      "ai_prompt_strength_strong": "Prompt forte",
      "ai_advanced": "Configurações Avançadas",
      "target_agent_id": "ID do Agente Alvo",
      "auth_oauth2_mtls": "OAuth2 mTLS",
      "credential_label": "Credencial de API",
      "select_credential": "Selecionar credencial",
      "credential_hint": "Selecione uma credencial OAuth2 mTLS para autenticação com o endpoint da API.",
      "credential_hint_oauth2": "Selecione uma credencial OAuth2 para autenticação com o endpoint da API",
      "credential_hint_mtls": "Selecione uma credencial OAuth2 mTLS para autenticação com o endpoint da API",
      "auth_oauth2": "OAuth2",
      "transcribe_source_variable": "Variável de origem",
      "transcribe_source_variable_hint": "Variável de uma etapa anterior que capturou uma mensagem de voz (ex. \"userReply\"). O nó lê <variable>.filePath.",
      "transcribe_response_variable": "Variável de resposta",
      "transcribe_response_variable_hint": "Armazena o texto transcrito em <variable>.text e o provedor em <variable>.provider. É definido como true em <variable>.skipped quando o áudio excede o limite de tamanho.",
      "transcribe_from": "de",
      "transcribe_to": "para",
      "add_credential": "+ Adicionar Credencial"
    },
    "credentials": {
      "title": "Credenciais de API",
      "manage": "Gerenciar Credenciais",
      "create": "Criar",
      "create_title": "Criar Credencial",
      "edit": "Editar",
      "edit_title": "Editar Credencial",
      "save": "Salvar",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "delete_confirm": "Tem certeza de que deseja excluir esta credencial?",
      "name": "Nome",
      "description": "Descrição",
      "token_endpoint": "Endpoint de Token",
      "client_id": "ID do Cliente",
      "client_secret": "Segredo do Cliente",
      "grant_type": "Tipo de Concessão",
      "scope": "Escopo",
      "client_cert": "Certificado do Cliente",
      "client_key": "Chave do Cliente",
      "actions": "Ações",
      "create_success": "Credencial criada com sucesso",
      "create_failure": "Falha ao criar credencial",
      "save_success": "Credencial atualizada com sucesso",
      "save_failure": "Falha ao atualizar credencial",
      "delete_success": "Credencial excluída com sucesso",
      "delete_failure": "Falha ao excluir credencial",
      "delete_confirm_title": "Excluir Credencial",
      "type": "Tipo",
      "verify": "Verificar",
      "verify_success": "Credencial verificada com sucesso",
      "verify_failure": "Falha ao verificar credencial"
    },
    "trigger": {
      "settings_title": "Configurações do acionador",
      "modes_label": "Modos de acionamento",
      "modes_hint": "Selecione como este fluxo pode ser acionado. Pelo menos um modo deve estar marcado.",
      "mode_message": "Mensagem",
      "mode_ui": "UI",
      "mode_api": "API",
      "collision_policy_label": "Política de colisão",
      "collision_reject": "Rejeitar",
      "collision_reject_hint": "se o destinatário já tem uma sessão ativa para este fluxo, rejeita o novo acionamento e mantém a sessão existente em execução.",
      "collision_replace": "Substituir",
      "collision_replace_hint": "se o destinatário já tem uma sessão ativa para este fluxo, expira-a e inicia uma nova sessão para o novo acionamento.",
      "required_variables": "Variáveis obrigatórias",
      "curl_snippet_label": "Trecho cURL (acionamento por API)",
      "trigger_action": "Acionar",
      "modal_title": "Acionar fluxo",
      "tab_single": "Destinatário único",
      "tab_csv": "Upload de CSV",
      "phone_number": "Número de telefone",
      "phone_number_placeholder": "Selecione um número de telefone",
      "recipient_phone": "Telefone do destinatário",
      "collision_override": "Substituir política de colisão",
      "collision_use_default": "Usar padrão do fluxo",
      "variable_placeholder": "Inserir valor",
      "variables_label": "Variáveis do Fluxo",
      "variables_hint": "Declare as variáveis que este fluxo aceita. Os disparadores (UI, CSV, API) fornecem valores ao acioná-lo. Variáveis sem valor padrão são obrigatórias.",
      "variable_default_title": "Variável {{idx}}",
      "variable_name_label": "Nome",
      "variable_default_label": "Valor padrão",
      "variable_description_label": "Descrição",
      "variable_name_placeholder": "nome",
      "variable_default_placeholder": "(opcional)",
      "variable_description_placeholder": "(opcional)",
      "variable_add": "+ Adicionar variável",
      "variable_remove": "Remover",
      "variable_required": "Obrigatório",
      "variable_optional": "Opcional",
      "variable_duplicate": "Nome de variável duplicado.",
      "variable_node_conflict": "O nome entra em conflito com uma variável declarada por um nó deste fluxo.",
      "send": "Enviar",
      "accepted": "Aceito",
      "rejected": "Rejeitado",
      "trigger_sent": "Disparador enviado.",
      "view_batch": "Ver lote",
      "errors": {
        "flow_not_found": "Fluxo não encontrado.",
        "flow_not_published": "Este fluxo não está publicado. Publique uma versão antes de acioná-lo.",
        "mode_not_allowed": "Este fluxo não permite esta origem de acionamento. Abra as configurações do acionador do fluxo para habilitá-la.",
        "no_send_message_node": "Este fluxo não tem nó de envio de mensagem, então não há nada para enviar ao acioná-lo.",
        "first_send_must_be_template": "Fluxos de saída devem começar com um template do WhatsApp. Configure o primeiro nó de envio de mensagem para usar um template aprovado antes de acioná-lo.",
        "sessionBusy": "O destinatário já tem uma sessão ativa para este fluxo.",
        "recipientInAttendance": "O destinatário está em atendimento com um agente no momento.",
        "duplicate_in_batch": "Destinatário duplicado neste lote - apenas a primeira linha foi processada.",
        "invalidPhone": "Número de telefone inválido.",
        "missingVariables": "Faltam uma ou mais variáveis obrigatórias."
      },
      "list_title": "Lotes de acionamento",
      "list_no_batches": "Nenhum lote de acionamento encontrado.",
      "csv_modal_text": "Crie um arquivo CSV: Certifique-se de que seu arquivo CSV inclua as seguintes colunas:",
      "csv_template_button": "Baixar modelo CSV",
      "required": "obrigatório",
      "csv_dragger": "Clique ou arraste um arquivo .csv aqui para enviar",
      "csv_format_hint": "A primeira coluna deve ser \"to\". As demais colunas mapeiam para variáveis do fluxo.",
      "csv_missing_to": "O CSV precisa ter uma coluna \"to\" como primeira coluna.",
      "csv_missing_vars": "Faltam colunas de variáveis obrigatórias no CSV",
      "csv_row_count": "{{count}} linhas",
      "csv_large_file": "{{count}} linhas - este é um lote grande e pode demorar.",
      "batch_title": "Lote de acionamento",
      "batch_id": "ID do lote",
      "batch_created_at": "Criado em",
      "batch_created_by": "Criado por",
      "batch_total": "Total",
      "batch_accepted": "Aceitos",
      "batch_rejected": "Rejeitados",
      "batch_completed": "Concluídos",
      "batch_failed": "Com falha",
      "batch_col_to": "Para",
      "batch_col_accepted": "Aceito",
      "batch_col_session": "Sessão",
      "batch_col_session_status": "Status da sessão",
      "batch_col_variables": "Variáveis",
      "batch_col_rejection_reason": "Motivo da rejeição",
      "batch_col_error": "Erro",
      "batch_col_updated_at": "Atualizado",
      "batch_filter_all": "Todos",
      "batch_filter_all_accepted": "Todos aceitos",
      "batch_filter_all_statuses": "Todos os status",
      "batch_filter_rejected": "Rejeitados",
      "batch_search_phone": "Buscar telefone...",
      "batch_yes": "Sim",
      "batch_no": "Não",
      "batch_no_items": "Nenhum item encontrado.",
      "batch_load_more": "Carregar mais",
      "batch_loading": "Carregando..."
    }
  },
  "org_explorer": {
    "title": "Explorador de Organizações",
    "placeholder": "Selecione ou pesquise um flag",
    "flag_label": "Flag:",
    "results_count": "{{count}} organizações encontradas",
    "showing_count": "Mostrando {{shown}} de {{total}} organizações",
    "empty_state": "Selecione um flag para ver quais organizações o têm habilitado.",
    "no_results": "Nenhuma organização encontrada para este flag.",
    "no_flag_matches": "Nenhum flag corresponde à sua busca",
    "copy_all": "Copiar todos os IDs",
    "export_csv": "Exportar CSV",
    "clear": "Limpar",
    "run_query": "Executar consulta",
    "filters_label": "Filtros",
    "helper_text": "Encontre organizações que correspondam às condições dadas.",
    "preview_label": "Prévia:",
    "preview_placeholder": "Adicione condições para ver uma prévia da consulta.",
    "clear_all": "Limpar tudo",
    "searching": "Buscando…",
    "conditions_label": "Condições:",
    "conditions_count": "{{count}} condições",
    "connector_and": "E",
    "connector_or": "OU",
    "add_condition": "Adicionar condição",
    "remove_condition": "Remover",
    "collapse_filters": "Recolher filtros",
    "expand_filters": "Expandir filtros",
    "condition_flag_placeholder": "Selecione um flag",
    "condition_value_placeholder": "Informe um valor",
    "operator_is": "é",
    "operator_is_not": "não é",
    "operator_eq": "Igual a",
    "operator_ne": "Diferente de",
    "operator_gt": "Maior que",
    "operator_gte": "Maior ou igual a",
    "operator_lt": "Menor que",
    "operator_lte": "Menor ou igual a",
    "operator_contains": "Contém",
    "operator_not_contains": "Não contém",
    "operator_starts_with": "Começa com",
    "operator_between": "Entre",
    "operator_includes_all": "Inclui todos",
    "operator_includes_any": "Inclui algum",
    "operator_excludes_all": "Exclui todos",
    "operator_greater_than": "Maior que",
    "operator_less_than": "Menor que",
    "operator_is_exactly": "É exatamente",
    "operator_before": "Antes de",
    "operator_after": "Depois de",
    "operator_exactly": "Exatamente",
    "value_true": "Verdadeiro",
    "value_false": "Falso",
    "value_enabled": "Habilitado",
    "value_disabled": "Desabilitado",
    "validation_value_required": "O valor é obrigatório",
    "type_label": "Tipo",
    "type_boolean": "Booleano",
    "type_number": "Número",
    "type_string": "Texto",
    "type_select": "Seleção",
    "type_multi": "Multi-seleção",
    "type_date": "Data",
    "copy_org_id": "Copiar ID da org",
    "toast_copied": "Copiado",
    "table": {
      "org_name": "Nome da org",
      "org_id": "ID da org",
      "description": "Descrição",
      "actions": "Ações",
      "open_org": "Abrir org",
      "integrations": "Integrações"
    },
    "errors": {
      "failed_load": "Falha ao carregar organizações. Tente novamente."
    },
    "source_config": "Flag de configuração",
    "source_computed": "Métrica de usuários",
    "source_integration": "Integração",
    "condition_computed_placeholder": "Selecione uma métrica",
    "condition_integration_placeholder": "Selecione uma integração",
    "category_placeholder": "Selecione uma categoria...",
    "category_group_metrics": "Métricas",
    "category_group_configuration": "Configuração",
    "category_integrations": "Integrações",
    "category_feature_flags": "Flags de configuração",
    "category_metrics": "Métricas",
    "no_category_matches": "Nenhuma categoria corresponde à sua busca",
    "select_integrations_placeholder": "Selecione integrações...",
    "select_flag_placeholder": "Selecione um flag...",
    "select_flag_first": "Selecione um flag primeiro",
    "select_metric_placeholder": "Selecione uma métrica...",
    "select_metric_first": "Selecione uma métrica primeiro",
    "enter_number_placeholder": "Informe número",
    "min_placeholder": "Mín",
    "max_placeholder": "Máx",
    "and": "e",
    "has": "Tem",
    "does_not_have": "Não tem",
    "has_integration": "Tem integração",
    "does_not_have_integration": "Não tem integração",
    "computed_fields": {
      "total_users": "Total de usuários",
      "total_users_help": "Quantidade total de usuários na organização",
      "active_users": "Usuários ativos",
      "active_users_help": "Quantidade de usuários com status ativo",
      "sidecar_users": "Usuários com sidecar",
      "sidecar_users_help": "Quantidade de usuários com sidecar habilitado",
      "desktop_users": "Usuários de desktop",
      "desktop_users_help": "Quantidade de usuários com app de desktop",
      "last_activity": "Última atividade",
      "last_activity_help": "Último login de um usuário na organização"
    }
  },
  "common": {
    "hide": "Ocultar",
    "show": "Mostrar",
    "copy": "Copiar",
    "copied_to_clipboard": "Copiado para a área de transferência"
  },
  "chat_now_modal": {
    "search_no_resoults_found": "Nenhum resultado encontrado. Por favor, tente outra pesquisa.",
    "start_chat": "Iniciar Conversa"
  },
  "settings": "Configurações",
  "back": "Voltar",
  "next": "Próximo",
  "save_changes": "Salvar Alterações",
  "support": "Suporte",
  "tuvis_platform": "Plataforma Tuvis",
  "error_try_again": "Por favor, tente novamente mais tarde",
  "login": {
    "login_failed": "Falha no login",
    "no_sufficient_permissions": "Você não tem permissão para acessar este aplicativo"
  },
  "coming_soon": "Em breve",
  "status": "Status",
  "home": {
    "title": "Início",
    "banner": {
      "title": "Atualização!",
      "learn_more": "Saiba mais"
    },
    "welcome": {
      "title": "Bem-vindo à Plataforma Tuvis",
      "description": "Sua jornada segura, compatível e produtiva começa aqui. Gerencie comunicações, usuários, canais e sistemas em um único lugar. Experimente uma integração perfeita em seu fluxo de trabalho mantendo os mais altos padrões de proteção de dados e eficiência da equipe.",
      "greeting": "Bem-vindo de volta, <bold>{{name}}</bold>!"
    },
    "quick_actions": {
      "title": "Ações Rápidas",
      "edit": "Editar",
      "done": "Concluído",
      "drag_to_reorder": "Arraste para reordenar",
      "click_to_hide": "Clique para remover",
      "add_action": "Adicionar ação rápida",
      "add_action_desc": "Fixar qualquer página para acesso rápido",
      "add_action_modal_title": "Adicionar ação rápida",
      "search_pages": "Pesquisar páginas...",
      "no_pages_found": "Nenhuma página encontrada"
    }
  },
  "auto_sync": {
    "on": "Ligado",
    "off": "Desligado",
    "inherent": "Global"
  },
  "org_overview": {
    "title": "Org Overview"
  },
  "analytics": {
    "title": "Analytics"
  },
  "analytics_dashboard": {
    "title": "Dashboard"
  },
  "cyber_insights": {
    "title": "Segurança e Incidentes",
    "total_incidents": "Total de incidentes",
    "count": "Contagem",
    "violated_dlp": "Políticas DLP violadas",
    "min": "Minutos",
    "time_to_resolve": "Tempo médio para resolver um incidente em minutos",
    "time_to_resolve_chart_label": "Tempo de resolução",
    "daily_incidents": "Incidentes diários",
    "daily_incidents_chart_label": "Incidentes",
    "incidents_per_user": "Incidentes por usuário",
    "incidents_per_severity": "Incidentes por gravidade",
    "export_incidents": "Incidentes",
    "export_average_time_to_resolve": "Tempo médio para resolver",
    "day": "Dia",
    "time_to_response": "Média de minutos para responder",
    "number_of_incidents": "Número de incidentes",
    "created_by": "Criado por"
  },
  "compliance_insights": {
    "title": "Conformidade"
  },
  "surveillance_insights": {
    "title": "Vigilância e Incidentes",
    "total_incidents": "Total de incidentes",
    "violated_policies": "Principais políticas de vigilância violadas",
    "daily_incidents": "Incidentes diários",
    "incidents_per_user": "Incidentes por usuário",
    "incidents_per_severity": "Incidentes por gravidade",
    "export_incidents": "Incidentes",
    "export_violated_policies": "Políticas de vigilância violadas",
    "export_daily_incidents": "Incidentes diários",
    "export_incidents_per_user": "Incidentes por usuário"
  },
  "call_recordings_insights": {
    "title": "Resumo de gravações de chamadas",
    "export_call_recordings": "Gravações de chamadas",
    "total_call_recordings": "Total de gravações de chamadas",
    "outgoing": "Saída",
    "incoming": "Entrada",
    "count": "Contagem",
    "call_recordings_per_user": "Gravações de chamadas por usuário",
    "number_of_call_recordings": "Número de gravações de chamadas"
  },
  "user_analytics": {
    "title": "Análise de Usuários",
    "subtitle": "Análise detalhada do tempo de resposta para cada usuário em sua organização (Últimos 3 meses)",
    "search_placeholder": "Pesquisar por ID do usuário...",
    "search_name_placeholder": "Pesquisar por nome do usuário...",
    "edit_columns": "Editar Colunas",
    "no_data": "Nenhum dado de análise de usuário disponível",
    "edit_columns_modal": {
      "title": "Personalizar Colunas da Tabela",
      "description": "Escolha quais métricas exibir na tabela de análise de usuários. Você pode mostrar ou ocultar colunas com base em suas necessidades de análise."
    },
    "column_groups": {
      "basic": "Informações Básicas",
      "response_times": "Métricas de Tempo de Resposta",
      "time_distribution": "Análise de Distribuição de Tempo"
    },
    "columns": {
      "user_id": "ID do Usuário",
      "engagement_user_id": "ID de usuário CRM / analytics",
      "user_name": "Nome do Usuário",
      "isOnline": "Status Online",
      "online_source": "Fonte online",
      "total_responses": "Total de Respostas",
      "total_duration": "Duração Online",
      "median_response_minutes": "Tempo de Resposta Mediano",
      "average_response_minutes": "Tempo de Resposta Médio",
      "min_response_minutes": "Tempo de Resposta Mínimo",
      "max_response_minutes": "Tempo de Resposta Máximo",
      "p90_response_minutes": "Resposta Percentil 90",
      "p95_response_minutes": "Resposta Percentil 95",
      "stddev_response_minutes": "Desvio Padrão do Tempo de Resposta",
      "responses_within_5min": "Respostas Dentro de 5 Min",
      "responses_within_15min": "Respostas Dentro de 15 Min",
      "responses_within_1hour": "Respostas Dentro de 1 Hora",
      "responses_over_1hour": "Respostas Mais de 1 Hora",
      "business_hours_responses": "Respostas Horário Comercial",
      "after_hours_responses": "Respostas Fora do Horário",
      "weekend_responses": "Respostas Fim de Semana",
      "weekday_responses": "Respostas Dias Úteis",
      "pct_within_5min": "% Dentro de 5 Min",
      "pct_within_15min": "% Dentro de 15 Min",
      "pct_within_1hour": "% Dentro de 1 Hora",
      "pct_over_1hour": "% Mais de 1 Hora",
      "pct_business_hours": "% Horário Comercial",
      "pct_after_hours": "% Fora do Horário",
      "pct_weekend": "% Fim de Semana",
      "pct_weekday": "% Dias Úteis"
    },
    "date_filter": "FILTRAR DATA"
  },
  "custom_filters": {
    "title": "Filtros personalizados",
    "create_new": "Novo filtro",
    "create_first": "Crie seu primeiro filtro",
    "empty_state": "Nenhum filtro personalizado ainda. Crie um para filtrar conversas pelos resultados de relatórios do Salesforce.",
    "no_assignments": "Não atribuído",
    "users": "usuários",
    "groups": "grupos",
    "columns": {
      "name": "Nome",
      "description": "Descrição",
      "reports": "Relatórios",
      "assigned": "Atribuído a",
      "last_updated": "Última atualização",
      "actions": "Ações"
    },
    "actions": {
      "settings": "Configurações",
      "delete": "Excluir"
    },
    "deleteModal": {
      "title": "Excluir filtro personalizado",
      "description": "Tem certeza que deseja excluir \"{{name}}\"?",
      "submit": "Excluir"
    },
    "errors": {
      "failedDelete": "Falha ao excluir o filtro personalizado",
      "loadFailed": "Falha ao carregar os filtros personalizados"
    },
    "modal": {
      "title": "Criar filtro personalizado",
      "edit_title": "Editar filtro personalizado",
      "name_label": "Nome do filtro",
      "description_label": "Descrição",
      "users_label": "Usuários",
      "groups_label": "Grupos",
      "reports_placeholder": "Selecione relatórios Salesforce...",
      "submit_create": "Criar",
      "submit_save": "Salvar",
      "errors": {
        "name_required": "O nome do filtro é obrigatório",
        "name_too_short": "O nome do filtro deve ter pelo menos 3 caracteres",
        "create_failed": "Falha ao criar o filtro. Tente novamente.",
        "update_failed": "Falha ao atualizar o filtro. Tente novamente."
      }
    }
  },
  "dashboards": {
    "title": "Visualização personalizada",
    "subtitle": "Crie e gerencie visualizações personalizadas com dados do CRM para sua equipe",
    "create_new": "Nova visualização personalizada",
    "create_first": "Crie sua primeira visualização personalizada",
    "empty_state": "Nenhuma visualização personalizada criada ainda. Crie a primeira para começar!",
    "home_badge": "Início",
    "no_assignments": "Não atribuído",
    "users": "usuários",
    "groups": "grupos",
    "confirm_delete": "Tem certeza que deseja excluir \"{{name}}\"? Todos os widgets serão removidos permanentemente.",
    "addWidget": "Adicionar widget",
    "addFirstWidgetButton": "+ Adicionar o primeiro widget",
    "editWidget": "Editar widget",
    "widgetTitle": "Título do widget",
    "widgetTitlePlaceholder": "ex.: Vendas totais, Casos abertos",
    "widgetDescription": "Descrição do widget",
    "widgetDescriptionPlaceholder": "ex.: Exibe as vendas totais deste trimestre",
    "report": "Relatório",
    "displayAs": "Exibir como",
    "yAxis": "Eixo Y",
    "xAxis": "Eixo X",
    "measure": "Medida",
    "selectGroupingField": "Selecione o campo de agrupamento...",
    "selectMeasure": "Selecione a medida...",
    "preview": "Visualização",
    "selectReportToPreview": "Selecione um relatório para visualizar o widget",
    "selectDisplayTypeToPreview": "Selecione um tipo de exibição para ver a visualização",
    "recordCount": "Contagem de registros",
    "add": "Adicionar",
    "update": "Atualizar",
    "widgets": {
      "loading": "Carregando...",
      "noDataAvailable": "Nenhum dado disponível",
      "noReportConfigured": "Nenhum relatório Salesforce configurado",
      "failedLoadReportData": "Falha ao carregar dados do relatório",
      "failedLoadWidgetData": "Falha ao carregar dados do widget",
      "unsupportedWidgetType": "Tipo de widget não suportado: {{type}}",
      "item": "Item",
      "noGroupedDataAvailable": "Nenhum dado agrupado disponível",
      "noNumericValuesFound": "Nenhum valor numérico encontrado no relatório",
      "tryDifferentReport": "Este relatório pode não ter valores agregados. Tente outro relatório ou tipo de widget.",
      "reportMayNotHaveAggregates": "Este relatório pode não ter valores agregados.",
      "values": "Valores",
      "noDetailDataAvailable": "Nenhum dado de detalhe disponível",
      "showingRowsOfTotal": "Mostrando {{shown}} de {{total}} linhas",
      "noDataToDisplay": "Nenhum dado para exibir",
      "viewReport": "Ver relatório"
    },
    "widgetTypes": {
      "kpiCard": "Cartão KPI",
      "barChart": "Gráfico de barras",
      "pieChart": "Gráfico de pizza",
      "lineChart": "Gráfico de linhas"
    },
    "validation": {
      "selectReport": "Selecione um relatório Salesforce",
      "selectWidgetType": "Selecione um tipo de widget",
      "widgetTitleRequired": "O título do widget é obrigatório"
    },
    "errors": {
      "failedCreateWidget": "Falha ao criar o widget",
      "failedUpdateWidget": "Falha ao atualizar o widget",
      "failedReorderWidgets": "Falha ao reordenar os widgets",
      "failedDeleteWidget": "Falha ao excluir o widget"
    },
    "deleteWidget": "Excluir widget",
    "confirmDeleteWidget": "Tem certeza que deseja excluir \"{{title}}\"?",
    "deleteWidgetModal": {
      "title": "Excluir widget",
      "description": "Tem certeza que deseja excluir \"{{title}}\"? Esta ação não pode ser desfeita.",
      "submit": "Excluir"
    },
    "columns": {
      "name": "Nome",
      "description": "Descrição",
      "widgets": "Widgets",
      "assigned_users": "Atribuído a",
      "last_updated": "Última atualização",
      "actions": "Ações"
    },
    "actions": {
      "edit": "Editar",
      "settings": "Configurações",
      "builder": "Editar widgets",
      "preview": "Visualização",
      "delete": "Excluir"
    },
    "deleteDashboardModal": {
      "title": "Excluir visualização personalizada",
      "description": "Tem certeza que deseja excluir \"{{name}}\"? Todos os widgets serão removidos permanentemente.",
      "submit": "Excluir"
    },
    "modal": {
      "title": "Criar nova visualização personalizada",
      "edit_title": "Editar configurações da visualização personalizada",
      "name_label": "Nome da visualização personalizada",
      "name_placeholder": "ex.: Visão de vendas, Visão do gerente",
      "description_label": "Descrição",
      "description_placeholder": "Breve descrição do que esta visualização personalizada mostra",
      "assign_to": "Atribuir visualização personalizada a",
      "users_label": "Usuários",
      "users_placeholder": "Selecione os usuários que podem ver esta visualização personalizada",
      "groups_label": "Grupos",
      "groups_placeholder": "Selecione os grupos que podem ver esta visualização personalizada",
      "is_home_default_label": "Definir como visualização personalizada inicial",
      "is_home_default_help": "Quando ativado, esta visualização personalizada substituirá a tela inicial do WhatsApp para os usuários atribuídos",
      "create_button": "Criar visualização personalizada",
      "errors": {
        "name_required": "O nome da visualização personalizada é obrigatório",
        "name_too_short": "O nome da visualização personalizada deve ter pelo menos 3 caracteres",
        "create_failed": "Falha ao criar a visualização personalizada. Tente novamente.",
        "update_failed": "Falha ao atualizar a visualização personalizada. Tente novamente."
      }
    }
  },
  "users_conversations_status": {
    "title": "Status de Conversas dos Usuários",
    "subtitle": "Status de conversas do WhatsApp em tempo real para cada usuário - mensagens não lidas, aguardando respostas e mensagens precisando de resposta.",
    "empty_state": "Nenhum dado disponível ainda. Os dados aparecerão quando os usuários com o recurso de rastreamento ativado usarem o aplicativo desktop.",
    "columns": {
      "user_name": "Nome do Usuário",
      "unread": "Não lidas",
      "awaiting_reply": "Aguardando Resposta",
      "need_reply": "Precisam de Resposta",
      "last_updated": "Última Atualização"
    }
  },
  "user_management": {
    "cols": {
      "avatar": "Avatar",
      "online_tooltip": "Usuário está online",
      "offline_tooltip": "Usuário está offline",
      "name": "Nome",
      "orgId": "ID da Organização",
      "orgName": "Nome da organização",
      "status": "Status",
      "paidLicences": "Licenças Pagas",
      "auto_sync_person": "Sincronização Automática (Pessoa)",
      "auto_sync_group": "Sincronização Automática (Grupo)",
      "sync_back_days": "Dias de sincronização retroativa",
      "active_tuvis": "Ativo no Tuvis",
      "groups": "Grupos",
      "last_login": "Último login",
      "last_login_platform": "Último login (Plataforma)",
      "last_login_desktop": "Último login (Desktop)",
      "terms_of_use_accepted": "Termos de Uso Aceitos",
      "terms_of_use_expired": "Expirado",
      "last_login_extension": "Último login (Extensão)",
      "last_login_mobile": "Último login (Móvel)",
      "last_login_tooltip": "Este mostra a última vez que o usuário iniciou sessão com sucesso ou foi atualizado durante a atualização automática - não quando foram ativos/online.",
      "desktop_version": "Versão do Desktop",
      "extension_version": "Versão da Extensão",
      "mobile_version": "Versão Móvel",
      "linked_identities": "Identidades vinculadas",
      "online_source": {
        "desktop": "Tuvis Desktop App",
        "extension": "Tuvis Extension",
        "tuvisBrowser": "Tuvis Browser",
        "unknown": "Unknown"
      }
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo",
      "disabled": "Desativado"
    },
    "sync_back_days_inherit": "Herdar da organização ({{days}} dias)",
    "sync_back_days_tooltip_user": "Configure quantos dias de mensagens históricas serão sincronizadas. Deixe vazio para herdar do nível da organização ou grupo.",
    "sync_back_days_tooltip_group": "Configure quantos dias de mensagens históricas serão sincronizadas. Deixe vazio para herdar do nível da organização.",
    "sync_back_days_helper_user": "Deixe vazio para herdar da organização ou grupo. Esta configuração controla quanto tempo atrás as mensagens são sincronizadas quando a sincronização automática está ativada.",
    "sync_back_days_helper_group": "Deixe vazio para herdar da organização. Esta configuração controla quanto tempo atrás as mensagens são sincronizadas quando a sincronização automática está ativada.",
    "reset_to_default": "Redefinir para o padrão",
    "invite_user_modal": {
      "new_org": "Nova Organização",
      "org_name": "Nome da Organização",
      "server_location": "Localização do Servidor",
      "org_language": "Idioma da Organização",
      "org_type": "Tipo de Organização",
      "available_crm": "CRM Disponível",
      "security_stack": "Stack de segurança",
      "security_stack_other": "Por favor especifique o nome do stack de segurança",
      "comment": "Comentário",
      "comment_placeholder": "Comentário opcional sobre esta organização..."
    },
    "merge": {
      "modal_title": "Mesclar usuários duplicados",
      "modal_body": "Escolha a conta a manter. As identidades de login e os sidecars das outras contas são movidos para ela e os duplicados são desativados. Mensagens e histórico não são movidos.",
      "primary_label": "Conta principal (mantida)",
      "duplicates_label": "Duplicados (desativados)",
      "mismatch_warning": "As contas selecionadas não compartilham o mesmo {{key}} - mescle apenas se tiver certeza de que são a mesma pessoa.",
      "confirm": "Mesclar",
      "cluster_progress": "Duplicado {{current}} de {{total}}",
      "skip": "Pular",
      "success": "Usuários mesclados",
      "failure": "Falha ao mesclar usuários",
      "view_duplicates": "Encontrar usuários duplicados",
      "searching_duplicates": "Procurando usuários duplicados...",
      "no_duplicates": "Nenhum usuário duplicado encontrado"
    },
    "merged_into": "Mesclado em {{label}}",
    "merged_cannot_activate": "Mesclado - não pode ser reativado"
  },
  "engagement": {
    "select": "Selecionar",
    "select_columns": "Selecionar colunas",
    "export_pdf": "Exportar PDF",
    "analytics_counters": "Contadores de análise",
    "email": "E-mail",
    "name": "Nome",
    "date": "Data",
    "sent_messages": "Mensagens enviadas",
    "received_messages": "Mensagens recebidas",
    "export": "Exportar",
    "title": "Conversas",
    "total_messages": "Total de mensagens",
    "total_messages_tooltip": "Quantidade total de mensagens processadas pelo Tuvis",
    "messages_over_time": "Mensagens trocadas ao longo do tempo",
    "messages_over_time_per_user": "Mensagens trocadas ao longo do tempo por usuário",
    "messages_over_time_chart_label": "Mensagens",
    "messages_over_time_tooltip": "Mensagens trocadas entre usuários ao longo do tempo",
    "direction": "Direção",
    "top_engaged": "Leads / Contatos / Contas pessoais mais engajadas",
    "files_exchanged": "Arquivos trocados",
    "files_exchanged_tooltip": "Arquivos trocados entre usuários",
    "engaged_by_type": "Tipo de engajamento",
    "unknown_engaged": "Pessoas desconhecidas",
    "leads": "Leads",
    "contacts": "Contatos",
    "person_accounts": "Contas pessoais",
    "accounts": "Contas comerciais",
    "engaged_people": "Pessoas engajadas",
    "sent": "Enviado",
    "received": "Recebido",
    "count": "Contagem",
    "response_time": "Tempo de Resposta (Mediana)",
    "file_types": {
      "image_one": "Uma Imagem",
      "image_other": "{{amount}} Imagens",
      "audio_one": "Um arquivo de áudio",
      "audio_other": "{{amount}} Arquivos de áudio",
      "video_one": "Um vídeo",
      "video_other": "{{amount}} Vídeos",
      "pdf_one": "Um arquivo PDF",
      "pdf_other": "{{amount}} Arquivos PDF",
      "spreadsheet_one": "Uma planilha de Excel",
      "spreadsheet_other": "{{amount}} Planilhas de Excel",
      "document_one": "Um documento",
      "document_other": "{{amount}} Documentos",
      "presentation_one": "Uma apresentação",
      "presentation_other": "{{amount}} Apresentações",
      "other_one": "Outro arquivo",
      "other_other": "{{amount}} Outros arquivos"
    },
    "minutes": "Minutos"
  },
  "revenue": {
    "title": "Analisador de interações",
    "top_engaging_users": "Usuários mais engajados",
    "top_engaging_groups": "Grupos de Usuários Mais Ativos",
    "record_created": "Registro criado",
    "activities": "Atividades",
    "leads": "Leads",
    "contacts": "Contatos",
    "tasks": "Tarefas",
    "cases": "Casos",
    "emails": "Emails",
    "events": "Eventos",
    "person_accounts": "Contas pessoais",
    "accounts": "Contas comerciais",
    "unknown_engagement": "Pessoas desconhecidas",
    "total_engaging_people": "Pessoas engajadas",
    "messages": "Mensagens",
    "others": "Outros",
    "minutes": "Minutos",
    "record_created_tooltip": "Novos registros criados através da Tuvis",
    "top_engaging_users_tooltip": "Usuários interagindo com pessoas por mensagens instantâneas",
    "top_engaging_groups_tooltip": "Exibindo os grupos de usuários mais ativos",
    "opportunities_analyzer": {
      "title": "Analisador de oportunidades",
      "account": "Conta",
      "opportunity": "Oportunidade",
      "stage": "Estágio",
      "amount": "Quantia",
      "users": "Usuários",
      "persons": "Pessoas",
      "messages": "Mensagens",
      "files": "Arquivos"
    },
    "break_down": "Detalhamento"
  },
  "adoption": {
    "title": "Adoção da Tuvis",
    "most_active_users": "Usuários mais ativos",
    "total_users": "Usuários totais",
    "adoption_over_time": "Adoção ao longo do tempo",
    "time_spent_on_engagement": "Tempo gasto no engajamento",
    "chat_now": "Converse agora",
    "use_template": "Templates usados",
    "currently_active": "Atualmente ativo",
    "active_users": "Usuários ativos",
    "actions_used": "Ações usadas",
    "most_active_users_tooltip": "Número total de vezes que a Tuvis foi usada proativamente pelos usuários",
    "adoption_over_time_tooltip": "O número total de usuários Tuvis em sua conta e uso por data.",
    "time_spent_on_engagement_tooltip": "Tempo gasto no WhatsApp vs. Salesforce. Com a Tuvis, suas equipes gastam menos tempo realizando tarefas repetitivas e manuais e mais tempo interagindo com os clientes pelo WhatsApp.",
    "chat_now_tooltip": "Quantas vezes os usuários clicaram no botão Conversar agora, no Salesforce ou na barra de pesquisa superior.",
    "use_template_tooltip": "Quantas vezes os usuários usaram modelos de mensagens dinâmicas",
    "time_spent_month": "Mês",
    "time_spent_active_users": "Usuários",
    "time_spent_active_users_usage": "Todos os usuários ativos",
    "time_spent_new_users_breakdown": "novos usuários",
    "time_spent_avrage": "Média",
    "time_spent_new_users": "usuários",
    "time_spent_month_avg": "Média mês",
    "time_spent_tooltip_header": "Tempo gasto no WhatsApp",
    "time_spent_tooltip_content": "Em média, desses {{users}} usuários, aproximadamente {{percent}}%do tempo deles foi gasto usando o WhatsApp.",
    "actions": {
      "show_more": "Exibir mais",
      "show_less": "Exibir menos",
      "chat_now": "Converse agora",
      "use-template": "Templates usados",
      "create-activity-task-case": "Criar Atividade/Tarefa/Caso",
      "create-task": "Criar Atividade Tarefa",
      "create-lead-contact": "Criar Lead/Contato",
      "create-activity": "Criar Atividade",
      "create-contact": "Criar Contato",
      "create-lead": "Criar Lead",
      "create-case": "Criar Caso",
      "create-custom-object": "Criar Custom object",
      "view-in-crm": "Ver no CRM",
      "add_to_phone": "Adicionar ao telefone",
      "schedule-event": "Agendar",
      "send-email": "Send Email",
      "add-mobile-contact": "Adicionar aos Contatos do Celular",
      "call-contact": "Telefone",
      "start_meeting": "Começar Evento",
      "find-on-linkedin": "Procurar no LinkedIn",
      "find-on-facebook": "Procurar no Facebook",
      "find-on-google": "Pesquisar no Google",
      "chat-on-messenger": "Converse no Messenger",
      "chat-on-messanger": "Converse no Messenger"
    }
  },
  "sidecars": {
    "disconnections_over_time": {
      "title": "Usuários desconectados ao longo do tempo",
      "date": "Data",
      "channel": "Canal",
      "unique_users": "Usuários desconectados",
      "events": "Eventos de desconexão"
    },
    "email": "Email",
    "no_sidecars_desc": "Atualmente, você não possui nenhum dispositivo, mas este é o momento ideal para criar o seu primeiro.",
    "manual": "Inserir manualmente",
    "upload_csv": "Carregar CSV",
    "scan_qr": "<0>Não</0> escaneie o código QR com o app de câmera, <1>escaneie através do {{channelName}}</1>",
    "scan_qr_instructions": {
      "whatsapp": {
        "android": "<0>Para escanear:</0> Abra o WhatsApp → Menu de três pontos → Aparelhos conectados → Conectar dispositivos",
        "ios": "<0>Para escanear:</0> Abra o WhatsApp → Configurações → Aparelhos conectados → Conectar dispositivo"
      },
      "telegram": "<0>Para escanear:</0> Abra o Telegram → Configurações → Dispositivos → Vincular dispositivo → Escanear código QR",
      "line": "<0>Para escanear:</0> Abra o LINE → Configurações → Dispositivos → Escanear código QR",
      "signal": "<0>Para escanear:</0> Abra o Signal → Configurações → Aparelhos conectados → Escanear código QR"
    },
    "pairing_timeout": "O tempo limite do QRCode foi atingido ou ocorreu uma falha durante o emparelhamento.",
    "pairing_phone_mismatch": "O número do WhatsApp que você tentou conectar não está registrado no seu dispositivo.",
    "pairing_error_generic": "Algo deu errado durante o emparelhamento. Tente novamente mais tarde.",
    "pairing_error_title": "Conexão falhou",
    "what_to_do_now": "O que fazer agora?",
    "generate_new_qr_code": "Gerar novo QR Code",
    "pairing_timeout_step_1_title": "Verifique a versão do WhatsApp",
    "pairing_timeout_step_1_body": "Acesse a loja de aplicativos do seu celular e verifique se há atualizações disponíveis para o WhatsApp. Se houver, atualize o aplicativo.",
    "pairing_timeout_step_2_title": "Remova dispositivos desconectados",
    "pairing_timeout_step_2_body": "Antes de tentar conectar novamente, exclua todas as conexões antigas no menu \"Dispositivos Desconectados\" do WhatsApp.",
    "pairing_timeout_step_3_title": "Teste o backup do WhatsApp",
    "pairing_timeout_step_3_body": "Verifique se você consegue realizar um backup. Se não conseguir por falta de espaço, isso pode ser a causa da desconexão. Libere espaço de armazenamento antes de tentar novamente.",
    "pairing_phone_mismatch_step_1_title": "Verifique o convite:",
    "pairing_phone_mismatch_step_1_body": "O e-mail que você recebeu para parear o dispositivo mostra o número de WhatsApp esperado.",
    "pairing_phone_mismatch_step_2_title": "Corrija seu cadastro:",
    "pairing_phone_mismatch_step_2_body": "Se o número do convite estiver incorreto, entre em contato com o administrador do Tuvis da sua empresa para atualizá-lo.",
    "invite_user": "Convidar usuário",
    "invite_phone": "Número de telefone esperado",
    "user_inactive_cannot_add": "Não é possível adicionar o Remote Sync. Este usuário está inativo no momento.",
    "should_notify": "Notifique-me quando o aparelho estiver emparelhado ou desconectado",
    "auto_reinvite": "Reconvite automático ao desconectar-se",
    "periodic_reinvite": "Reconvite automático diário até emparelhar",
    "sidecar_created": "Um novo dispositivo foi criado",
    "invitation_sent": "Convite enviado",
    "share_invite_link": "Compartilhar link de convite:",
    "next": "Próximo",
    "invite": "Criar",
    "pair": "Conectar-se com a Tuvis",
    "pair_description_1": "Você foi convidado a vincular sua conta de {{channelName}} com a Tuvis",
    "pair_description_2": "clique no botão abaixo para iniciar o processo de conexão",
    "pair_button": "Conecte-se com a Tuvis",
    "pairing_success": "Conexão realizada com sucesso",
    "pairing_success_description_1": "Sua conta de {{channelName}} agora está conectada com a Tuvis.",
    "pairing_success_description_2": "Agora você pode utilizar a Tuvis para engajar com seus clientes através do {{channelName}}",
    "pairing_boot_sentences_length": "7",
    "pairing_boot_sentences_0": "A Tuvis está iniciando um QR code na nuvem para você",
    "pairing_boot_sentences_1": "Configurar o seu QR code pode levar alguns minutos",
    "pairing_boot_sentences_2": "Por favor, aguarde. O QR code está sendo criado",
    "pairing_boot_sentences_3": "Assim que o QR code estiver pronto, você poderá vincular sua conta do {{channelName}} à Tuvis",
    "pairing_boot_sentences_4": "Ah, isso está demorando mais do que o esperado.",
    "pairing_boot_sentences_5": "Estamos quase lá, apenas mais alguns segundos",
    "pairing_boot_sentences_6": "Pedimos desculpas pelo atraso. Estamos trabalhando para colocá-lo em funcionamento.",
    "pairing_boot_sentences_connect_phone_number_0": "O Tuvis está configurando uma conexão na nuvem para você…",
    "pairing_boot_sentences_connect_phone_number_1": "A configuração da sua conexão pode levar alguns minutos…",
    "pairing_boot_sentences_connect_phone_number_2": "Por favor, aguarde enquanto sua conexão está sendo criada…",
    "pairing_boot_sentences_connect_phone_number_3": "Assim que a conexão estiver pronta, você poderá parear sua conta {{channelName}} com o Tuvis…",
    "pairing_boot_sentences_connect_phone_number_4": "Oh, isso está demorando mais do que o esperado.",
    "pairing_boot_sentences_connect_phone_number_5": "Estamos quase lá, só mais alguns segundos",
    "pairing_boot_sentences_connect_phone_number_6": "Pedimos desculpas pelo atraso. Estamos trabalhando arduamente para que você comece a usar",
    "link_is_invalid": "Esse link não é mais válido.",
    "contact_admin": "Contate seu administrador para assistência.",
    "create_sidecar": "Adicionar dispositivo",
    "phone": "Telefone",
    "user": "Usuário",
    "manager": "Gerente",
    "paired_devices": "Aparelhos conectados",
    "runner": "Executor",
    "runnerChannel": "Canal",
    "counters": {
      "total": "Usuários do Remote Sync",
      "connected": "Conectados",
      "disconnected": "Desconectados",
      "new": "Convites pendentes",
      "licenses": "Máximo de dispositivos"
    },
    "statuses": {
      "invited": "Convidado",
      "booting": "Iniciando",
      "running": "Sincronizando agora",
      "idle": "Sincronização pendente",
      "pairing": "Conectando-se",
      "error": "Erro",
      "not_paired": "Desconectado",
      "connected": "Conectado",
      "new": "Novo",
      "disconnected_by_user": "Desconectado pelo usuário"
    },
    "status": "Status",
    "created_at": "Criado em",
    "last_update": "Última atualização",
    "start_sidecar": "Conectar dispositivo",
    "debug_sidecar": "Ajustar dispositivo",
    "clear_query_cache": "Limpar Cache de Consulta",
    "reload_sidecars": "Recarregar dispositivos",
    "filter_sidecars": "Filtrar dispositivos",
    "sidecar_messages": "Mensagens do dispositivo",
    "send_invitation": "Enviar convite",
    "sidecar_settings": "Configurações do dispositivo",
    "delete_sidecar": "Deletar dispositivo",
    "delete_sidecar_modal_message": "Tem a certeza de que deseja apagar este dispositivo?",
    "pair_sidecar": "Vincular dispositivo",
    "frequency": "Frequência",
    "log": "Registro",
    "alt_login": {
      "invalid_code": "Código inválido",
      "verify_phone_code": "Verificar",
      "send_login_code": "Enviamos o código para o aplicativo {{channelName}} no seu outro dispositivo.",
      "link_phone": "Vincular telefone do {{channelName}}",
      "link_with_qr": "Ligar com código QR",
      "link_with_phone": "Conecte com seu número de {{channelName}}",
      "get_code": "Obter código",
      "edit_phone": "Editar telefone",
      "enter_phone_number": "Digite o número de telefone com o código do país",
      "enter_code": "Digite o código no telefone"
    },
    "pairing_steps": {
      "first": "1. Abra o WhatsApp no seu telefone.",
      "second": {
        "on_android": "2. No Android, toque no Menu",
        "on_iphone": "ou, no iPhone, toque em Configurações"
      },
      "third": "3. Selecione \"Dispositivos vinculados\" e depois \"Vincular um dispositivo\".",
      "fourth": "4. Clique em \"Conectar com número de telefone\".",
      "fifth": "5. Alguns dispositivos podem necessitar a digitação manual do código"
    },
    "addSidecar": "Atribuir dispositivo remoto",
    "maxSidecarsReached": "Você atingiu o máximo número de dispositivos remotos",
    "disconnected_at": "Desconectado em",
    "send_invites": "Enviar Convites",
    "sidecars": "Dispositivos",
    "bulk_reinvite": {
      "success": "Convites enviados com sucesso para {{count}} dispositivos",
      "partial_failure": "Falha ao enviar convites para {{count}} dispositivos",
      "failed": "Falha ao enviar convites em massa"
    },
    "bulk_delete": {
      "action_label": "Deletar Selecionados",
      "confirm_title": "Deletar Dispositivos",
      "confirm_message": "Tem certeza de que deseja deletar {{count}} dispositivo(s)? Esta ação não pode ser desfeita.",
      "progress": "Deletando {{current}} de {{total}}...",
      "success": "{{count}} dispositivo(s) deletado(s) com sucesso",
      "partial_success": "{{successCount}} dispositivo(s) deletado(s). Falha ao deletar {{failCount}} dispositivo(s).",
      "failed": "Falha ao deletar dispositivos"
    },
    "scan_qr_auth_code": "Digite este código no aplicativo {{channelName}} para conectar com a Tuvis"
  },
  "filters": {
    "timeComparisonDays": "dos últimos {{count}} dias",
    "timeComparisonMonths": "dos últimos {{count}} meses",
    "filters": "Filtros",
    "last_month": "Filtros último mês",
    "last_60_days": "Filtros últimos 60 dias",
    "last_90_days": "Filtros últimos 90 dias",
    "last_year": "Filtros últimos ano",
    "users": "Usuários",
    "assignee": "Responsável",
    "created_by": "Criado por",
    "no_assignee": "Sem responsável",
    "groups": "Grupos",
    "phones": "Telefones do Usuário",
    "error_no_phones": "Nenhum telefone encontrado",
    "reset_filters": "Redefinir filtros",
    "apply_filters": "Aplicar filtros",
    "clear_all": "Limpar filtros",
    "filter_analytics": "Filtrar dados",
    "search": "Buscar",
    "search_no_results_title": "Não encontramos nada",
    "search_no_results_description": "Tente palavras-chave diferentes ou verifique se tudo está escrito corretamente.",
    "error_no_users": "Usuários não encontrados",
    "error_no_users_description": "Por favor, tente novamente mais tarde",
    "show": "Mostrar",
    "top": "Filtros top",
    "filter_audit_logs": "filtros registros de auditoría",
    "sent_or_received_by": "Enviado ou recebido por",
    "severity": "Gravidade",
    "policy": "Política",
    "table": "Filtrar Tabela"
  },
  "edit_columns": {
    "edit_columns": "Editar colunas",
    "select_all": "Selecionar tudo",
    "deselect_all": "Desmarcar tudo",
    "search_columns": "Pesquisar colunas",
    "reset_to_default": "Redefinir para o padrão",
    "no_columns_found": "Nenhuma coluna encontrada",
    "selected": "Selecionado",
    "select": "Selecionar"
  },
  "footer": {
    "rights_reserved": "© 2026 Tuvis Todos os direitos reservados.",
    "privacy_policy": "Política de Privacidade",
    "terms_conditions": "Termos e Condições"
  },
  "search_orgs": {
    "invite_to_platform": "Criar nova organização",
    "search_orgs": "Buscar organizações",
    "change_organization_name": "Alterar o nome da organização",
    "would_you_like_to_change_organization_name": "Deseja alterar o nome da organização?",
    "edit_organization_identity_section": "Identidade da organização",
    "organization_name": "Nome da organização",
    "change": "Alterar",
    "cancel": "Cancelar",
    "organization_name_updated": "Nome da organização atualizado",
    "failed_to_update_organization_name": "Falha ao atualizar o nome da organização",
    "organization_description": "Descrição da organização",
    "organization_description_updated": "Descrição da organização atualizada",
    "failed_to_update_organization_description": "Falha ao atualizar a descrição da organização"
  },
  "chat_groups": {
    "title": "Chats de grupos"
  },
  "users_page": {
    "user_not_found": "Usuário não encontrado",
    "title": "Usuários",
    "add_phone": "Adicionar Telefone",
    "actions": {
      "name": "Usuários",
      "resend_invite": "Reenviar convite",
      "enable_desktop": "Ativar WhatsApp (Aplicativo desktop Tuvis)",
      "disable_desktop": "Desativar WhatsApp (Aplicativo desktop Tuvis)",
      "disable": "Desativar usuário",
      "reactive": "Reativar usuário",
      "sidecar_settings": "Alterar configurações do dispositivo",
      "merge_users": "Mesclar usuários"
    },
    "toasts": {
      "invite_failed_user_exists": "O endereço de e-mail já existe; reenvie o convite"
    }
  },
  "notifications_settings_page": {
    "title": "Notificações"
  },
  "super_admin_page": {
    "title": "Super Admin",
    "subHeader": "Manage Organization Settings",
    "saved_successfully": "Organization settings were successfully saved",
    "saved_failed": "Organization settings failed to save"
  },
  "whatsapp_business_api_agent_page": {
    "title": "Agente",
    "react": "Reagir",
    "reply": "Responder"
  },
  "channels": {
    "title": "Sincronização Remota",
    "all_remote_devices": "Todos os Dispositivos Remotos",
    "enable": "Ativar",
    "disable": "Desativar",
    "confirm_disable_modal_text": "Tem certeza de que deseja desativar o canal do {{channel}}?",
    "confirm_enable_modal_text": "Tem certeza de que deseja ativar o canal do {{channel}}?",
    "confirm_button": "Confirmar",
    "desktop": "WhatsApp (App desktop Tuvis)",
    "tuvis_desktop_app": "Tuvis Desktop App",
    "whatsapp": "WhatsApp",
    "mobile_call_recording": "Gravação de chamadas móveis",
    "imessage": "iMessage",
    "telegram": "Telegram",
    "unavailable": {
      "title": "Canal indisponível",
      "message": "{{channel}} não está incluído no seu plano atual. Entre em contato com a nossa equipe de Vendas para ativá-lo."
    },
    "analytics": {
      "device_connected_rate": "Taxa de dispositivos conectados",
      "device_connected_rate_tooltip": "Percentual de dispositivos de Remote Sync convidados e conectados no momento.",
      "device_connected_rate_subtext": "{{connected}} / {{total}} dispositivos",
      "average_time_to_pair": "Tempo médio para emparelhar",
      "average_time_to_pair_tooltip": "Média de horas desde o último convite até o primeiro emparelhamento bem-sucedido. Com base em dispositivos emparelhados no intervalo de datas selecionado.",
      "average_time_to_pair_value": "{{hours}} hrs",
      "average_time_to_pair_subtext": "{{count}} dispositivos emparelhados"
    }
  },
  "twilio_settings_page": {
    "title": "Gravação de Chamadas Tuvis",
    "add_account": "Adicionar conta",
    "add_phone": "Comprar número de telefone",
    "reload": "Recarregar",
    "connect_button": "Conectar",
    "need_to_connect": "Para melhorar sua experiência e desbloquear recursos avançados, você precisa se conectar à Gravação de Chamadas Tuvis",
    "empty_state_no_phones_text": "Nenhum número de telefone foi adicionado ainda.",
    "no_address_error_message": "Para o país selecionado, você deve ter um endereço para concluir esta compra",
    "close_account": "Fechar conta",
    "create_account_loading": "Criando conta...",
    "create_account_error": "Falha ao criar conta",
    "close_account_loading": "Fechando conta...",
    "close_account_error": "Falha ao fechar conta",
    "close_account_modal": {
      "title": "Fechar conta",
      "description": "Tem certeza de que deseja fechar esta conta?",
      "may_result_1": "Fechar a conta a removerá da conta de Gravação de Chamadas Tuvis.",
      "may_result_2": "- A gravação de chamadas Tuvis liberará todos os números de telefone na subconta.",
      "may_result_3": "- A conta de gravação de chamadas Tuvis não poderá fazer e receber chamadas telefônicas ou enviar e receber mensagens SMS",
      "may_result_4": "- A conta de gravação de chamadas Tuvis não poderá ser aberta novamente",
      "may_result_5": "- A gravação de chamadas Tuvis excluirá todos os dados 30 dias após o fechamento"
    },
    "tabs": {
      "phones": "TELEFONES",
      "settings": "CONFIGURAÇÃO"
    },
    "cols": {
      "account_sid": "SID DA CONTA",
      "api_sid": "SID DA API",
      "api_secret": "SEGREDO DA API",
      "auth_token": "TOKEN DE AUTENTICAÇÃO",
      "sms": "SMS",
      "voice": "Voz",
      "capabilities": "Capacidades",
      "name": "Nombre",
      "status": "Estado",
      "phone": "Teléfono",
      "accountName": "Nombre de la cuenta",
      "accountSid": "SID de la cuenta",
      "type": "Tipo",
      "price": "Precio"
    },
    "status": {
      "connected": "Conectado",
      "pending_connection": "Conexión pendiente"
    },
    "actions_phone_table": {
      "assign_users": "Asignar usuarios",
      "rename_phone": "Renombrar teléfono",
      "connect_phone": "Conectar teléfono",
      "assign_phone": "Atribuir telefone",
      "release_phone": "Liberar teléfono"
    },
    "purchase_phone": {
      "country": "País:",
      "account": "Cuenta:",
      "purchase": "Comprar",
      "confirm_purchase": "¿Estás seguro?",
      "confirm_purchase_body": "¿Estás seguro de que quieres comprar un nuevo número de teléfono?",
      "phone_purchased_successfully": "Número de teléfono comprado exitosamente",
      "phone_purchased_failed": "Error al comprar número de teléfono: {{error}}",
      "confirm_release": "¿Estás seguro?",
      "confirm_release_body": "¿Estás seguro de que quieres liberar este número de teléfono? El número de teléfono se liberará de tu cuenta de Twilio y ya no estará disponible para su uso. Esta acción no se puede deshacer sin la ayuda del soporte de Twilio."
    },
    "connect_to_tuvis_call_recording_modal": {
      "title": "Conectar ao Tuvis Call Recording",
      "description": "Entre em contato com o seu gerente de conta da Tuvis para conectar ao Tuvis Call Recording"
    }
  },
  "slack_settings_page": {
    "title": "Integração de Slack de Tuvis",
    "fleet": {
      "title": "Aplicações de Slack adicionais",
      "description": "Instale aplicações de trabalho de Tuvis adicionais para aumentar a capacidade de mensagens de Slack. Cada aplicação adiciona seu próprio limite de taxa.",
      "install": "Instalar",
      "uninstall": "Desinstalar",
      "installed": "Instalada"
    },
    "need_to_connect": "Instale a aplicação de Slack de Tuvis para começar. Clique no botão abaixo para instalar a aplicação e conectar seu espaço de trabalho de Slack para uma mensagem instantânea sem problemas.",
    "connect_button": "Instalar Aplicação de Slack",
    "disconnect_button": "Desinstalar Aplicação de Slack",
    "configure_shortcuts_button": "Configurar Atalhos",
    "connecting": "Instalando...",
    "connection_failed": "Erro ao instalar a aplicação de Slack",
    "connected_success": "Aplicação de Slack instalada com sucesso",
    "popup_blocked": "Popup bloqueado por o navegador",
    "oauth_cancelled": "OAuth cancelado por o usuário",
    "installed": {
      "title": "A aplicação de Slack de Tuvis está instalada em {{workspaceName}} ({{workspaceId}})",
      "description": "Agora você pode começar a conversar com seu espaço de trabalho de Slack."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Por favor, note:",
      "description": "Você precisa configurar o gatilho de atalho de modelo."
    },
    "configure_shortcut_modal": {
      "title": "Configurar Atalho de Modelo do WhatsApp",
      "shortcut_url_label": "URL do Atalho do Slack",
      "invalid_url": "Formato de URL inválido. Formato esperado: https://slack.com/shortcuts/{ID}/{KEY}",
      "save": "Salvar Configuração",
      "success": "Atalho configurado com sucesso",
      "error": "Erro ao configurar atalho"
    },
    "uninstall_modal": {
      "title": "Desinstalar Aplicação de Slack de Tuvis",
      "description": "Tem certeza de que deseja desinstalar a aplicação de Slack de Tuvis?",
      "description_with_workspace": "Tem certeza de que deseja desinstalar a aplicação de Slack de Tuvis de {{workspaceName}}?",
      "warning": "Esta ação não pode ser desfeita. Todas as configurações de integração do Slack serão removidas.",
      "confirm": "Desinstalar Aplicação",
      "cancel": "Cancelar",
      "success": "Aplicação de Slack desinstalada com sucesso",
      "error": "Erro ao desinstalar aplicação de Slack"
    },
    "workflow_api_key": {
      "title": "Chave de API do fluxo de trabalho",
      "description": "Use esta chave para configurar o aplicativo Tuvis Slack Workflow. Mantenha-a segura e não a compartilhe publicamente."
    }
  },
  "teams_settings_page": {
    "title": "Integração de Teams de Tuvis",
    "need_to_connect": "Instale a aplicação de Teams de Tuvis para começar. Clique no botão abaixo para instalar a aplicação e conectar seu espaço de trabalho de Teams para uma mensagem instantânea sem problemas.",
    "connect_button": "Conectar Teams",
    "disconnect_button": "Desinstalar Aplicação de Teams",
    "configure_shortcuts_button": "Configurar Atalhos",
    "connecting": "Conectando...",
    "connection_failed": "Erro ao conectar a aplicação de Teams",
    "connected_success": "Aplicação de Teams conectada com sucesso",
    "popup_blocked": "Popup bloqueado pelo navegador",
    "oauth_cancelled": "OAuth cancelado pelo usuário",
    "certificate_auth_description": "Conecte seu tenant do Microsoft Teams usando autenticação baseada em certificado para comunicação segura entre servidores.",
    "step1_certificate": "Passo 1: Baixar Certificado",
    "step1_description": "Baixe um certificado que será usado para autenticar com o Microsoft Azure. Faça upload no registro do seu aplicativo Azure.",
    "download_certificate": "Baixar Certificado",
    "download_certificate_failed": "Erro ao baixar o certificado",
    "step2_azure_config": "Passo 2: Configuração do Azure",
    "step2_description": "Insira os detalhes do registro do seu aplicativo Azure. Você pode encontrá-los no Portal do Azure em Registros de aplicativo.",
    "client_id": "ID do Aplicativo (Cliente)",
    "client_id_placeholder": "Insira seu ID do Aplicativo (Cliente) do Azure",
    "tenant_id": "ID do Diretório (Tenant)",
    "tenant_id_placeholder": "Insira seu ID do Diretório (Tenant) do Azure",
    "dummy_user_id": "ID da Conta de Serviço",
    "dummy_user_id_placeholder": "Insira o ID do objeto do Azure AD da conta de serviço",
    "certificate_required": "Por favor, gere um certificado primeiro",
    "test_connection_failed": "Erro ao testar a conexão com o Azure",
    "installed": {
      "title": "A aplicação de Teams de Tuvis está instalada em {{workspaceName}} ({{workspaceId}})",
      "description": "Agora você pode começar a conversar com seu espaço de trabalho de Teams."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Por favor, note:",
      "description": "Você precisa configurar o gatilho de atalho de modelo."
    },
    "configure_shortcut_modal": {
      "title": "Configurar Atalho de Modelo do WhatsApp",
      "guide_title": "Como Obter a URL do Seu Atalho:",
      "step_1": "No menu lateral esquerdo, clique em \"Mais\" e depois em \"Ferramentas\". Dentro de ferramentas, escolha \"Fluxos de trabalho\", clique no botão \"Novo\" à direita e escolha \"Criar fluxo de trabalho\"",
      "step_2": "Você será redirecionado para a nova página de fluxo de trabalho. Clique em \"Escolher um evento\", escolha \"A partir de um link no Teams\" e finalmente clique em \"Continuar\"",
      "step_3": "Clique em \"Adicionar etapas\". Na caixa de diálogo aberta, use o campo \"Pesquisar etapas\" no canto superior esquerdo e pesquise por \"Send Template\" da Tuvis. Em seguida, no campo \"ID do canal\" escolha a primeira opção: \"Canal onde o fluxo de trabalho foi usado\" e clique em \"Salvar\"",
      "step_4": "Clique no botão \"Finalizar\" no canto superior direito da página. Você será solicitado a definir um nome para o fluxo de trabalho - recomendamos definir \"Modelos do Whatsapp\" como nome. Depois de fazer isso, clique no botão \"Publicar\"",
      "step_5": "Ótimo! Tudo o que você precisa fazer agora é copiar o link \"Começa a partir de um link no Teams\" exibido no modal e colá-lo aqui abaixo",
      "shortcut_url_label": "URL do Atalho do Teams",
      "invalid_url": "Formato de URL inválido. Formato esperado: https://teams.com/shortcuts/{ID}/{KEY}",
      "save": "Salvar Configuração",
      "success": "Atalho configurado com sucesso",
      "error": "Erro ao configurar o atalho"
    },
    "uninstall_modal": {
      "title": "Desinstalar Aplicação de Teams de Tuvis",
      "description": "Tem certeza de que deseja desinstalar a aplicação de Teams de Tuvis?",
      "description_with_workspace": "Tem certeza de que deseja desinstalar a aplicação de Teams de Tuvis de {{workspaceName}}?",
      "warning": "Esta ação não pode ser desfeita. Todas as configurações de integração do Teams serão removidas.",
      "confirm": "Desinstalar Aplicação",
      "cancel": "Cancelar",
      "success": "Aplicação de Teams desinstalada com sucesso",
      "error": "Erro ao desinstalar aplicação de Teams"
    }
  },
  "archive_discord_settings_page": {
    "title": "Arquivar mensagens do Discord",
    "description": "Conecte seu aplicativo do Discord para arquivar mensagens de servidores e canais via eventos do bot do Discord.",
    "connect_button": "Ativar arquivamento",
    "disconnect_button": "Desativar arquivamento",
    "select_servers_button": "Selecionar servidores para arquivar",
    "add_server_button": "Adicionar servidor",
    "connecting": "Conectando...",
    "connection_failed": "Falha ao ativar o arquivamento do Discord",
    "connected_success": "Arquivamento do Discord ativado com sucesso",
    "step1_discord_config": "Passo 1: Configuração do bot do Discord",
    "step1_description": "Informe o application id e o token do bot do Discord. Garanta que o bot esteja instalado no servidor com permissões para ler mensagens e com o intent MESSAGE CONTENT habilitado.",
    "application_id": "ID da aplicação",
    "application_id_placeholder": "Informe o ID da aplicação do Discord",
    "bot_token": "Token do bot",
    "bot_token_placeholder": "Informe o token do bot do Discord",
    "installed": {
      "title": "Arquivamento do Discord está ativo",
      "description": "Suas mensagens do Discord estão sendo arquivadas em tempo real."
    },
    "uninstall_modal": {
      "title": "Desativar arquivamento do Discord",
      "description": "Tem certeza de que deseja desativar o arquivamento de mensagens do Discord? Isso interromperá a captura de novas mensagens.",
      "warning": "As mensagens já arquivadas serão preservadas, mas nenhuma nova mensagem será capturada.",
      "confirm": "Desativar arquivamento",
      "cancel": "Cancelar",
      "success": "Arquivamento do Discord desativado com sucesso",
      "error": "Falha ao desativar o arquivamento do Discord"
    }
  },
  "elite_token_page": {
    "title": "Token de Segurança Elite",
    "disclaimer": "Este token é um dado de segurança sensível. Uma vez gerado, você é o único responsável por armazená-lo e gerenciá-lo com segurança. A Tuvis não retém uma cópia deste token.",
    "token_label": "Token de Segurança",
    "token_subtitle": "Uma credencial por organização. Você pode rotacioná-la quando quiser.",
    "status_active": "Ativo",
    "status_not_set": "Não definido",
    "user_agent_header_description": "Inclua o token de segurança no cabeçalho do user-agent enviado pelos apps cliente da Tuvis para que sua stack de segurança possa identificar o tráfego autorizado.",
    "no_token_placeholder": "Nenhum token gerado ainda",
    "generate_button": "Gerar Token",
    "show": "Mostrar token",
    "hide": "Ocultar token",
    "copy": "Copiar token",
    "user_agent_header": "Adicionar token elite ao agente de usuário",
    "generate_error": "Falha ao gerar token",
    "update_error": "Falha ao atualizar a configuração",
    "save_button": "Salvar token",
    "save_success": "Token salvo com sucesso",
    "save_error": "Falha ao salvar o token",
    "generate_confirm_title": "Aviso: Ação Crítica",
    "generate_confirm_body": "Gerar um novo token de segurança invalidará imediatamente o atual. Isso interromperá a conexão da aplicação com o seu servidor até que você atualize o novo token na sua pilha de segurança. Tem certeza de que deseja continuar?",
    "generate_confirm_ok": "Confirmar e Gerar",
    "generate_confirm_cancel": "Cancelar",
    "save_confirm_title": "Aviso: Ação Crítica",
    "save_confirm_body": "Salvar este token substituirá imediatamente o atual. Isso interromperá a conexão da aplicação com o seu servidor até que você atualize a sua pilha de segurança com o novo token. Tem certeza de que deseja continuar?",
    "save_confirm_ok": "Confirmar e Salvar",
    "save_confirm_cancel": "Cancelar"
  },
  "api_docs_settings_page": {
    "title": "Documentação da API"
  },
  "api_keys_settings_page": {
    "title": "Chaves API",
    "reload": "Recarregar",
    "revoke": "Revogar",
    "close": "Fechar",
    "never_access": "Nunca Acessado",
    "create_api_key_desc": "Certifique-se de copiar seu novo segredo de API agora. Você não poderá ver este segredo de API novamente",
    "add_api_key": "Adicionar Chave API",
    "api_key": "Chave API",
    "base_url": "Base Url",
    "api_key_name": "Nome da Chave API",
    "api_secret": "Segredo da API",
    "scopes": "Escopos",
    "name": "Nome",
    "cols": {
      "name": "NOME",
      "api_key": "CHAVE API",
      "last_accessed": "Último Acesso",
      "type": "TIPO",
      "identifier": "ID"
    },
    "oauth_clients_title": "Clientes OAuth",
    "oauth_client_id": "ID do Cliente",
    "oauth_client_secret": "Segredo do Cliente",
    "oauth_auth_method": "Método de Autenticação",
    "oauth_clients_cert_registered": "Seu certificado de cliente TLS foi registrado com sucesso.",
    "drop_client_cert": "Solte seu certificado .pem aqui ou clique para carregar",
    "create_credential": "Criar credencial",
    "add_credential": "Adicionar",
    "view_docs": "Documentação da API",
    "credential_type": "Tipo",
    "type_api_key": "API Key",
    "type_oauth_client": "Cliente OAuth",
    "auth_method_client_secret": "Segredo do cliente",
    "auth_method_tls": "Certificado de cliente (mTLS)",
    "edit_scopes": "Editar escopos",
    "all_scopes": "Todos",
    "revoke_confirm_title": "Revogar credencial",
    "revoke_confirm_body": "Isso revoga a credencial permanentemente e qualquer aplicação que a utilize deixará de funcionar. Esta ação não pode ser desfeita."
  },
  "add_oauth_client": "Adicionar Cliente OAuth",
  "phone_blocklist_settings_page": {
    "title": "Números de telefone privados",
    "search": "Buscar números de telefone",
    "add_phones_modal": {
      "trigger": "Adicionar números de telefone",
      "title": "Adicionar números à lista de telefones privados",
      "description": "Use a área de texto para adicionar números à lista de telefones privados. Você pode adicionar vários números separando por linhas.",
      "placeholder": "Insira números de telefone separados por linha",
      "submit": "Adicionar"
    },
    "cols": {
      "phone": "Número de Telefone"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de telefone",
      "description": "Escolha um arquivo CSV com uma coluna \"Phone\" para importar números de telefone privados.",
      "confirm": "{{fileName}} foi processado. Encontramos {{count}} números. Deseja adicioná-los à lista de telefones privados?",
      "submit": "Importar",
      "loading_message": "Importando números de telefone...",
      "success_message": "{{count}} números importados com sucesso",
      "failed_message": "Falha ao importar números"
    },
    "delete_phone_modal": {
      "trigger": "Excluir Telefone",
      "title": "Excluir telefone da lista de telefones privados",
      "description": "Tem certeza que deseja excluir este telefone da lista de telefones privados?",
      "description_multiple": "Tem certeza que deseja excluir {{count}} telefones da lista de telefones privados?",
      "submit": "Excluir",
      "loading_message": "Excluindo telefone da lista de telefones privados...",
      "success_message": "Telefone excluído com sucesso",
      "failed_message": "Falha ao excluir telefone"
    }
  },
  "blocked_phones_settings_page": {
    "title": "Números de telefone bloqueados",
    "search": "Pesquisar números de telefone",
    "add_phones_modal": {
      "trigger": "Adicionar números",
      "title": "Adicionar números à lista de bloqueados",
      "description": "Use a área de texto abaixo para adicionar números a bloquear. Adicione vários separando-os por uma nova linha.",
      "placeholder": "Insira números separados por nova linha",
      "submit": "Adicionar"
    },
    "cols": {
      "phone": "Número de telefone"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de telefone",
      "description": "Escolha um arquivo CSV para importar números bloqueados. Garanta que o CSV tenha apenas uma coluna \"Phone\".",
      "confirm": "{{fileName}} foi processado com sucesso. Encontramos {{count}} números. Deseja adicioná-los à lista de bloqueados?",
      "submit": "Importar",
      "loading_message": "Importando números de telefone...",
      "success_message": "{{count}} números importados com sucesso",
      "failed_message": "Falha ao importar números"
    },
    "delete_phone_modal": {
      "trigger": "Excluir telefone",
      "title": "Excluir telefone da lista de bloqueados",
      "description": "Tem certeza de que deseja excluir este telefone da lista de bloqueados?",
      "description_multiple": "Tem certeza de que deseja excluir {{count}} telefones da lista de bloqueados?",
      "submit": "Excluir",
      "loading_message": "Excluindo telefone da lista de bloqueados...",
      "success_message": "Telefone excluído com sucesso",
      "failed_message": "Falha ao excluir o telefone"
    }
  },
  "fraud_detection_page": {
    "title": "Detecção de Fraude",
    "description": "Gerenciar listas de bloqueio de hashes de arquivos maliciosos e URLs para proteção contra ameaças conhecidas",
    "search": "Buscar",
    "tabs": {
      "hashes": "Hashes de Arquivos",
      "urls": "URLs Bloqueadas",
      "incidents": "Incidentes"
    },
    "add_hash_modal": {
      "trigger": "Adicionar Hash",
      "title": "Adicionar hash de arquivo malicioso",
      "description": "Digite um hash SHA256/MD5 para adicionar à lista de bloqueio. Mensagens contendo arquivos com hashes correspondentes serão bloqueadas.",
      "hash_label": "Hash SHA256/MD5",
      "hash_placeholder": "Digite o hash SHA256/MD5",
      "description_label": "Descrição (opcional)",
      "description_placeholder": "Digite uma descrição para este hash",
      "submit": "Adicionar",
      "invalid_hash": "Formato de hash SHA256/MD5 inválido.",
      "loading_message": "Adicionando hash...",
      "success_message": "Hash adicionado com sucesso",
      "failed_message": "Falha ao adicionar hash"
    },
    "add_url_modal": {
      "trigger": "Adicionar URL",
      "title": "Adicionar URL maliciosa",
      "description": "Digite uma URL para adicionar à lista de bloqueio. Mensagens contendo esta URL serão bloqueadas.",
      "url_label": "URL",
      "url_placeholder": "Digite a URL (ex: https://site-malicioso.com)",
      "description_label": "Descrição (opcional)",
      "description_placeholder": "Digite uma descrição para esta URL",
      "submit": "Adicionar",
      "invalid_url": "Formato de URL inválido.",
      "loading_message": "Adicionando URL...",
      "success_message": "URL adicionada com sucesso",
      "failed_message": "Falha ao adicionar URL"
    },
    "cols": {
      "hash": "Hash",
      "hash_type": "Tipo",
      "url": "URL",
      "description": "Descrição",
      "created_at": "Criado Em"
    },
    "import_hashes_modal": {
      "trigger": "Importar CSV",
      "title": "Importar hashes de arquivos maliciosos",
      "description": "Escolha um arquivo CSV para importar hashes de arquivos maliciosos. O CSV deve ter as colunas: 'hash' (obrigatório) e 'description' (opcional).",
      "download_template": "Baixar modelo CSV",
      "confirm": "{{fileName}} foi processado com sucesso. Encontramos {{count}} hashes. Deseja adicioná-los à lista de bloqueio?",
      "submit": "Importar",
      "loading_message": "Importando hashes...",
      "success_message": "{{count}} hashes importados com sucesso",
      "failed_message": "Falha ao importar hashes",
      "csv_errors": {
        "empty_file": "O arquivo CSV está vazio",
        "missing_hash_column": "Falta a coluna obrigatória 'hash'",
        "invalid_headers": "Cabeçalhos inválidos encontrados: {{invalidHeaders}}"
      }
    },
    "import_urls_modal": {
      "trigger": "Importar CSV",
      "title": "Importar URLs maliciosas",
      "description": "Escolha um arquivo CSV para importar URLs maliciosas. O CSV deve ter as colunas: 'url' (obrigatório) e 'description' (opcional).",
      "download_template": "Baixar modelo CSV",
      "confirm": "{{fileName}} foi processado com sucesso. Encontramos {{count}} URLs. Deseja adicioná-las à lista de bloqueio?",
      "submit": "Importar",
      "loading_message": "Importando URLs...",
      "success_message": "{{count}} URLs importadas com sucesso",
      "failed_message": "Falha ao importar URLs",
      "csv_errors": {
        "empty_file": "O arquivo CSV está vazio",
        "missing_url_column": "Falta a coluna obrigatória 'url'",
        "invalid_headers": "Cabeçalhos inválidos encontrados: {{invalidHeaders}}"
      }
    },
    "delete_hash_modal": {
      "trigger": "Excluir Hash",
      "title": "Excluir hash da lista de bloqueio",
      "description": "Tem certeza que deseja excluir este hash da lista de bloqueio?",
      "description_multiple": "Tem certeza que deseja excluir {{count}} hashes da lista de bloqueio?",
      "submit": "Excluir",
      "loading_message": "Excluindo hash da lista de bloqueio...",
      "success_message": "Hash excluído com sucesso",
      "failed_message": "Falha ao excluir hash"
    },
    "delete_url_modal": {
      "trigger": "Excluir URL",
      "title": "Excluir URL da lista de bloqueio",
      "description": "Tem certeza que deseja excluir esta URL da lista de bloqueio?",
      "description_multiple": "Tem certeza que deseja excluir {{count}} URLs da lista de bloqueio?",
      "submit": "Excluir",
      "loading_message": "Excluindo URL da lista de bloqueio...",
      "success_message": "URL excluída com sucesso",
      "failed_message": "Falha ao excluir URL"
    },
    "incidents": {
      "columns": {
        "created_at": "Criado Em",
        "threat_type": "Tipo de Ameaça",
        "matches": "Correspondências",
        "attachments": "Anexos",
        "sender": "Remetente",
        "recipient": "Destinatário",
        "channel": "Canal",
        "is_group": "Grupo",
        "status": "Status"
      },
      "threat_types": {
        "all": "Todos os tipos",
        "url": "URL",
        "file_hash": "Hash de Arquivo",
        "phone_number": "Número de Telefone"
      },
      "statuses": {
        "new": "Novo",
        "resolved": "Resolvido",
        "dismissed": "Descartado"
      },
      "filters": {
        "title": "Filtrar Incidentes",
        "all_statuses": "Todos os status",
        "all_types": "Todos os tipos"
      },
      "detail": {
        "header": "Detalhes do Incidente",
        "back_to_list": "Voltar aos incidentes",
        "threat_type": "Tipo de Ameaça",
        "content": "Conteúdo",
        "matches": "Correspondências",
        "attachments": "Anexos",
        "hash_type": "Tipo de Hash",
        "sender": "Remetente",
        "recipient": "Destinatário",
        "channel": "Canal",
        "is_group": "Chat em Grupo",
        "status": "Status",
        "created_at": "Criado Em",
        "incident_id": "ID do Incidente"
      },
      "yes": "Sim",
      "no": "Não",
      "more_matches": "e {{count}} mais"
    },
    "create_incident": "Criar um incidente",
    "notification_recipients": "Destinatários de notificações personalizados",
    "notification_recipients_placeholder": "Pesquisar usuários..."
  },
  "phone_whitelist_settings_page": {
    "title": "Números de Telefone Permitidos",
    "search": "Buscar números de telefone",
    "add_phones_modal": {
      "trigger": "Adicionar números de telefone",
      "title": "Adicionar números de telefone à lista permitida",
      "description": "Use a área de texto abaixo para adicionar números de telefone à lista permitida. Você pode adicionar vários números separando-os com uma nova linha.",
      "placeholder": "Digite os números de telefone separados por linha",
      "submit": "Adicionar",
      "loading_message": "Adicionando números de telefone...",
      "success_message": "{{count}} números de telefone adicionados com sucesso",
      "failed_message": "Falha ao adicionar números de telefone"
    },
    "cols": {
      "phone": "Número de Telefone"
    },
    "import_phones_modal": {
      "trigger": "Importar",
      "title": "Importar números de telefone",
      "description": "Escolha um arquivo CSV para importar números de telefone permitidos. Certifique-se de que seu arquivo CSV tenha apenas uma coluna \"Phone\" com números de telefone.",
      "confirm": "{{fileName}} foi processado com sucesso. Encontramos {{count}} números de telefone. Deseja adicioná-los à lista permitida?",
      "submit": "Importar",
      "loading_message": "Importando números de telefone...",
      "success_message": "{{count}} números de telefone importados com sucesso",
      "failed_message": "Falha ao importar números de telefone"
    },
    "delete_phone_modal": {
      "trigger": "Excluir Telefone",
      "title": "Excluir número de telefone",
      "description": "Tem certeza que deseja excluir este número de telefone da lista permitida?",
      "description_multiple": "Tem certeza que deseja excluir {{count}} números de telefone da lista permitida?",
      "submit": "Sim, Excluir",
      "loading_message": "Excluindo...",
      "success_message": "Número de telefone excluído com sucesso",
      "failed_message": "Falha ao excluir número de telefone"
    }
  },
  "whatsapp_business_api_settings_page": {
    "add_phone_successfully_toast": "Novo telefone adicionado com sucesso",
    "add_phone_failed_toast": "Falha ao adicionar número de telefone",
    "code_sent_successfully_toast": "Código enviado com sucesso",
    "code_sent_failed_toast": "Falha ao solicitar o código",
    "phone_verified_successfully_toast": "Telefone verificado com sucesso",
    "phone_verified_failed_toast": "Falha ao verificar o número, por favor, tente novamente",
    "verifyMethodModal": {
      "title": "Escolher método de verificação",
      "submit_button": "Próximo",
      "text": "Escolha como deseja verificar o seu número:",
      "desc": "Se estiver a utilizar um número de telefone fixo, escolha a chamada telefónica."
    },
    "verifyModal": {
      "title": "Verificar número de telefone",
      "text": "Enviamos um código de verificação para {{phone}}. Para verificar o seu número, insira o código de 6 dígitos."
    },
    "verifyMethod": {
      "sms": "Mensagem de texto",
      "voice": "Chamada telefónica"
    },
    "addPhoneNumberModal": {
      "title": "Adicionar um número de telefone para o WhatsApp",
      "phone_number_field_title": "Número de telefone",
      "phone_number_field_sub_title": "Este é o número que as pessoas verão quando conversarem com você.",
      "phone_number_field_sub_title_link": "Saiba como usar um número que já está no WhatsApp.",
      "name_field_title": "Nome de exibição do WhatsApp Business",
      "name_field_sub_title": "Seu nome de exibição deve corresponder ao nome da sua empresa e seguir as diretrizes de nome de exibição do WhatsApp Business.",
      "name_field_sub_title_link": "Saiba mais sobre as diretrizes de nome de exibição.",
      "select_account_placeholder": "Por favor, selecione uma conta do WhatsApp"
    },
    "title": "WhatsApp Business API",
    "need_to_connect": "Para melhorar a sua experiência e desbloquear funcionalidades avançadas, é necessário ligar-se à API do WhatsApp Business",
    "connect_button": "Ligar",
    "disconnect_button": "Desligar",
    "disconnect_modal_title": "Desligar WhatsApp Business API",
    "disconnect_modal_message": "Tem a certeza de que deseja desligar '{{wabaName}}'?",
    "reload": "Recarregar",
    "settings_saved_successfully": "As configurações foram guardadas com sucesso",
    "settings_saved_failed": "Falha ao guardar as configurações",
    "code_status": {
      "NOT_VERIFIED": "Não verificado",
      "VERIFIED": "Verificado",
      "NONE": "Nenhum",
      "EXPIRED": "Expirado"
    },
    "name_status": {
      "APPROVED": "Aprovado",
      "AVAILABLE_WITHOUT_REVIEW": "Disponível",
      "DECLINED": "Rejeitado",
      "EXPIRED": "Expirado",
      "PENDING_REVIEW": "Pendente de revisão",
      "NONE": "Nenhum"
    },
    "template_status": {
      "APPROVED": "Aprovado",
      "REJECTED": "Rejeitado",
      "PENDING": "Pendente",
      "NONE": "Nenhum"
    },
    "cols": {
      "phone": "Telefone",
      "phone_id": "ID do telefone",
      "display_name": "Nome de exibição",
      "name_status": "Status nome de exibição",
      "code_status": "Status código",
      "businessName": "Nome do negócio",
      "wabaName": "Conta WhatsApp Business",
      "wabaId": "ID do WhatsApp Business",
      "businessStatus": "Estado do negócio",
      "smartersStatus": "Estado do Smarters",
      "templateName": "Nome do template",
      "languages": "Idiomas",
      "status": "Status",
      "template_available": "Template disponível",
      "user_groups": "Grupos de usuários",
      "purpose": "Finalidade"
    },
    "purpose": {
      "all": "Todos",
      "opt-in": "Opt-In",
      "campaign": "Campanha"
    },
    "preview_template": {
      "title": "{{name}}",
      "action": "Visualizar"
    },
    "edit_template": {
      "title": "Editar grupos do template",
      "user_groups_label": "Grupos de usuários",
      "all_users": "Todos os usuários",
      "save_success": "Template atualizado com sucesso",
      "save_error": "Falha ao atualizar template",
      "purpose_title": "Editar finalidade do template",
      "purpose_label": "Finalidade",
      "purpose_opt_in": "Opt-In",
      "purpose_campaign": "Campanha"
    },
    "actions_phone_table": {
      "set_smarters_token": "Definir token do Smarters",
      "delete_smarters_token": "Deletar token inteligente",
      "update_smarters_token": "Atualizar token inteligente",
      "assign_users": "Atribuir utilizadores",
      "verify_number": "Verificar número"
    },
    "smarters_modal": {
      "placeholder": "Insira o token do Smarters",
      "delete_token_message": "Tem a certeza de que deseja eliminar o token do Smarters do número de telefone: {{phoneNumber}}"
    },
    "empty_state_no_phones_text": "Ainda não foram adicionados números de telefone.",
    "empty_state_no_phones_button": "Adicionar novo número",
    "empty_state_no_template_message": "Para começar, crie o seu primeiro modelo de API do WhatsApp Business",
    "empty_state_no_template_button": "Adicionar modelo",
    "failed_to_disconnect": "Falha ao desligar a API do WhatsApp Business. Por favor, tente novamente.",
    "failed_to_connect": "Falha ao ligar à API do WhatsApp Business. Por favor, tente novamente.",
    "tabs": {
      "phones": "TELEFONES",
      "settings": "CONFIGURAÇÕES",
      "templates": "TEMPLATE"
    },
    "create_template": "Criar template",
    "create_template_loading_toast": "Criando template...",
    "create_template_success_toast": "Template enviado para aprovação",
    "create_template_failed_toast": "Falha ao criar template",
    "createTemplateModal": {
      "title": "Criar Template do WhatsApp",
      "template_name": "Nome do Template",
      "template_name_tooltip": "O nome deve ser em letras minúsculas, sem espaços ou caracteres especiais (use underscores).",
      "template_name_placeholder": "ex: confirmacao_pedido",
      "waba_account": "Conta WhatsApp Business",
      "category": "Categoria",
      "language": "Idioma",
      "header_type": "Cabeçalho",
      "header_text_placeholder": "Texto do cabeçalho (máx. 60 caracteres)",
      "body": "Corpo",
      "body_placeholder": "Digite o corpo da mensagem. Use {{1}}, {{2}} para parâmetros dinâmicos.",
      "body_helper": "Para adicionar uma variável, use {{#}} onde # é o índice da variável começando em 1.",
      "parameter_sample": "Exemplo para {{param}}",
      "parameter_sample_placeholder": "Digite o valor de exemplo",
      "footer": "Rodapé",
      "footer_placeholder": "Texto do rodapé (máx. 60 caracteres)",
      "buttons": "Botões",
      "add_button": "+ Adicionar Botão",
      "button_text_placeholder": "Texto do botão",
      "button_text_too_long": "O texto do botão não pode ter mais de {{max}} caracteres",
      "button_url_placeholder": "https://exemplo.com",
      "max_buttons_reached": "Máximo de 3 botões",
      "submit": "Criar Template",
      "category_utility": "Utilidade",
      "category_marketing": "Marketing",
      "header_none": "Nenhum",
      "header_text": "Texto",
      "button_quick_reply": "Resposta Rápida",
      "button_url": "URL",
      "template_preview_placeholder": "A visualização da template aparecerá aqui",
      "no_buttons_text": "Nenhum botão adicionado. Clique em + para adicionar até 3 botões.",
      "header_image": "Imagem",
      "header_video": "Vídeo",
      "header_document": "Documento",
      "header_media_upload": "Enviar mídia de exemplo",
      "header_media_uploading": "Enviando...",
      "header_media_uploaded": "Mídia enviada",
      "header_media_upload_failed": "Falha ao enviar mídia"
    },
    "add_waba_account": "Adicionar conta",
    "add_waba_phone": "Adicionar número de telefone",
    "business_status_tag": {
      "rejected": "Rejeitado",
      "verified": "Verificado",
      "pending": "Pendente",
      "not_verified": "Não Verificado",
      "pending_submission": "Envio Pendente",
      "auth_error": "Reconexão necessária"
    }
  },
  "campaigns": {
    "title": "Campanhas",
    "campaigns_tab": "Campanhas",
    "templates_tab": "Modelos",
    "new_campaign": "Nova Campanha",
    "search_placeholder": "Buscar",
    "no_campaigns": "Nenhuma campanha encontrada",
    "no_search_results": "Nenhuma campanha corresponde à sua busca",
    "cols": {
      "template": "Modelo",
      "date": "Data",
      "status": "Status",
      "sent": "Enviado / Audiência"
    },
    "create_modal": {
      "assign_to": "Atribuir conversas a",
      "assign_to_placeholder": "Selecionar agente (opcional)",
      "set_conversation_open": "Definir conversa como aberta",
      "success": "Campanha criada com sucesso",
      "error": "Falha ao criar campanha. Por favor, tente novamente.",
      "file_too_large": "Arquivo muito grande. Tamanho máximo: {{maxSize}}",
      "csv_empty": "Arquivo CSV está vazio",
      "csv_missing_headers": "Arquivo CSV com cabeçalhos obrigatórios ausentes: {{headers}}",
      "csv_invalid_phones": "Arquivo CSV contém números de telefone inválidos: {{phones}}",
      "csv_missing_params": "Arquivo CSV com colunas de parâmetros de template ausentes: {{params}}"
    }
  },
  "tuvis_contacts_page": {
    "title": "Contatos Tuvis",
    "name": "Nome",
    "phoneNumber": "Número de Telefone",
    "update_contact": "Editar Contato",
    "create_contact": "Novo Contato",
    "delete_contact": "Excluir Contato",
    "delete_contact_modal_message": "Tem certeza que deseja excluir este contato Tuvis?",
    "import_contacts_preview": "Visualização",
    "import_contacts_csv_button": "Importar CSV",
    "import_contacts_csv_template": "Baixar Modelo CSV",
    "required": "obrigatório",
    "import_button": "Importar",
    "drop_csv": "Solte o arquivo CSV aqui ou clique para procurar",
    "import_contacts_modal_text": "Criar um arquivo CSV: Certifique-se de que seu arquivo CSV inclua as seguintes colunas:",
    "import_contacts_csv_invalid_format": "Formato CSV inválido: {{header}}",
    "import_contacts_csv_success": "Resultados da importação: {{numOfNewContacts}} novos contatos Tuvis adicionados do arquivo CSV",
    "import_contacts_csv_failure": "Falha ao importar contatos Tuvis {{error}}",
    "csv_errors": {
      "empty_file": "Arquivo CSV está vazio",
      "missing_required_headers": "Arquivo CSV sem cabeçalhos obrigatórios: {{missingRequiredHeaders}}",
      "invalid_headers": "Arquivo CSV contém cabeçalhos inválidos: {{invalidHeaders}}",
      "invalid_phone": "Arquivo CSV contém linhas com telefones inválidos: {{invalidPhones}}",
      "missing_name": "Arquivo CSV contém linhas com nomes ausentes: {{missingName}}"
    },
    "assignedUser": "Usuários Atribuídos",
    "assignedUserId": "IDs de Usuários Atribuídos",
    "assignedUserPlaceholder": "Selecionar Usuários",
    "create_contact_failure": "Erro ao criar contato Tuvis",
    "update_contact_failure": "Erro ao atualizar contato Tuvis",
    "search_placeholder": "Buscar contatos",
    "contacts": "Contatos",
    "delete_selected": "Excluir Selecionados",
    "delete_selected_contacts": "Excluir Contatos Selecionados",
    "delete_selected_contacts_modal_message": "Tem certeza de que deseja excluir {{count}} contatos selecionados? Esta ação não pode ser desfeita.",
    "bulk_delete_success": "{{count}} contatos excluídos com sucesso",
    "bulk_delete_failure": "Falha ao excluir os contatos selecionados",
    "download_csv": "Baixar CSV",
    "download_csv_failure": "Falha ao baixar CSV",
    "createdAt": "Data de Criação"
  },
  "sidecars_page": {
    "title_short": "Remote Sync",
    "title": "Tuvis Remote Sync"
  },
  "all_users": {
    "title": "Todos os usuários"
  },
  "internal_admin_tools": {
    "global_user_search": "Todos os usuários",
    "org_explorer": "Explorador de Orgs"
  },
  "user_groups": {
    "headers": {
      "group_details": "Detalhes do Grupo"
    },
    "remove_user_from_group": "Remover usuário do grupo",
    "disabled_edit_name_tooltip": "O nome deste grupo não pode ser editado pois\nestá sincronizado com um sistema externo",
    "disabled_add_user_tooltip": "Você não pode adicionar usuários a este grupo porque ele está sincronizado com um sistema externo",
    "title": "Grupos de usuários",
    "add_group": "Adicionar grupo",
    "add_user": "Adicionar usuário",
    "remove_user": "Remover usuário {{userName}}",
    "remove_group": "Remover grupo",
    "update_group": "Atualizar Remover",
    "name": "Nome",
    "type": "Tipo",
    "users": "Usuários",
    "external_scim": "SSO",
    "external_sfdc": "Salesforce Profile",
    "confirm_delete_group": "Tem certeza de que deseja excluir este grupo?",
    "confirm_remove_user": "Tem certeza de que deseja remover este usuário?",
    "errors": {
      "default": "Ocorreu um erro ao processar sua solicitação",
      "duplicate_key": "Já existe um grupo com este nome",
      "license_limit_reached": "Limite de licenças atingido. Habilitar este canal excederia os assentos disponíveis.",
      "load_failed": "Erro ao carregar os grupos de usuários"
    },
    "configs": {
      "activities_create": "Criar Atividades",
      "activities_display": "Exibir Atividades",
      "show_chat_now_action": "Exibir Ação Chat Agora",
      "cases_create": "Criar Casos",
      "cases_display": "Exibir Casos",
      "auto_sync_activities_limit": "Limite Auto Sync Atividades",
      "contacts_create": "Criar Contatos",
      "contacts_display": "Exibir Contatos",
      "create_person_account": "Criar contas pessoais",
      "auto_sync_cases_limit": "Limite Auto Sync Casos",
      "leads_create": "Criar Leads",
      "leads_display": "Exibir Leads",
      "opps_display": "Exibir Oportunidades",
      "show_person_account": "Exibir contas pessoais",
      "tasks_create": "Criar Tarefas",
      "tasks_display": "Exibir Tarefas",
      "filter_analytics_by_profile": "Filtrar Analytics por Perfil",
      "show_edit_layout": "Exibir Editar Layout",
      "block_unknown_person": "Bloquear Pessoa Desconhecida",
      "show_auto_sync_button": "Exibir Botão Auto Sync",
      "show_global_search": "Exibir Busca Global",
      "show_new_event_action": "Exibir Ação Novo Evento",
      "show_add_to_phone_action": "Exibir Ação Adicionar ao Telefone",
      "show_calendar": "Exibir Calendário",
      "hide_all_create_actions": "Ocultar Todas as Ações Criar",
      "periodic_auto_sync": "Sincronizar periodicamente todas as mensagens",
      "show_whatsapp_calls": "Exibir Chamadas do WhatsApp"
    }
  },
  "users_lists": {
    "load_failed": "Erro ao carregar a lista de usuários"
  },
  "group_metadata": {
    "title": "Grupos do WhatsApp",
    "details_title": "Detalhes do Grupo WhatsApp",
    "subject": "Nome do Grupo",
    "no_subject": "N/A",
    "group_id": "ID do Grupo",
    "source_phone": "Telefone de Origem",
    "participants": "Participantes",
    "participants_count": "{{count}} participantes",
    "creation_date": "Data de Criação",
    "last_message_date": "Última Mensagem",
    "member_add_mode": "Modo de Adicionar Membros",
    "restrict": "Restrito",
    "participant_name": "Nome",
    "participant_phone": "Número de Telefone",
    "is_admin": "Administrador",
    "no_name": "N/A",
    "no_participants": "Sem participantes",
    "not_found": "Grupo não encontrado",
    "filter_by_user_placeholder": "Filtrar por usuário",
    "show_only_disabled_users": "Mostrar apenas usuários desabilitados",
    "participant_type": "Tipo de usuário",
    "org_user": "Usuário da org",
    "external_user": "Externo",
    "member_add_mode_all_members": "Todos os membros",
    "member_add_mode_only_admin": "Somente admin",
    "search_empty": {
      "no_results": "Nenhum grupo do WhatsApp foi sincronizado ainda"
    },
    "search_placeholder": "Pesquisar grupos por nome...",
    "view_logs": "Ver registros",
    "logs_modal": {
      "title": "Registros de atividade do grupo",
      "event_type": "Tipo de evento",
      "performed_by": "Realizado por",
      "affected": "Afetado",
      "date_time": "Data e hora",
      "no_events": "Nenhum registro de atividade encontrado"
    },
    "event_type": {
      "subject": "Nome alterado",
      "add": "Usuário adicionado",
      "remove": "Usuário removido",
      "leave": "Usuário saiu",
      "create": "Grupo criado",
      "restrict": "Permissão de edição alterada",
      "restrict_on": "Edição: Somente administradores",
      "restrict_off": "Edição: Todos os membros",
      "announce": "Permissão de mensagens alterada",
      "announce_on": "Mensagens: Somente administradores",
      "announce_off": "Mensagens: Todos os membros",
      "member_add_mode": "Modo de adição alterado",
      "member_add_mode_on": "Adição: Somente administradores",
      "member_add_mode_off": "Adição: Todos os membros"
    }
  },
  "audit_log": {
    "filters": "Filtros",
    "title": "Registro de auditoria",
    "unknown_user": "Usuário desconhecido",
    "reason": "razão",
    "from": "de",
    "to": "para",
    "header": {
      "type": "Tipo",
      "event": "Evento",
      "time": "Tempo",
      "description": "Descrição"
    },
    "namespaces": {
      "sidecars": "Tuvis Remote Sync",
      "integrations": "Integrações",
      "users": "Usuários",
      "userGroups": "Grupos",
      "settings": "Configurações",
      "waba": "WhatsApp Business API",
      "twilio": "Gravação de chamadas da Tuvis",
      "auth": "Autenticação",
      "dlp": "Data Loss Protection",
      "surveillance": "Vigilância",
      "incident": "Incidentes",
      "urlPolicies": "Políticas de acesso",
      "browserControls": "Controles do navegador",
      "email": "E-mail",
      "keywordInsights": "Insights de Palavras-Chave",
      "phonesWhitelist": "Lista de telefones permitidos",
      "phonesBlocklist": "Números de telefone privados",
      "blockedPhones": "Telefones Bloqueados (chat)",
      "tuvisContacts": "Contatos do Tuvis",
      "fraudDetection": "Detecção de Fraude",
      "dashboards": "Visualização personalizada",
      "customFilters": "Filtros personalizados",
      "accounts": "Contas",
      "archive": "Arquivo",
      "platforms": "Plataformas",
      "saml": "SAML",
      "botFlows": "Fluxos de bot"
    },
    "descriptions": {
      "dashboard_created": {
        "event_name": "Painel Criado",
        "description": "O painel \"{{metadata.name}}\" foi criado por {{metadata.userName}}"
      },
      "dashboard_updated": {
        "event_name": "Painel Atualizado",
        "description": "O painel \"{{metadata.name}}\" foi atualizado por {{metadata.userName}}"
      },
      "dashboard_deleted": {
        "event_name": "Painel Excluído",
        "description": "O painel \"{{metadata.name}}\" foi excluído por {{metadata.userName}}"
      },
      "widget_created": {
        "event_name": "Widget Criado",
        "description": "O widget \"{{metadata.title}}\" foi adicionado ao painel por {{metadata.userName}}"
      },
      "widget_deleted": {
        "event_name": "Widget Excluído",
        "description": "O widget \"{{metadata.title}}\" foi removido do painel por {{metadata.userName}}"
      },
      "incident_summary_reported": {
        "event_name": "Resumo Relatado",
        "description": "Relatório de Resumo do Incidente Enviado por Email"
      },
      "incident_reported": {
        "event_name": "Incidente Relatado",
        "description": "Incidente criado por '{{metadata.userName}}'"
      },
      "new_url_policy": {
        "event_name": "Nova Política de URL Criada",
        "description": "Política de URL criada por '{{metadata.userName}}'"
      },
      "update_url_policy": {
        "event_name": "Política de URL Atualizada",
        "description": "Política de URL atualizada por '{{metadata.userName}}'"
      },
      "delete_url_policy": {
        "event_name": "Política de URL Excluída",
        "description": "Política de URL excluída por '{{metadata.userName}}'"
      },
      "new_surveillance_policy": {
        "event_name": "Nova Política de Vigilância Criada",
        "description": "Política de vigilância criada por '{{metadata.userName}}'"
      },
      "update_surveillance_policy": {
        "event_name": "Política de vigilância atualizada",
        "description": "Política de vigilância atualizada por '{{metadata.userName}}'"
      },
      "delete_surveillance_policy": {
        "event_name": "Política de vigilância excluída",
        "description": "Política de vigilância excluída por '{{metadata.userName}}'"
      },
      "new_surveillance_rule": {
        "event_name": "Nova Regra de Vigilância Criada",
        "description": "Regra de vigilância criada por '{{metadata.userName}}'"
      },
      "update_surveillance_rule": {
        "event_name": "Regra de vigilância atualizada",
        "description": "Regra de vigilância atualizada por '{{metadata.userName}}'"
      },
      "delete_surveillance_rule": {
        "event_name": "Regra de vigilância excluída",
        "description": "Regra de vigilância excluída por '{{metadata.userName}}'"
      },
      "new_incident": {
        "event_name": "Novo Incidente Criado",
        "description": "Incidente criado por '{{metadata.userName}}'"
      },
      "update_incident_status": {
        "event_name": "Status do Incidente Atualizado",
        "description": "Status do incidente alterado para '{{metadata.status}}' por '{{metadata.userName}}'"
      },
      "update_surveillance_incident_status": {
        "event_name": "Status do Incidente de Vigilância Atualizado",
        "description": "Status do incidente de vigilância alterado para '{{metadata.status}}' por '{{metadata.userName}}'"
      },
      "surveillance_incident_reported": {
        "event_name": "Incidente de Vigilância Relatado",
        "description": "Incidente de vigilância relatado por '{{metadata.userName}}'"
      },
      "update_incident_assignee": {
        "event_name": "Responsável pelo Incidente Atualizado",
        "description": "Responsável pelo incidente atualizado para '{{metadata.assigneeName}}' por '{{metadata.userName}}'"
      },
      "create_policy": {
        "event_name": "Usuário Criou Política",
        "description": "Usuário {{metadata.userName}} criou política - {{metadata.policy.name}}"
      },
      "update_policy": {
        "event_name": "Política Atualizada",
        "description": "Usuário {{metadata.userName}} atualizou política - {{metadata.policy.name}}"
      },
      "delete_policy": {
        "event_name": "Política Excluída",
        "description": "Usuário {{metadata.userName}} excluiu política - {{metadata.policyName}}"
      },
      "create_rule": {
        "event_name": "Usuário Criou Regra DLP",
        "description": "Usuário {{metadata.userName}} criou regra - {{metadata.rule.name}}"
      },
      "update_rule": {
        "event_name": "Regra DLP Atualizada",
        "description": "Usuário {{metadata.userName}} atualizou regra - {{metadata.rule.name}}"
      },
      "delete_rule": {
        "event_name": "Regra DLP Excluída",
        "description": "Usuário {{metadata.userName}} excluiu regra - {{metadata.ruleName}}"
      },
      "disconnected": {
        "event_name": "Dispositivo Desconectado",
        "description": "Dispositivo de {{channel}} desconectado - {{sidecarName}}"
      },
      "run_completed": {
        "event_name": "Sincronização Mobile Concluída",
        "description": "Sincronização do dispositivo concluída - {{sidecarName}}"
      },
      "run_failed": {
        "event_name": "Falha na Execução Mobile",
        "description": "Erro na sincronização do dispositivo - {{sidecarName}}"
      },
      "pairing_phone_mismatch": {
        "event_name": "Incompatibilidade de Número Mobile",
        "description": "Falha no pareamento do dispositivo {{channel}} por divergência de número de telefone - {{sidecarName}}"
      },
      "pairing_success": {
        "event_name": "Usuário Pareado Mobile",
        "description": "Dispositivo de {{channel}} pareado com sucesso - {{sidecarName}}"
      },
      "pairing_failed": {
        "event_name": "Falha ao Emparelhar Dispositivo",
        "description": "Falha ao emparelhar o dispositivo {{channel}} - {{sidecarName}}"
      },
      "created": {
        "event_name": "Conexão Mobile Criada",
        "description": "Dispositivo criado por {{metadata.inviter}} - {{sidecarName}}"
      },
      "invited": {
        "event_name": "Usuário Convidado Mobile",
        "description": "{{metadata.senderUserName}} convidou {{metadata.recipientName}} ({{metadata.email}}) para parear com Tuvis"
      },
      "auto_invited": {
        "event_name": "Usuário Auto-Convidado para Parear",
        "description": "Automaticamente convidado {{metadata.email}} para parear com Tuvis"
      },
      "update_settings": {
        "event_name": "Configurações Mobile Atualizadas",
        "description": "Configuração do dispositivo atualizada por {{userName}}{{sidecarName}}"
      },
      "started": {
        "event_name": "Sincronização Mobile Iniciada",
        "description": "Sincronização do dispositivo iniciada - {{sidecarName}}"
      },
      "started_pairing": {
        "event_name": "Início de Pareamento Mobile",
        "description": "Pareamento do dispositivo iniciado - {{sidecarName}}"
      },
      "deleted": {
        "event_name": "Mobile Excluído com Sucesso",
        "description": "Dispositivo{{sidecarName}} excluído por {{userName}}"
      },
      "connect": {
        "event_name": "Usuário Conectou Integração",
        "description": "Integração {{metadata.type}} conectada"
      },
      "disconnect": {
        "event_name": "Integração Desconectada",
        "description": "Integração {{metadata.type}} desconectada"
      },
      "update": {
        "event_name": "Integração Atualizada",
        "description": "Integração {{metadata.type}} atualizada"
      },
      "clear_query_cache": {
        "event_name": "Cache de Consulta SFDC Limpo",
        "description": "Cache de consulta SFDC limpo"
      },
      "login": {
        "event_name": "Usuário Conectado",
        "description": "Usuário {{name}} fez login com sucesso em {{platform}} com {{crmAuthProvider}}"
      },
      "update_permissions": {
        "event_name": "Permissões do Usuário Atualizadas",
        "description": "Permissões de usuário atualizadas - {{userName}} alterou as permissões de {{whatsllyUserName}}"
      },
      "edit_user": {
        "event_name": "Usuário Editou Valor",
        "description": "Usuário atualizado - {{userName}} editou {{whatsllyUserName}}"
      },
      "disabled_user": {
        "event_name": "Conta Desativada",
        "description": "Usuário Desabilitado - {{userName}} desabilitou {{whatsllyUserName}}"
      },
      "activate_user": {
        "event_name": "Conta Ativada",
        "description": "Usuário Ativado - {{userName}} ativou {{whatsllyUserName}}"
      },
      "users_invited": {
        "event_name": "Vários Usuários Convidados",
        "description": "Usuários convidados - {{userName}} convidou {{emails}}"
      },
      "user_invited": {
        "event_name": "Usuário Convidado",
        "description": "{{inviterName}} convidou {{recipientName}} para se conectar ao Tuvis"
      },
      "user_was_invited": {
        "event_name": "Convidado para Conectar",
        "description": "{{recipientName}} foi convidado por {{inviterName}} para se conectar ao Tuvis"
      },
      "invite_deleted": {
        "event_name": "Convite de Usuário Excluído",
        "description": "Convite de usuário excluído - {{userName}} excluiu o convite de {{emails}}"
      },
      "download_csv": {
        "event_name": "CSV de Usuários Baixado",
        "description": "CSV de Usuários Baixado - {{userName}} baixou o csv de usuários"
      },
      "new_user": {
        "event_name": "Novo Usuário Adicionado",
        "description": "Novo usuário criado - {{userName}} ({{emails}})"
      },
      "merge_users": {
        "event_name": "Usuários mesclados",
        "description": "Mescladas {{metadata.movedIdentities}} identidades vinculadas no usuário resultante"
      },
      "read_messages": {
        "event_name": "Usuário Leu Mensagens",
        "description": "Usuário '{{userName}}' leu as mensagens de '{{viewedUserName}}'"
      },
      "assign_user": {
        "event_name": "Usuários Atribuídos ao Grupo",
        "description": "{{userName}} adicionou {{count}} usuários ao grupo {{groupName}}"
      },
      "unassign_user": {
        "event_name": "Usuários Removidos do Grupo",
        "description": "{{userName}} removeu {{count}} usuários do grupo {{groupName}}"
      },
      "create_group": {
        "event_name": "Grupo Criado",
        "description": "Grupo criado - {{userName}} criou {{groupName}}"
      },
      "update_group": {
        "event_name": "Grupo Atualizado",
        "description": "Grupo atualizado - {{userName}} atualizou {{groupName}}"
      },
      "remove_group": {
        "event_name": "Grupo Excluído",
        "description": "Grupo excluído - {{userName}} excluiu {{groupName}}"
      },
      "set_global_layout": {
        "event_name": "Layout Global Atualizado",
        "description": "Layout Global atualizado"
      },
      "set_hide_edit_layout": {
        "event_name": "Ocultar Layout de Edição Atualizado",
        "description": "Ocultar Layout de Edição atualizado - {{configValue}}"
      },
      "reset_user_layouts": {
        "event_name": "Layouts de Usuário Redefinidos",
        "description": "Layouts de Usuário Redefinidos"
      },
      "org_configs_updated": {
        "event_name": "Configuração da Org Atualizada",
        "description": "{{userName}} alterou as configurações da organização {{orgConfigsUpdateds}} {{reason}}"
      },
      "elite_token_generated": {
        "event_name": "Token de Segurança Elite Gerado",
        "description": "{{userName}} gerou um novo token de segurança elite"
      },
      "elite_token_updated": {
        "event_name": "Token de Segurança Elite Atualizado",
        "description": "{{userName}} atualizou o token de segurança elite"
      },
      "change_org_name": {
        "event_name": "Perfil da organização atualizado",
        "description": "{{userName}} atualizou o perfil da organização {{orgConfigsUpdateds}}"
      },
      "create_api_key": {
        "event_name": "Chave API Pública Criada",
        "description": "Chave API pública criada com id {{entityId}}"
      },
      "revoke_api_key": {
        "event_name": "Chave API Pública Revogada",
        "description": "Chave API pública revogada com id {{entityId}}"
      },
      "connected_to_waba": {
        "event_name": "API do WhatsApp Business Conectada",
        "description": "API do WhatsApp Business conectada - {{metadata.userName}}"
      },
      "disconnected_from_waba": {
        "event_name": "API do WhatsApp Business Desconectada",
        "description": "API do WhatsApp Business desconectada - {{userName}}"
      },
      "connected_to_twilio": {
        "event_name": "Integração Twilio Conectada",
        "description": "Twilio conectado - {{metadata.userName}}"
      },
      "disconnected_from_twilio": {
        "event_name": "Twilio Desconectado",
        "description": "Twilio desconectado"
      },
      "purchase-phone": {
        "event_name": "Número Twilio Comprado",
        "description": "Número de telefone comprado - {{metadata.userName}} comprou {{metadata.phone_number}}"
      },
      "update-phone": {
        "event_name": "Número Twilio Atualizado",
        "description": "Número de telefone atualizado - {{metadata.userName}} atualizou {{metadata.phone_number}}"
      },
      "release-phone": {
        "event_name": "Número Twilio Liberado",
        "description": "Número de telefone liberado - {{metadata.userName}} liberou {{metadata.phone_number}}"
      },
      "create_campaign": {
        "event_name": "Campanha Criada",
        "description": "Campanha criada - {{metadata.userName}} criou {{metadata.campaign.name}}"
      },
      "update_campaign": {
        "event_name": "Campanha Atualizada",
        "description": "Campanha atualizada - {{metadata.userName}} atualizou {{metadata.campaign.name}}"
      },
      "delete_campaign": {
        "event_name": "Campanha Excluída",
        "description": "Campanha excluída - {{metadata.userName}} excluiu {{metadata.campaign.name}}"
      },
      "add_whitelist_phones": {
        "event_name": "Lista de telefones permitidos adicionada",
        "description": "Lista de telefones permitidos adicionada - {{metadata.userName}} adicionou {{metadata.addedCount}} números de telefone"
      },
      "delete_whitelist_phone": {
        "event_name": "Lista de telefones permitidos excluída",
        "description": "Lista de telefones permitidos excluída - {{metadata.userName}} excluiu {{metadata.phone}}"
      },
      "add_blocklist_phones": {
        "event_name": "Números de telefone privados adicionados",
        "description": "Números de telefone privados adicionados - {{metadata.userName}} adicionou {{metadata.addedCount}} números"
      },
      "delete_blocklist_phone": {
        "event_name": "Número de telefone privado excluído",
        "description": "Número de telefone privado excluído - {{metadata.userName}} excluiu {{metadata.phone}}"
      },
      "add_blocked_phones": {
        "event_name": "Telefones Bloqueados (chat) Adicionados",
        "description": "Telefones Bloqueados (chat) adicionados - {{metadata.userName}} adicionou {{metadata.addedCount}} números"
      },
      "delete_blocked_phone": {
        "event_name": "Telefones Bloqueados (chat) Excluídos",
        "description": "Telefones Bloqueados (chat) excluídos - {{metadata.userName}} excluiu {{metadata.phone}}"
      },
      "new_tuvis_contact": {
        "event_name": "Contato do Tuvis Criado",
        "description": "Contato do Tuvis Criado - {{metadata.userName}} criou {{entityId}}"
      },
      "update_tuvis_contact": {
        "event_name": "Contato do Tuvis Atualizado",
        "description": "Contato do Tuvis Atualizado - {{metadata.userName}} atualizou {{entityId}}"
      },
      "delete_tuvis_contact": {
        "event_name": "Contato do Tuvis Excluído",
        "description": "Contato do Tuvis Excluído - {{metadata.userName}} excluiu {{entityId}}"
      },
      "import_tuvis_contacts": {
        "event_name": "Contatos do Tuvis Importados",
        "description": "Contatos do Tuvis Importados - {{metadata.userName}} importou {{metadata.contacts.length}} contatos"
      },
      "add_malicious_hashes": {
        "event_name": "Hashes maliciosos adicionados",
        "description": "Hashes maliciosos adicionados - {{metadata.userName}} adicionou {{metadata.addedCount}} hashes"
      },
      "delete_malicious_hashes": {
        "event_name": "Hashes maliciosos excluídos",
        "description": "Hashes maliciosos excluídos - {{metadata.userName}} excluiu {{metadata.hashes.length}} hashes"
      },
      "add_malicious_urls": {
        "event_name": "URLs maliciosas adicionadas",
        "description": "URLs maliciosas adicionadas - {{metadata.userName}} adicionou {{metadata.addedCount}} URLs"
      },
      "delete_malicious_urls": {
        "event_name": "URLs maliciosas excluídas",
        "description": "URLs maliciosas excluídas - {{metadata.userName}} excluiu {{metadata.urls.length}} URLs"
      },
      "create_account": {
        "event_name": "Conta criada",
        "description": "Conta criada - {{metadata.name}}"
      },
      "update_account": {
        "event_name": "Conta atualizada",
        "description": "Conta atualizada - {{metadata.name}}"
      },
      "unassign_org": {
        "event_name": "Organização desvinculada da conta",
        "description": "Organização desvinculada da conta"
      },
      "update_user_permissions": {
        "event_name": "Permissões de usuário da conta atualizadas",
        "description": "Permissões de usuário da conta atualizadas"
      },
      "delete_account_users": {
        "event_name": "Usuários removidos da conta",
        "description": "Usuários removidos da conta - {{metadata.count}} usuário(s)"
      },
      "invite_external_user": {
        "event_name": "Usuário externo convidado para a conta",
        "description": "Usuário externo convidado para a conta - {{metadata.email}} por {{metadata.userName}}"
      },
      "resend_invite": {
        "event_name": "Convite da conta reenviado",
        "description": "Convite da conta reenviado - {{metadata.count}} convite(s)"
      },
      "install_platform": {
        "event_name": "Plataforma instalada",
        "description": "Plataforma instalada - {{metadata.platformType}} ({{metadata.platformWorkspaceName}})"
      },
      "uninstall_platform": {
        "event_name": "Plataforma desinstalada",
        "description": "Plataforma desinstalada - {{metadata.platformType}}"
      },
      "update_platform_metadata": {
        "event_name": "Metadados da plataforma atualizados",
        "description": "Metadados da plataforma atualizados"
      },
      "create_platform": {
        "event_name": "Plataforma de arquivo criada",
        "description": "Plataforma de arquivo criada - {{metadata.platform}}"
      },
      "update_platform": {
        "event_name": "Plataforma de arquivo atualizada",
        "description": "Plataforma de arquivo atualizada - {{metadata.platform}}"
      },
      "delete_platform": {
        "event_name": "Plataforma de arquivo excluída",
        "description": "Plataforma de arquivo excluída - {{metadata.platform}}"
      },
      "scim_create_group": {
        "event_name": "Grupo criado (SCIM)",
        "description": "Grupo criado via SCIM - {{metadata.displayName}}"
      },
      "scim_update_group": {
        "event_name": "Grupo atualizado (SCIM)",
        "description": "Grupo atualizado via SCIM - {{metadata.displayName}}"
      },
      "scim_patch_group": {
        "event_name": "Grupo modificado (SCIM)",
        "description": "Grupo modificado via SCIM - {{metadata.displayName}}"
      },
      "scim_delete_group": {
        "event_name": "Grupo excluído (SCIM)",
        "description": "Grupo excluído via SCIM - {{metadata.displayName}}"
      },
      "scim_create_user": {
        "event_name": "Usuário criado (SCIM)",
        "description": "Usuário criado via SCIM - {{metadata.userName}}"
      },
      "scim_update_user": {
        "event_name": "Usuário atualizado (SCIM)",
        "description": "Usuário atualizado via SCIM - {{metadata.userName}}"
      },
      "scim_patch_user": {
        "event_name": "Usuário modificado (SCIM)",
        "description": "Usuário modificado via SCIM - {{metadata.userName}}"
      },
      "scim_deactivate_user": {
        "event_name": "Usuário desativado (SCIM)",
        "description": "Usuário desativado via SCIM - {{metadata.userName}}"
      },
      "scim_reactivate_user": {
        "event_name": "Usuário reativado (SCIM)",
        "description": "Usuário reativado via SCIM - {{metadata.userName}}"
      },
      "install_saml": {
        "event_name": "SAML instalado",
        "description": "SAML configurado para a organização"
      },
      "remove_saml": {
        "event_name": "SAML removido",
        "description": "Configuração SAML removida da organização"
      },
      "save_notifications": {
        "event_name": "Notificações do dispositivo salvas",
        "description": "Configurações de notificação do dispositivo salvas"
      },
      "save_flow": {
        "event_name": "Fluxo de bot salvo",
        "description": "Versão {{metadata.version}} do fluxo de bot salva por {{metadata.userName}}"
      },
      "publish_flow": {
        "event_name": "Fluxo de bot publicado",
        "description": "Versão {{metadata.version}} do fluxo de bot publicada por {{metadata.userName}}"
      },
      "unpublish_flow": {
        "event_name": "Fluxo de bot despublicado",
        "description": "Fluxo de bot despublicado por {{metadata.userName}}"
      },
      "stop_session": {
        "event_name": "Sessão de bot encerrada",
        "description": "Sessão de bot para {{metadata.senderNumber}} encerrada por {{metadata.userName}}"
      },
      "clone_flow": {
        "event_name": "Fluxo de bot clonado",
        "description": "Fluxo de bot \"{{metadata.flowName}}\" clonado por {{metadata.userName}}"
      },
      "update_flow_metadata": {
        "event_name": "Metadados do fluxo de bot atualizados",
        "description": "Metadados do fluxo de bot \"{{metadata.flowName}}\" atualizados por {{metadata.userName}}"
      },
      "create_flow": {
        "event_name": "Fluxo de bot criado",
        "description": "Fluxo de bot \"{{metadata.flowName}}\" criado por {{metadata.userName}}"
      },
      "assign_phones": {
        "event_name": "Telefones atribuídos ao fluxo de bot",
        "description": "Atribuições de telefone do fluxo de bot atualizadas por {{metadata.userName}}"
      },
      "terms_of_use_accepted": {
        "event_name": "Termos de Uso Aceitos",
        "description": "{{userName}} aceitou os termos de uso (versão {{termsVersion}})"
      },
      "terms_of_use_rejected": {
        "event_name": "Termos de Uso Recusados",
        "description": "{{userName}} recusou os termos de uso (versão {{termsVersion}})"
      },
      "new_application": {
        "event_name": "Aplicativo criado",
        "description": "O aplicativo foi criado por {{metadata.userName}}"
      },
      "update_application": {
        "event_name": "Aplicativo atualizado",
        "description": "O aplicativo foi atualizado por {{metadata.userName}}"
      },
      "delete_application": {
        "event_name": "Aplicativo excluído",
        "description": "O aplicativo foi excluído por {{metadata.userName}}"
      },
      "new_application_category": {
        "event_name": "Categoria de aplicativo criada",
        "description": "A categoria de aplicativo foi criada por {{metadata.userName}}"
      },
      "update_application_category": {
        "event_name": "Categoria de aplicativo atualizada",
        "description": "A categoria de aplicativo foi atualizada por {{metadata.userName}}"
      },
      "delete_application_category": {
        "event_name": "Categoria de aplicativo excluída",
        "description": "A categoria de aplicativo foi excluída por {{metadata.userName}}"
      },
      "new_start_page_layout": {
        "event_name": "Layout da página inicial criado",
        "description": "O layout da página inicial foi criado por {{metadata.userName}}"
      },
      "update_start_page_layout": {
        "event_name": "Layout da página inicial atualizado",
        "description": "O layout da página inicial foi atualizado por {{metadata.userName}}"
      },
      "delete_start_page_layout": {
        "event_name": "Layout da página inicial excluído",
        "description": "O layout da página inicial foi excluído por {{metadata.userName}}"
      },
      "update_start_page_branding": {
        "event_name": "Marca da página inicial atualizada",
        "description": "A marca da página inicial foi atualizada por {{metadata.userName}}"
      },
      "update_block_page_config": {
        "event_name": "Página de bloqueio atualizada",
        "description": "As configurações da página de bloqueio foram atualizadas por {{metadata.userName}}"
      },
      "access_request_submitted": {
        "event_name": "Pedido de acesso enviado",
        "description": "{{metadata.userName}} pediu acesso a {{metadata.host}}"
      },
      "access_request_approved": {
        "event_name": "Solicitação de acesso aprovada",
        "description": "A solicitação de acesso foi aprovada por {{metadata.userName}}"
      },
      "access_request_dismissed": {
        "event_name": "Solicitação de acesso descartada",
        "description": "A solicitação de acesso foi descartada por {{metadata.userName}}"
      },
      "new_browser_url_policy": {
        "event_name": "Política de acesso criada",
        "description": "A política de acesso foi criada por {{metadata.userName}}"
      },
      "update_browser_url_policy": {
        "event_name": "Política de acesso atualizada",
        "description": "A política de acesso foi atualizada por {{metadata.userName}}"
      },
      "delete_browser_url_policy": {
        "event_name": "Política de acesso excluída",
        "description": "A política de acesso foi excluída por {{metadata.userName}}"
      },
      "new_browser_control": {
        "event_name": "Controle do navegador criado",
        "description": "O controle do navegador foi criado por {{metadata.userName}}"
      },
      "update_browser_control": {
        "event_name": "Controle do navegador atualizado",
        "description": "O controle do navegador foi atualizado por {{metadata.userName}}"
      },
      "delete_browser_control": {
        "event_name": "Controle do navegador excluído",
        "description": "O controle do navegador foi excluído por {{metadata.userName}}"
      },
      "archive_device": {
        "event_name": "Dispositivo arquivado",
        "description": "O dispositivo foi arquivado por {{metadata.userName}}"
      },
      "unarchive_device": {
        "event_name": "Dispositivo desarquivado",
        "description": "O dispositivo foi desarquivado por {{metadata.userName}}"
      },
      "new_block_page_layout": {
        "event_name": "Página de bloqueio criada",
        "description": "A página de bloqueio foi criada por {{metadata.userName}}"
      },
      "update_block_page_layout": {
        "event_name": "Página de bloqueio atualizada",
        "description": "A página de bloqueio foi atualizada por {{metadata.userName}}"
      },
      "delete_block_page_layout": {
        "event_name": "Página de bloqueio excluída",
        "description": "A página de bloqueio foi excluída por {{metadata.userName}}"
      },
      "new_branding_layout": {
        "event_name": "Marca criada",
        "description": "A marca foi criada por {{metadata.userName}}"
      },
      "update_branding_layout": {
        "event_name": "Marca atualizada",
        "description": "A marca foi atualizada por {{metadata.userName}}"
      },
      "delete_branding_layout": {
        "event_name": "Marca excluída",
        "description": "A marca foi excluída por {{metadata.userName}}"
      },
      "new_edr_agent": {
        "event_name": "Agente EDR criado",
        "description": "O agente EDR foi criado por {{metadata.userName}}"
      },
      "update_edr_agent": {
        "event_name": "Agente EDR atualizado",
        "description": "O agente EDR foi atualizado por {{metadata.userName}}"
      },
      "delete_edr_agent": {
        "event_name": "Agente EDR excluído",
        "description": "O agente EDR foi excluído por {{metadata.userName}}"
      },
      "update_posture_baseline": {
        "event_name": "Linha de base de postura do dispositivo atualizada",
        "description": "A linha de base de postura do dispositivo foi atualizada por {{metadata.userName}}"
      },
      "create_device": {
        "event_name": "Dispositivo criado",
        "description": "Um novo dispositivo foi informado para {{metadata.userName}}"
      },
      "create_extension": {
        "event_name": "Extensão adicionada",
        "description": "{{metadata.userName}} adicionou uma extensão à lista"
      },
      "update_extension": {
        "event_name": "Extensão atualizada",
        "description": "{{metadata.userName}} atualizou uma extensão"
      },
      "update_saas_app": {
        "event_name": "Governança do aplicativo SaaS atualizada",
        "description": "{{userName}} atualizou a governança de {{appName}}"
      },
      "delete_extension": {
        "event_name": "Extensão removida",
        "description": "{{metadata.userName}} removeu uma extensão da lista"
      },
      "create_org": {
        "event_name": "Organização criada",
        "description": "Organização criada por {{metadata.userName}}"
      },
      "disconnect_from_twilio": {
        "event_name": "Twilio desconectado",
        "description": "Twilio desconectado"
      },
      "archive_flow": {
        "event_name": "Fluxo de bot arquivado",
        "description": "Fluxo de bot arquivado por {{metadata.userName}}"
      },
      "bulk_delete_tuvis_contacts": {
        "event_name": "Contatos Excluídos em Massa",
        "description": "{{metadata.deletedCount}} contatos excluídos por {{metadata.userName}}"
      },
      "custom_filter_created": {
        "event_name": "Filtro Personalizado Criado",
        "description": "O filtro personalizado \"{{metadata.filterName}}\" foi criado"
      },
      "custom_filter_updated": {
        "event_name": "Filtro Personalizado Atualizado",
        "description": "O filtro personalizado \"{{metadata.filterName}}\" foi atualizado"
      },
      "custom_filter_deleted": {
        "event_name": "Filtro Personalizado Excluído",
        "description": "O filtro personalizado \"{{metadata.filterName}}\" foi excluído"
      },
      "disconnect_from_waba": {
        "event_name": "Desconectado do WhatsApp Business",
        "description": "Conta do WhatsApp Business {{entityId}} desconectada por {{metadata.userName}}"
      },
      "identity_merge_ambiguous": {
        "event_name": "Mesclagem de Identidade Ambígua",
        "description": "A identidade não pôde ser mesclada automaticamente: mais de um usuário corresponde a {{metadata.mergeKey}} \"{{metadata.mergeValue}}\""
      },
      "subaccount_created": {
        "event_name": "Subconta do Twilio Criada",
        "description": "Subconta do Twilio \"{{metadata.friendlyName}}\" criada por {{metadata.userName}}"
      },
      "update_api_key": {
        "event_name": "Chave API Pública Atualizada",
        "description": "Chave API pública atualizada com id {{entityId}}"
      },
      "update_fraud_incident_status": {
        "event_name": "Status do Incidente de Fraude Atualizado",
        "description": "Status do incidente de fraude alterado para \"{{metadata.status}}\" por {{metadata.userName}}"
      }
    }
  },
  "saml_settings": {
    "sign_auth_res": "Assine a resposta SAML",
    "sign_auth_res_tooltip": "Define se a mensagem de resposta de autenticação SAML está digitalmente assinada pelo IDP ou não, certifique-se de que esta configuração corresponda ao seu IDP.",
    "sign_assertion": "Assine a asserção SAML",
    "sign_assertion_tooltip": "Define se a declaração SAML está digitalmente assinada ou não, certifique-se de que esta configuração corresponda ao seu IDP.",
    "disable_requested_authn_context": "Desativar Contexto de Autenticação Solicitado",
    "disable_requested_authn_context_tooltip": "Se marcado, não solicita um contexto de autenticação específico",
    "use_browser": "Abrir autenticação no navegador",
    "use_browser_tooltip": "Se marcado, a autenticação SAML será aberta no navegador padrão do usuário em vez de dentro da aplicação",
    "default_permission_title": "Definir permissões padrão para novos usuários:",
    "default_groups_title": "Definir grupos padrão para novos usuários:",
    "provisioning": "Provisionamento",
    "scim_url": "URL do locatário",
    "scim_token": "Token secreto",
    "disable_scim_invite_email": "Desativar e-mail de convite",
    "disable_scim_invite_email_tooltip": "Quando ativado, usuários criados pelo provisionamento SCIM não receberão o e-mail de convite da plataforma.",
    "scim_list_active_only": "Excluir usuários desativados das listagens SCIM",
    "scim_list_active_only_tooltip": "Quando ativado, as respostas SCIM `GET /Users` sem filtro retornam apenas usuários ativos. Necessário para IdPs que tratam a lista como o conjunto de usuários gerenciados (por exemplo, JumpCloud). Mantenha desativado para comportamento compatível com SCIM (RFC 7644 §3.4.2) - IdPs que precisem apenas de usuários ativos devem enviar `filter=active eq true`.",
    "attribute_mapping_title": "Mapeamento de atributos",
    "attribute_mapping_tooltip": "Mapeie os atributos SCIM recebidos para os campos de usuário do Tuvis. Os campos padrão são mapeados automaticamente e exibidos para referência. O telefone só é provisionado se você mapeá-lo: deixe vazio e o SCIM nunca altera o campo Telefone do usuário, ou informe 'phoneNumbers' para o atributo padrão - ou outro caminho, se o seu IdP enviar o número em outro atributo. Para cada campo personalizado, informe o caminho do atributo SCIM de origem; por exemplo 'title', ou um caminho de extensão como os atributos 'employeeNumber' (enterprise) ou 'extensionAttribute1' (Entra).",
    "attribute_mapping_placeholder": "Caminho do atributo SCIM (ex.: title)",
    "attribute_mapping_placeholder_phone": "Não sincronizado - informe um caminho de atributo SCIM para provisionar",
    "attribute_mapping_empty": "Crie primeiro campos personalizados (Plataforma > Campos personalizados) para mapear atributos SCIM.",
    "attribute_mapping_col_tuvis": "Usuário Tuvis",
    "attribute_mapping_col_scim": "Usuário de origem SCIM",
    "save_changes": "Salvar alterações",
    "save_changes_confirm": "Você tem certeza de que deseja salvar as alterações?",
    "title": "Configurações SSO",
    "invite_to_platform_tooltip": "Convide um novo usuário a platforma. Isso irá criar uma nova organização quando ele se cadastar. Convidar para uma organização já existente pode ser feito através de \"Usuários\" página.",
    "saml_settings": " Configurações SSO para Org",
    "force_saml_only": "Allow Login Only Using SSO",
    "drop_xml": "Insira o arquivo XML  aqui ou clique para navegar",
    "import_xml": "Importar metadata XML",
    "xml_url": "Importar de URL",
    "invalid_url": "XML  e URL invalidos",
    "import_xml_placeholder": "https://login.microsoftonline.com/<tenant_id>/FederationMetadata/2007-06/FederationMetadata.xml?appid=<app_id>",
    "add_to_provider": "Adicione o seguinte - ao seu provedor de identidade",
    "sp_entity_id": "SP Entity ID",
    "acs_url": "SP ACS URL",
    "curreny_saml_settings": "Configurações SSO atual",
    "domains_usage": " é usado por {{organizations}} organização(ões)",
    "friendly_org_name": "Nome da Organização",
    "friendly_org_name_tooltip": "Exibido no login para ajudar os usuários a selecionar a organização correta quando várias organizações estão associadas ao mesmo domínio SAML.",
    "org_email_domain": "Domínio de e-mail da organização",
    "idp_entity_id": "IdP Entity ID",
    "idp_sso_url": "IdP SSO URL",
    "idp_certificates": "IdP Certificate",
    "save_saml_settings": "Salvar configurações SSO",
    "save_success": "Configurações SSO salvas.",
    "save_failed": "Falha ao salvar as configurações SSO. Nada foi alterado; tente novamente.",
    "load_failed": "Falha ao carregar as configurações SSO. O formulário está vazio e não reflete o que está salvo; atualize a página antes de fazer alterações.",
    "default_channel_title": "Definir o canal padrão para novos usuários:"
  },
  "search_person": {
    "loading": "Carregando..."
  },
  "file_invalid": {
    "size": "Não foi possível sincronizar devido ao limite de tamanho de arquivo",
    "mimeType": "Tipo de arquivo não suportado",
    "messageType": "Tipo de mensagem não suportado"
  },
  "destinations_page": {
    "tags": {
      "all_users": "Todos os usuários"
    },
    "table_actions": {
      "edit_connection": "Editar Conexão",
      "edit_details": "Editar Detalhes"
    },
    "table_headers": {
      "name": "Nome",
      "logo": "Logo",
      "integration": "Integração",
      "type": "Tipo",
      "user_groups": "Grupos de usuários"
    },
    "edit_integration": {
      "header": "Editar Integração"
    },
    "edit_details": {
      "header": "Editar Detalhes",
      "view_only_label": "Somente visualização"
    },
    "add_integration": {
      "header": "Adicionar Integração",
      "name": "Nome",
      "name_placeholder": "ex.: S3 para Vendas",
      "user_groups": "Grupos de usuários",
      "all_users": "Todos os usuários"
    },
    "language": "Idioma",
    "all_types": "Todos os tipos",
    "available_fields": "Campos Disponíveis",
    "type": "Tipo",
    "tabs": {
      "messages": "Mensagens",
      "auditLogs": "Registros de Auditoria",
      "dlpIncidents": "Incidentes",
      "audioTranscribes": "Transcrição de Áudio",
      "dlpDetectors": "Detectores DLP",
      "security": "Segurança",
      "fileScanning": "Detecção de Fraude",
      "llmProvider": "Provedores de IA",
      "platforms": "Plataformas",
      "channels": "Canais",
      "archive": "Archive"
    },
    "incident_types": {
      "label": "Tipos de Incidentes",
      "dlp": "DLP",
      "surveillance": "Vigilância",
      "fraud": "Detecção de Fraude"
    },
    "security": {
      "add": "Adicionar",
      "remove": "Remover",
      "edit": "Editar",
      "other_modal_title": "Outra pilha de segurança",
      "disclaimer": "Selecione sua infraestrutura para receber da Tuvis o guia correto de aplicação de rede. Adicionar uma plataforma identifica seu ambiente; não estabelece uma conexão de dados ao vivo com esses sistemas."
    },
    "pipedrive": {
      "text": "Conecte sua conta PipeDrive para sincronizar mensagens\n",
      "connect": "Conectar",
      "reconnect": "Reconectar"
    },
    "hubspot": {
      "connect": "Conectar",
      "reconnect": "Reconectar",
      "text": "Conecte a conta HubSpot para sincronizar mensagens"
    },
    "crm": {
      "lead": "Lead",
      "contact": "Contato",
      "field_value": "Valor do Campo",
      "field_name": "Nome do Campo",
      "enableObjectSettingsCheckbox": "Criar objeto se não encontrado"
    },
    "global_relay": {
      "description": "Para habilitar a integração, entre em contato com seu gerente de conta or time de suporte da Global Relay (coloque provisioning@globalrelay.net em cópia no email), e pergunte pelos detalhes SMTP personalizados da conta:",
      "subDescription": {
        "host": {
          "subject": "Host do servidor SMTP",
          "desc": ": deve ficar assim: feeds-xyz.globalrelay.com"
        },
        "username_password": "Nome de usuário e senha SMTP personalizados",
        "smtp_destination": {
          "subject": "Destino SMTP de registro no diário",
          "desc": ": um endereço de e-mail que deve ser semelhante a este: feed-########@feeds.globalrelay.com"
        },
        "msg_type": {
          "subject": "X-GlobalRelay-MsgType",
          "desc": ": vai ser normalmente \"TuvisWhatsApp\""
        }
      }
    },
    "title": "Integrações",
    "revoke_destination": "Desconectar Integração",
    "revoke_destination_confirmation": "Tem certeza de que deseja desconectar {{destinationName}}?",
    "revoke_destination_with_batch_mode_on_confirmation": "Tem certeza de que deseja desconectar {{destinationName}}? Desativar o modo em lote deixará as mensagens não sincronizadas sem sincronização. Tem certeza de que deseja prosseguir?",
    "revoke_button_text": "Desconectar {{destinationName}}",
    "enable_destination_confirmation": "Tem certeza de que deseja habilitar {{destinationName}}?",
    "disable_destination_confirmation": "Tem certeza de que deseja desabilitar {{destinationName}}?",
    "cancel_button_text": "Cancelar",
    "format": "Formato",
    "save_base_path": "Caminho Base de Salvamento",
    "read_base_path": "Caminho Base de Leitura",
    "bucket": "Bucket",
    "iam_role_name": "ARN da função",
    "external_id": "ID externo",
    "openid_provider_url": "URL do Provedor OpenId",
    "access_key_auth": "Auth. chave acesso",
    "identity_provider_auth": "Auth. provedor ID",
    "file_name_template": "Modelo de Nome de Arquivo",
    "file_name_upload_date": "Incluir Data de Upload em Nomes de Arquivos",
    "media_file_name_template": "Modelo de Nome de Arquivo de Mídia",
    "store_media": "Armazenar mídia",
    "client_encryption_key": "Chave de criptografia do cliente",
    "client_encryption": "Criptografia do lado do cliente",
    "flat": "Salvar arquivos diretamente na raiz do caminho base",
    "zipped": "Salvar arquivo de mídia compactado",
    "msg_date_timezone": "Fuso horário da data",
    "file_name_date_timezone": "Fuso horário do nome do arquivo",
    "yes": "Sim",
    "no": "Não",
    "region": "Região",
    "accesses_key_id": "ID da Chave de Acesso",
    "secret_access_key": "Chave de Acesso Secreta",
    "enable_long_audio_transcription": "Ativar transcrição para áudios com mais de 3 minutos",
    "enable_video_transcription": "Ativar transcrição de vídeo",
    "enable_video_transcription_tooltip": "Quando ativado, a trilha de áudio dentro dos arquivos de vídeo enviados é transcrita e verificada para violações de DLP.",
    "enable_long_audio_transcription_tooltip": "Para transcrever arquivos de áudio com mais de 3 minutos, o Tuvis precisa de acesso a um bucket S3 com permissões de escrita e exclusão.",
    "temporary_s3_bucket": "Bucket S3 temporário",
    "temporary_s3_region": "Região S3 temporária",
    "temporary_s3_prefix": "Prefixo S3 temporário (Opcional)",
    "account_name": "Nome da Conta",
    "account_key": "Chave da Conta",
    "sas_url": "SAS URL",
    "container_name": "Nome do Contêiner",
    "storage_url": "URL de Armazenamento",
    "api_key": "Chave API",
    "host": "Host",
    "connection_string": "String de Conexão",
    "port": "Porta",
    "user": "Usuário",
    "password": "Senha",
    "rcpt": "Destino SMTP",
    "secure": "Seguro",
    "true": "Verdadeiro",
    "false": "Falso",
    "server_url": "URL do Servidor",
    "api_url": "URL da API",
    "blob_storage": "Blob",
    "file_scanning_category": "Varredura de Arquivos",
    "compliance": "Compliance",
    "dlp": "Data Loss Protection",
    "sftp_password_or_privateKeyError": "Você deve inserir uma senha ou uma chave privada",
    "create_destination_in_progress": "Criação do destino em andamento",
    "destination_created_successfully": "Destino criado com sucesso",
    "failed_to_create_destination": "Falha ao criar o destino",
    "revoke_destination_in_progress": "Desconectando integração em andamento",
    "destination_revoked_successfully": "Integração desconectada com sucesso",
    "failed_to_revoke_destination": "Falha ao desconectar integração",
    "do_you_want_store_media": "Você quer armazenar mídia na sua instância do Salesforce?",
    "update_destination_in_progress": "Atualização do destino em andamento",
    "destination_updated_successfully": "Destino atualizado com sucesso",
    "failed_to_update_destination": "Falha ao atualizar o destino",
    "salesforce_user": "Usuário Salesforce",
    "failed_to_get_integrations": "Falha ao obter integrações",
    "save": "Salvar",
    "download_certificate": "Baixar certificado",
    "generate_certificate": "Gerar certificado",
    "generate_certificate_failed_toast": "Falha ao gerar o arquivo do certificado. Por favor, tente novamente.",
    "connected_app_consumer_key": "Chave do Consumidor do Aplicativo Conectado",
    "client_id": "ID do Cliente",
    "client_secret": "Segredo do Cliente",
    "url": "URL",
    "tenant_id": "ID do Locatário",
    "user_id": "ID do Usuário",
    "username": "Nome de Usuário",
    "test_connection": "Testar conexão",
    "test_connection_failed_toast": "Teste de conexão falhou. Por favor, verifique suas configurações.",
    "test_connection_s3_validation_failed_toast": "Houve um problema na validação do S3. Verifique as permissões do role.",
    "test_connection_transcribe_validation_failed_toast": "Houve um problema na validação do Transcribe. Verifique as permissões do role.",
    "project_id": "Project ID",
    "client_email": "Client Email",
    "private_key": "Private Key",
    "batch": {
      "title": "Executar como trabalho em lote",
      "batch_sync_turn_off_title": "Desativar o modo 'executar como Lote'",
      "batch_sync_turn_off_desc": "Desativar o modo em lote deixará as mensagens não sincronizadas sem sincronização. Tem certeza de que deseja prosseguir?"
    },
    "connected_integrations": "Integrações conectadas",
    "empty_state": {
      "title": "Nenhuma integração {{destinationName}} conectada",
      "description": "Adicione uma integração {{destinationName}} para começar"
    },
    "aws_region": "Região AWS",
    "aws_access_key_id": "ID da Chave de Acesso AWS",
    "aws_secret_access_key": "Chave de Acesso Secreta AWS",
    "aws_session_token": "Token de Sessão AWS",
    "target_index": "Fluxo de dados / índice de destino",
    "pipeline_id": "ID do pipeline de ingestão",
    "google_api_key": "Chave de API do Google",
    "webhook_access_key": "Chave de acesso do webhook",
    "llm_enabled_models": "Modelos permitidos",
    "llm_enabled_models_placeholder": "Deixe em branco para permitir todos os modelos",
    "llm_default_model": "Modelo padrão",
    "llm_default_model_placeholder": "Selecione o modelo padrão para novos chats",
    "connector_name": "Nome do conector",
    "object_name": "Nome do objeto",
    "ingestion_endpoint": "Endpoint de ingestão",
    "sentinel": {
      "tenant_id": "ID do tenant do Azure",
      "client_id": "ID do cliente",
      "client_secret": "Segredo do cliente",
      "dce_endpoint": "URL do endpoint de coleta de dados",
      "dcr_immutable_id": "ID imutável do DCR",
      "stream_name": "Nome do fluxo (opcional)"
    }
  },
  "dlp_incident_page": {
    "header": "Detalhes do Incidente",
    "channel": "Canal",
    "incident_id": "ID do Incidente",
    "refresh": "Atualizar",
    "details": "Detalhes",
    "attachments_match_details": {
      "title": "Detalhes de correspondência de arquivos",
      "description": "Detalhes sobre como os arquivos corresponderam à regra"
    },
    "source": "Origem",
    "image_unappropriate": "Imagem Inapropriada",
    "triggered_rule": "Regra",
    "match_source": {
      "content": "Conteúdo do arquivo",
      "metadata": "Metadados do arquivo",
      "filename": "Nome do arquivo",
      "image": "Imagem"
    }
  },
  "url_policies_page": {
    "title": "Políticas de desktop",
    "name": "Nome",
    "url": "URL",
    "type": "Tipo",
    "created_at": "Criado em",
    "updated_at": "Atualizado em",
    "update_policy": "Editar Política",
    "create_policy": "Nova Política",
    "delete_policy": "Excluir Política",
    "delete_policy_modal_message": "Tem certeza que deseja excluir esta política de URL?",
    "watermark": "Marca d'água",
    "action_ON": "ATIVADO",
    "action_OFF": "DESATIVADO",
    "protect_download": "Proteger download",
    "password": "Senha",
    "watermark_tooltip": "Adiciona marcas d'água com identificação do usuário na viewport para impedir compartilhamento não autorizado e permitir rastreamento de vazamentos",
    "protect_download_tooltip": "Cada arquivo baixado será compactado e protegido pela senha fornecida.",
    "dlp": "DLP",
    "dlp_tooltip": "Monitorar e aplicar políticas DLP ao conteúdo deste site",
    "surveillance": "Vigilância",
    "surveillance_tooltip": "Monitorar o conteúdo deste site de acordo com suas regras de vigilância e registrar os incidentes correspondentes",
    "fraud_detection": "Detecção de fraude",
    "fraud_detection_tooltip": "Bloquear downloads de arquivos com hashes maliciosos conhecidos neste site",
    "wizard": {
      "new_title": "Nova política",
      "edit_title": "Editar política",
      "back_to_list": "Voltar às políticas",
      "step_type": "Tipo",
      "step_configuration": "Configuração",
      "step_summary": "Resumo",
      "select_type_heading": "Selecionar tipo de política",
      "select_type_sub": "Escolha o tipo de política que deseja criar.",
      "configure_heading": "Configurar política",
      "configure_sub": "Preencha os detalhes, URLs, escopo e recursos.",
      "summary_heading": "Revisar política",
      "summary_sub": "Confirme os detalhes abaixo antes de salvar.",
      "type_applications_title": "Aplicativos",
      "type_applications_desc": "Permitir aplicativos de mensagens compatíveis no Tuvis Desktop.",
      "type_managed_title": "URLs gerenciadas",
      "type_managed_desc": "Aplicar regras DLP e monitoramento a integrações predefinidas pela Tuvis.",
      "type_network_title": "Rede",
      "type_network_desc": "Permitir acesso a qualquer site externo ou URL personalizada no Tuvis Desktop.",
      "next": "Avançar",
      "back": "Voltar",
      "submit_create": "Criar política",
      "submit_update": "Salvar alterações",
      "managed_url_placeholder": "Selecione um site gerenciado (ex.: Slack, ChatGPT)",
      "application_placeholder": "Selecione um aplicativo…",
      "application_whatsapp": "WhatsApp",
      "application_telegram": "Telegram",
      "application_tuvis": "Mensagens Tuvis",
      "error_select_policy_type": "Selecione um tipo de política antes de continuar.",
      "error_complete_required_fields": "Preencha todos os campos obrigatórios antes de continuar.",
      "error_invalid_url": "Informe uma URL válida (por exemplo https://example.com).",
      "summary_empty_value": "Nenhum"
    }
  },
  "browser_settings_page": {
    "title": "Controles do navegador",
    "description": "Descrição",
    "allowAutofillForms": "Permitir preenchimento automático de formulários",
    "allowAutofillForms_hint": "Permite que o navegador preencha endereços e outros dados de formulário.",
    "allowPasswordManager": "Permitir o gerenciador de senhas do navegador",
    "allowPasswordManager_hint": "Permite que os usuários salvem e preencham senhas no navegador.",
    "allowAutofillCreditCards": "Permitir preenchimento de cartões",
    "allowAutofillCreditCards_hint": "Permite que o navegador armazene e preencha cartões de pagamento.",
    "allowCast": "Permitir Cast",
    "allowCast_hint": "Permite que os usuários transmitam abas e mídia para outros dispositivos.",
    "allowDeveloperTools": "Permitir ferramentas de desenvolvedor",
    "allowDeveloperTools_hint": "Permite abrir as DevTools. No nível do navegador (não há opção por URL). Bloquear desativa-as em todos os lugares.",
    "allowDeleteHistory": "Permitir excluir o histórico do navegador",
    "allowDeleteHistory_hint": "Permite que os usuários limpem o histórico de navegação.",
    "allowTaskManagerEndProcess": "Permitir encerrar processos no Gerenciador de tarefas",
    "allowTaskManagerEndProcess_hint": "Permite que os usuários encerrem processos do navegador pelo Gerenciador de tarefas.",
    "allowExternalApps": "Permitir abrir links em apps externos",
    "allowExternalApps_hint": "Permite que o navegador abra aplicativos externos para links (mailto:, tel:, protocolos personalizados).",
    "allowIncognito": "Permitir modo anônimo",
    "allowIncognito_hint": "Permite abrir janelas anônimas. Recomenda-se bloquear: o modo anônimo pode evadir o monitoramento.",
    "allowFileSelectionDialogs": "Permitir diálogos de arquivo (enviar / salvar como)",
    "allowFileSelectionDialogs_hint": "Permite escolher arquivos para enviar ou um local para salvar. Bloquear desativa envios e salvar como.",
    "allowAddPerson": "Permitir adicionar perfis do navegador",
    "allowAddPerson_hint": "Permite que os usuários adicionem novos perfis do navegador.",
    "download_restrictions": "Restrições de download",
    "download_restrictions_hint": "Restringe quais downloads são permitidos.",
    "download_restrictions_unmanaged": "Não gerenciado (padrão do Chrome)",
    "download_restrictions_0": "Sem restrições",
    "download_restrictions_1": "Bloquear downloads perigosos",
    "download_restrictions_2": "Bloquear downloads potencialmente perigosos",
    "download_restrictions_3": "Bloquear todos os downloads",
    "download_restrictions_4": "Bloquear downloads maliciosos",
    "default_search_label": "Mecanismo de busca padrão",
    "default_search_hint": "Define o mecanismo de busca padrão do navegador. Se não definido, usa a base do navegador (Google).",
    "default_search_unset": "Não gerenciado (base Google)",
    "default_search_custom": "Personalizado...",
    "default_search_custom_name": "Nome",
    "default_search_custom_url": "URL de busca",
    "default_search_custom_suggest": "URL de sugestões (opcional)",
    "default_search_placeholder_error": "A URL de busca deve incluir o marcador {searchTerms}.",
    "control_chip_incognito": "Sem anônimo",
    "control_chip_file_dialogs": "Sem diálogos arquivo",
    "control_chip_add_person": "Sem perfis novos",
    "control_chip_downloads": "Downloads limitados",
    "extensions_title": "Extensões",
    "extensions_hint": "Controle as extensões com qualquer combinação das listas abaixo. Insira um id por linha.",
    "extensions_forcelist": "Forçar instalação",
    "extensions_forcelist_hint": "Instaladas automaticamente e não podem ser removidas pelo usuário.",
    "extensions_allowlist": "Permitir",
    "extensions_allowlist_hint": "Isentas da lista de bloqueio (use * em Bloquear para permitir apenas estas).",
    "extensions_blocklist": "Bloquear",
    "extensions_blocklist_hint": "Bloqueadas. Use * para bloquear tudo, exceto as permitidas.",
    "extensions_ids_placeholder": "Ids de extensão, um por linha",
    "extensions_picker_placeholder": "Procure ou cole um ID de extensão…",
    "save": "Salvar",
    "name": "Nome",
    "priority": "Prioridade",
    "required": "Obrigatório",
    "cancel": "Cancelar",
    "enforces": "Aplica",
    "create_policy": "Nova Política",
    "update_policy": "Editar",
    "delete_policy": "Excluir",
    "delete_policy_modal_message": "Tem certeza de que deseja excluir esta política de configurações do navegador?",
    "new_policy_title": "Criar política de controles do navegador",
    "edit_policy_title": "Editar política de controles do navegador",
    "section_details_title": "Detalhes",
    "section_details_desc": "Nomeie esta política e defina a prioridade (a mais alta vence quando mais de uma corresponde a um usuário).",
    "section_identity_title": "Identidade",
    "section_identity_desc": "Aplica-se a todos ou restrinja a grupos ou usuários específicos.",
    "section_settings_title": "Configurações",
    "section_settings_desc": "Os controles de navegador que esta política aplica.",
    "section_login_restrictions_title": "Restrições de login",
    "section_login_restrictions_desc": "Faça o Tuvis Browser aplicar o próprio cabeçalho de restrição de tenant do fornecedor no login dos aplicativos abaixo, para que o fornecedor aceite apenas as contas listadas. O Tuvis aplica o cabeçalho; o fornecedor faz a aplicação.",
    "login_restrictions_empty": "Nenhum aplicativo do catálogo suporta restrições de login ainda.",
    "login_restrictions_personal_note": "Contas pessoais não têm um ID de workspace ou organização, por isso não podem ser adicionadas a esta lista. Para permitir o login com contas pessoais em {{app}}, deixe esta restrição desabilitada - quando habilitada, o Tuvis aplica o cabeçalho a cada login e o fornecedor faz a aplicação.",
    "login_restrictions_required_error": "Este campo é obrigatório para aplicar a restrição.",
    "corporate_domains_title": "Domínios corporativos",
    "corporate_domains_hint": "Domínios que o Tuvis Browser trata como corporativos ao classificar uma conta conectada no dispositivo. Usado para qualquer aplicativo desta política cuja restrição de login acima esteja desabilitada - a configuração usual quando você quer permitir uma conta pessoal mas ainda assim diferenciá-la de uma corporativa. O Tuvis lê e classifica o endereço no dispositivo; ele não bloqueia nem detecta uma conta por conta própria - sua política de DLP ou vigilância decide o que fazer com a classificação.",
    "corporate_domains_placeholder": "Domínios, um por linha (ex.: corp.com)",
    "control_chip_autofill_forms": "Sem preenchimento",
    "control_chip_password_manager": "Sem gerenciador senhas",
    "control_chip_autofill_cards": "Sem cartões",
    "control_chip_cast": "Sem Cast",
    "control_chip_devtools": "Sem DevTools",
    "control_chip_delete_history": "Sem excluir histórico",
    "control_chip_task_manager": "Ger. tarefas limitado",
    "control_chip_external_apps": "Sem apps externos",
    "control_chip_extensions": "Extensões",
    "updates_title": "Atualizações do navegador",
    "updates_hint": "Se este grupo recebe atualizações do Tuvis Browser e com que frequência.",
    "updates_unmanaged": "Não gerenciado (apenas indicador)",
    "updates_notify": "Recomendado: avisar o usuário",
    "updates_required": "Obrigatório: forçar a reinicialização",
    "updates_deadline_label": "Prazo (dias)",
    "updates_deadline_hint": "Dias desde que uma atualização fica disponível até a reinicialização ser aplicada. Deixe em branco para o padrão.",
    "updates_enabled": "Verificar atualizações",
    "updates_enabled_hint": "Desativado interrompe todas as verificações de atualização, incluindo o item de menu Verificar atualizações e a página Sobre. A política de MDM do dispositivo tem prioridade.",
    "updates_period_label": "Verificar a cada",
    "updates_period_hint": "Com que frequência cada navegador busca uma versão nova.",
    "updates_period_default": "Padrão do navegador (4 horas)",
    "updates_period_30": "30 minutos",
    "updates_period_60": "1 hora",
    "updates_period_240": "4 horas",
    "updates_period_720": "12 horas",
    "updates_period_1440": "Uma vez por dia",
    "updates_channel_label": "Canal de atualização",
    "updates_channel_hint": "Qual canal de versões este grupo segue. Use Beta para um grupo piloto.",
    "updates_channel_default": "Igual à versão instalada",
    "updates_channel_release": "Estável",
    "updates_channel_beta": "Beta",
    "updates_enforcement_label": "Aplicação de atualizações pendentes",
    "updates_enforcement_hint": "Com que firmeza o navegador aplica uma atualização já baixada.",
    "group_monitoring": "Integridade do monitoramento",
    "group_monitoring_hint": "Recursos que permitem ao usuário agir fora da visão do Tuvis. Revise primeiro.",
    "group_extensions": "Extensões",
    "group_extensions_hint": "Se os usuários podem instalar extensões e quais a sua organização força, permite ou bloqueia.",
    "group_data": "Movimentação de dados",
    "group_data_hint": "Downloads, acesso a arquivos, abertura de outros aplicativos e importação de outro navegador.",
    "group_autofill": "Preenchimento automático e senhas",
    "group_autofill_hint": "Dados de formulários salvos, cartões de pagamento e o gerenciador de senhas integrado.",
    "group_privacy": "Privacidade e telemetria",
    "group_privacy_hint": "Relatórios em segundo plano e tráfego de previsão que o navegador enviaria.",
    "group_device": "Acesso a dispositivos e hardware",
    "group_device_hint": "Localização, sensores e acesso direto ao hardware pelas páginas web.",
    "group_platform": "Plataforma web",
    "group_platform_hint": "Comportamento do navegador sem impacto em dados ou monitoramento. Pode ficar como está.",
    "allowUsageMetrics": "Permitir métricas de uso",
    "allowUsageMetrics_hint": "Controla se o navegador envia estatísticas de uso anonimizadas e relatórios de falhas ao Google. Desativado: nenhuma métrica ou relatório de falhas sai do dispositivo.",
    "allowSearchSuggestions": "Permitir sugestões de pesquisa",
    "allowSearchSuggestions_hint": "Controla se as teclas digitadas na barra de endereços são enviadas ao provedor de pesquisa para obter sugestões ao vivo. Desativado: nada do que é digitado sai do dispositivo até a pesquisa ser enviada.",
    "allowUrlKeyedDataCollection": "Permitir coleta de dados por URL",
    "allowUrlKeyedDataCollection_hint": "Controla se as URLs das páginas visitadas são enviadas ao Google para habilitar recursos como anotações de página. Desativado: as URLs visitadas não são enviadas.",
    "allowNetworkPrediction": "Permitir previsão de rede",
    "allowNetworkPrediction_hint": "Controla se o navegador faz pré-carregamento e pré-conexão com páginas antes do clique. Desativado: sem conexões especulativas em segundo plano.",
    "allowEnhancedSpellCheck": "Permitir verificação ortográfica aprimorada",
    "allowEnhancedSpellCheck_hint": "Controla se o texto digitado é enviado ao serviço de verificação ortográfica do Google para melhores sugestões. Desativado: a verificação ortográfica permanece no dispositivo.",
    "allowGeolocation": "Permitir acesso à localização",
    "allowGeolocation_hint": "Controla se os sites podem solicitar a localização geográfica do dispositivo. Desativado: as solicitações de localização são bloqueadas (os sites nunca veem onde você está).",
    "allowSensors": "Permitir sensores de movimento",
    "allowSensors_hint": "Controla se os sites podem ler os sensores de movimento e de luz ambiente. Desativado: o acesso aos sensores é bloqueado.",
    "allowWebUsb": "Permitir WebUSB",
    "allowWebUsb_hint": "Controla se os sites podem se conectar a dispositivos USB pela API WebUSB. Desativado: o acesso a dispositivos USB é bloqueado.",
    "allowWebBluetooth": "Permitir Web Bluetooth",
    "allowWebBluetooth_hint": "Controla se os sites podem se conectar a dispositivos Bluetooth pela API Web Bluetooth. Desativado: o acesso a dispositivos Bluetooth é bloqueado.",
    "allowSerialPorts": "Permitir portas seriais",
    "allowSerialPorts_hint": "Controla se os sites podem acessar as portas seriais pela API Web Serial. Desativado: o acesso às portas seriais é bloqueado.",
    "allowFileSystemRead": "Permitir leitura do sistema de arquivos",
    "allowFileSystemRead_hint": "Controla se os sites podem ler arquivos e pastas locais pela API File System Access. Desativado: os sites não podem ler arquivos locais.",
    "allowFileSystemWrite": "Permitir gravação no sistema de arquivos",
    "allowFileSystemWrite_hint": "Controla se os sites podem gravar em arquivos e pastas locais pela API File System Access. Desativado: os sites não podem gravar arquivos locais.",
    "allowQuic": "Permitir o protocolo QUIC",
    "allowQuic_hint": "Controla se o navegador usa o protocolo de transporte QUIC (baseado em UDP). Desativado: as conexões voltam a TCP/TLS, que alguns firewalls corporativos inspecionam de forma mais confiável.",
    "allowJavaScriptJit": "Permitir JIT do JavaScript",
    "allowJavaScriptJit_hint": "Controla se o mecanismo JavaScript V8 usa compilação just-in-time. Desativado: o JIT é desabilitado, reduzindo bastante a superfície de ataque do JavaScript com um pequeno custo de desempenho.",
    "allowPaymentMethodQuery": "Permitir consultas de métodos de pagamento",
    "allowPaymentMethodQuery_hint": "Controla se os sites podem verificar (pela API Payment Request) se você tem métodos de pagamento salvos. Desativado: os sites não podem fazer essa verificação.",
    "allowAutoplay": "Permitir reprodução automática",
    "allowAutoplay_hint": "Controla se os sites podem reproduzir áudio e vídeo automaticamente. Desativado: a mídia não é reproduzida até o usuário interagir.",
    "allowImportAutofill": "Permitir importar dados de preenchimento automático",
    "allowImportAutofill_hint": "Controla se dados de formulários e preenchimento automático podem ser importados de outro navegador. Desativado: a importação é bloqueada.",
    "allowImportBookmarks": "Permitir importar favoritos",
    "allowImportBookmarks_hint": "Controla se favoritos podem ser importados de outro navegador. Desativado: a importação é bloqueada.",
    "allowImportHistory": "Permitir importar histórico",
    "allowImportHistory_hint": "Controla se o histórico de navegação pode ser importado de outro navegador. Desativado: a importação é bloqueada.",
    "allowImportSavedPasswords": "Permitir importar senhas salvas",
    "allowImportSavedPasswords_hint": "Controla se senhas salvas podem ser importadas de outro navegador. Desativado: a importação é bloqueada.",
    "allowImportSearchEngine": "Permitir importar mecanismos de pesquisa",
    "allowImportSearchEngine_hint": "Controla se as configurações de mecanismo de pesquisa podem ser importadas de outro navegador. Desativado: a importação é bloqueada.",
    "allowExtensionInstall": "Permitir instalar extensões",
    "allowExtensionInstall_hint": "Controla se os usuários podem instalar extensões do navegador. Desativado: todas as extensões são bloqueadas, exceto as gerenciadas pela Tuvis (que são instaladas de forma forçada). Use a lista de permitidas abaixo para autorizar extensões específicas.",
    "allowExternalExtensions": "Permitir extensões externas",
    "allowExternalExtensions_hint": "Controla se são instaladas as extensões que outros aplicativos do dispositivo tentam adicionar (pelo registro do sistema ou pelo mecanismo de extensões externas). Desativado: os aplicativos não podem instalar extensões no navegador de forma silenciosa.",
    "summary_title": "Resumo",
    "summary_desc": "Reveja o que esta política aplica antes de guardar.",
    "summary_untitled": "Controlos sem título",
    "summary_unset": "Não definido",
    "summary_sentence_one": "Estes controlos aplicam-se a {{identity}}. Esta política define 1 deles; os restantes mantêm a configuração base da organização.",
    "summary_sentence_other": "Estes controlos aplicam-se a {{identity}}. Esta política define {{count}} deles; os restantes mantêm a configuração base da organização.",
    "summary_manages_nothing": "Esta política ainda não define nada, por isso tudo abaixo é a configuração base da organização e guardar não altera nada.",
    "summary_allowed": "Permitido",
    "summary_blocked": "Bloqueado",
    "summary_updates_on": "A verificar atualizações",
    "summary_updates_off": "Fixado na versão atual",
    "summary_default_search": "Motor de busca predefinido",
    "summary_corporate_domains": "Domínios corporativos",
    "summary_extension_count_one": "1 extensão",
    "summary_extension_count_other": "{{count}} extensões",
    "summary_login_restriction_count_one": "1 aplicação restringida",
    "summary_login_restriction_count_other": "{{count}} aplicações restringidas",
    "summary_domain_count_one": "1 domínio",
    "summary_domain_count_other": "{{count}} domínios",
    "summary_not_managed": "Não gerido",
    "summary_group_other": "Outras definições"
  },
  "applications_page": {
    "title": "Aplicativos",
    "predefined_title": "Aplicativos predefinidos",
    "predefined_hint": "Aplicativos integrados mantidos pela Tuvis. Somente leitura.",
    "custom_title": "Aplicativos personalizados",
    "custom_hint": "Aplicativos definidos para sua organização.",
    "categories_title": "Categorias",
    "categories_hint": "Agrupe aplicativos em categorias para as condições de Tráfego das Políticas de Acesso.",
    "manage_categories": "Gerenciar categorias",
    "tab_applications": "Aplicativos",
    "tab_categories": "Categorias",
    "type": "Tipo",
    "type_predefined": "Predefinido",
    "type_custom": "Personalizado",
    "search_placeholder": "Pesquisar aplicativos…",
    "filter_title": "Filtros",
    "categories_search_placeholder": "Pesquisar categorias…",
    "add_category": "Adicionar categoria",
    "edit_category": "Editar categoria",
    "category_name": "Nome da categoria",
    "create_application": "Adicionar aplicativo",
    "update_application": "Editar aplicativo",
    "delete_application": "Excluir aplicativo",
    "delete_application_modal_message": "Tem certeza de que deseja excluir este aplicativo?",
    "delete_category": "Excluir categoria",
    "delete_category_modal_message": "Tem certeza de que deseja excluir esta categoria?",
    "new_application_title": "Novo aplicativo",
    "edit_application_title": "Editar aplicativo",
    "section_details_title": "Detalhes",
    "section_details_desc": "Nome, padrões de correspondência e categorias deste aplicativo.",
    "name": "Nome",
    "patterns": "Padrões",
    "patterns_hint": "Um padrão de host por linha, ex.: *.salesforce.com",
    "patterns_placeholder": "*.salesforce.com",
    "categories": "Categorias",
    "categories_placeholder": "Selecionar categorias…",
    "icon_url": "URL do ícone",
    "icon_url_placeholder": "https://example.com/icon.png",
    "launch_url": "URL de abertura",
    "launch_url_placeholder": "https://example.com",
    "required": "Obrigatório",
    "save": "Salvar",
    "cancel": "Cancelar"
  },
  "device_posture_page": {
    "title": "Postura do dispositivo",
    "tab_baseline": "Linha de base",
    "tab_edr_agents": "Agentes EDR",
    "baseline_enable_label": "Exigir linha de base de postura",
    "baseline_hint": "Os dispositivos que não corresponderem a esta expressão são considerados não conformes.",
    "save": "Salvar",
    "predefined_agents_title": "Agentes EDR/antivírus predefinidos",
    "predefined_agents_hint": "Agentes EDR/antivírus integrados mantidos pela Tuvis. Somente leitura.",
    "custom_agents_title": "Agentes EDR/antivírus personalizados",
    "custom_agents_hint": "Agentes EDR/antivírus definidos para sua organização.",
    "agent_name": "Nome",
    "agent_paths": "Caminhos",
    "agent_paths_win": "Caminhos do Windows (um por linha)",
    "agent_paths_mac": "Caminhos do macOS (um por linha)",
    "agent_paths_linux": "Caminhos do Linux (um por linha)",
    "add_agent": "Adicionar agente",
    "edit_agent": "Editar agente",
    "delete_agent": "Excluir agente",
    "delete_agent_modal_message": "Tem certeza de que deseja excluir este agente?"
  },
  "devices_page": {
    "title": "Dispositivos",
    "hint": "Inventário de hardware e última conformidade de postura dos dispositivos com Tuvis Browser da organização.",
    "user": "Usuário",
    "filter_title": "Filtros",
    "filter_os": "Sistema operacional",
    "filter_user": "Usuário",
    "filter_disk_encryption": "Criptografia de disco",
    "show_archived": "Mostrar arquivados",
    "archive": "Arquivar",
    "unarchive": "Desarquivar",
    "status": "Status",
    "archived": "Arquivado",
    "device": "Dispositivo",
    "os": "SO",
    "tuvis_version": "Versão do Tuvis",
    "extension_version": "Versão da extensão",
    "cpu": "CPU",
    "ram": "RAM",
    "disk": "Disco",
    "compliant": "Conforme",
    "last_seen": "Visto por último",
    "empty_state": "Nenhum dispositivo informado até agora.",
    "detail_title": "Detalhes do dispositivo",
    "search_empty": "Nenhum dispositivo corresponde à sua pesquisa",
    "refresh": "Atualizar",
    "detail_section_user": "Usuário",
    "detail_section_device": "Dispositivo",
    "detail_section_hardware": "Hardware",
    "detail_section_posture": "Postura",
    "detail_section_extensions": "Extensões",
    "detail_name": "Nome",
    "detail_model": "Modelo",
    "detail_hostname": "Nome do host",
    "detail_serial": "Número de série",
    "detail_os": "Sistema operacional",
    "detail_last_seen": "Visto por último",
    "detail_device_id": "ID do dispositivo",
    "detail_cpu": "CPU",
    "detail_memory": "Memória",
    "detail_disk": "Disco",
    "detail_compliance": "Conformidade",
    "detail_failed_checks": "Verificações com falha",
    "detail_signal_disk_encryption": "Criptografia de disco",
    "detail_signal_screen_lock": "Bloqueio de tela",
    "detail_signal_firewall": "Firewall",
    "detail_signal_secure_boot": "Inicialização segura",
    "detail_signal_av": "Antivírus / EDR",
    "detail_compliant": "Em conformidade",
    "detail_non_compliant": "Não conforme",
    "tristate_enabled": "Habilitado",
    "tristate_disabled": "Desabilitado",
    "tristate_unknown": "Desconhecido",
    "detail_not_reported": "Não informado",
    "detail_disk_value": "{{free}} livres de {{total}}",
    "detail_cpu_full": "{{model}} · {{cores}} núcleos · {{arch}}",
    "detail_cpu_cores": "{{model}} ({{cores}} núcleos)",
    "detail_account_detection_title": "Detecção de conta",
    "detail_account_detection_status_ok": "OK",
    "detail_account_detection_status_no_match": "Sem correspondência",
    "detail_account_detection_status_error": "Erro",
    "detail_account_detection_last_result": "Última detecção",
    "detail_extension_item": "{{name}} ({{version}}) - {{installType}}",
    "detail_tuvis_version": "Versão do Tuvis Browser",
    "detail_extension_version": "Versão da extensão de monitoramento"
  },
  "extensions_page": {
    "title": "Extensões",
    "hint": "Inventário unificado das extensões do navegador na frota do Tuvis Browser da organização, combinando o que é aplicado por política com o que é realmente observado nos dispositivos e atribuindo uma pontuação de risco.",
    "name": "Extensão",
    "risk": "Risco",
    "source": "Origem",
    "devices": "Dispositivos",
    "enabled": "Habilitadas",
    "policies": "Políticas",
    "state": "Estado",
    "empty_state": "Aguardando a atualização da extensão: a extensão de monitoramento precisa de uma nova versão para informar as extensões instaladas.",
    "empty_state_none_installed": "Nenhuma extensão está instalada em nenhum dispositivo que informa.",
    "awaiting_banner": "Nenhum dispositivo informou extensões instaladas até agora, portanto as linhas abaixo vêm apenas das suas políticas: os valores “Desconhecido” e “Forçada, não observada” são esperados até que a extensão de monitoramento publique uma nova versão.",
    "search_empty": "Nenhuma extensão corresponde à sua pesquisa",
    "refresh": "Atualizar",
    "detail_title": "Detalhes da extensão",
    "detail_risk": "Risco",
    "detail_reasons": "Motivos",
    "detail_permissions": "Permissões",
    "detail_enforcement": "Aplicação",
    "install_types": "Tipos de instalação",
    "permissions": "Permissões",
    "host_permissions": "Permissões de host",
    "assign": "Atribuir aos Controles do navegador",
    "add_extension": "Adicionar extensão",
    "add_title": "Adicionar extensão à lista",
    "edit_title": "Editar extensão",
    "delete": "Excluir",
    "delete_extension": "Excluir extensão",
    "delete_extension_modal_message": "Tem certeza de que deseja remover esta extensão da lista mantida manualmente?",
    "extension_id": "ID da extensão",
    "extension_name": "Nome",
    "notes": "Notas",
    "source_manual": "Manual",
    "source_discovered": "Descoberto",
    "source_policy": "Da política",
    "no_longer_reported": "Nenhum dispositivo relata mais",
    "invalid_id": "Insira um ID de extensão válido de 32 caracteres",
    "risk_reason": {
      "sensitive_permission": "Permissão sensível: {{detail}}",
      "unrecognized_permission": "Permissão não reconhecida, pontuada de forma conservadora: {{detail}}",
      "global_host_access": "Pode ler e alterar dados em todos os sites",
      "specific_host_access": "Acesso a {{detail}} site(s) específico(s)",
      "install_type_not_policy": "Não instalada por política da organização (tipo de instalação: {{detail}})",
      "not_observed": "Não observada em nenhum dispositivo, portanto suas permissões são desconhecidas.",
      "from_last_report": "Pontuado a partir do último relatório desta extensão - nenhum dispositivo a relata mais."
    },
    "risk_total": "Total",
    "risk_total_capped": "Total (limitado de {{raw}})",
    "delete_blocked_by_policy": "Remova-a primeiro destas políticas de Controles do navegador: {{policies}}",
    "last_report_title": "Último relatório",
    "last_report_hint": "Nenhum dispositivo relata mais esta extensão. A versão, os tipos de instalação e as permissões abaixo - e a pontuação de risco - são do último relatório.",
    "last_seen": "Último relatório",
    "last_report_devices": "Dispositivos · usuários · ativadas (no último relatório)",
    "last_known_suffix": "último conhecido"
  },
  "saas_page": {
    "title": "Descoberta de SaaS",
    "hint": "Aplicativos SaaS usados na frota Tuvis Browser da organização, com status de catalogação, status de sanção e controle de licenças.",
    "app": "Aplicativo",
    "category": "Categoria",
    "catalogued": "Catalogado",
    "catalogued_yes": "Catalogado",
    "catalogued_no": "Não catalogado",
    "status": "Status",
    "status_unreviewed": "Não revisado",
    "status_sanctioned": "Sancionado",
    "status_unsanctioned": "Não sancionado",
    "users": "Usuários",
    "devices": "Dispositivos",
    "visits": "Visitas",
    "seats": "Licenças",
    "last_seen": "Última atividade",
    "empty_state": "Nenhum aplicativo SaaS reportado ainda.",
    "detail_title": "Detalhes do aplicativo",
    "search_empty": "Nenhum aplicativo SaaS corresponde à sua pesquisa",
    "refresh": "Atualizar",
    "usage_section": "Uso",
    "governance_section": "Governança",
    "filter_category_all": "Todas as categorias",
    "filter_status_all": "Todos os status",
    "filter_catalogued_all": "Todos os aplicativos",
    "filter_catalogued_yes": "Catalogados",
    "filter_catalogued_no": "Não catalogados",
    "license_seats": "Licenças",
    "license_cost": "Custo",
    "license_renewal_date": "Data de renovação",
    "license_notes": "Notas",
    "save": "Salvar",
    "chart_top_apps": "Principais aplicativos por usuários",
    "chart_categories": "Usuários por categoria",
    "chart_over_time": "Uso ao longo do tempo",
    "chart_top_apps_tooltip": "Os aplicativos com maior alcance na sua organização: quantas pessoas DISTINTAS abriram cada um no intervalo de datas selecionado, e não quantas visitas fizeram.",
    "chart_categories_tooltip": "Como o uso de SaaS da sua organização se divide entre as categorias de aplicativos, contando pessoas distintas por categoria. Visitas a aplicativos fora do catálogo são agrupadas como Sem categoria.",
    "chart_over_time_tooltip": "Atividade de SaaS no intervalo de datas selecionado: pessoas distintas por dia e o total de visitas que fizeram.",
    "category_uncategorized": "Sem categoria",
    "users_section": "Usuários",
    "no_users": "Nenhum usuário reportado ainda.",
    "users_section_count": "Usuários ({{count}})",
    "col_user": "Usuário",
    "date_filter_title": "Intervalo de datas",
    "log": "Histórico",
    "last_changed": "Última alteração"
  },
  "customization_page": {
    "title": "Personalização",
    "tab_start_page": "Página inicial",
    "tab_branding": "Identidade visual",
    "tab_block_page": "Página de bloqueio",
    "block_page_coming_soon": "A personalização da página de bloqueio estará disponível em breve."
  },
  "start_page_page": {
    "title": "Página inicial",
    "create_layout": "Adicionar layout",
    "update_layout": "Editar layout",
    "delete_layout": "Excluir layout",
    "delete_layout_modal_message": "Tem certeza de que deseja excluir este layout?",
    "new_layout_title": "Novo layout da página inicial",
    "edit_layout_title": "Editar layout da página inicial",
    "identity_everyone": "Todos",
    "section_details_title": "Detalhes",
    "section_details_desc": "Dê um nome a este layout da página inicial.",
    "section_identity_title": "Identidade",
    "section_identity_desc": "Aplicar a todos ou restringir a grupos ou usuários específicos.",
    "section_sections_title": "Seções",
    "section_sections_desc": "Agrupe os atalhos de aplicativos em seções exibidas na página inicial da nova aba.",
    "section_branding_title": "Identidade visual",
    "section_branding_desc": "Personalize o logotipo e o plano de fundo exibidos na página inicial. A identidade visual é definida para toda a organização e compartilhada entre todos os layouts.",
    "name": "Nome",
    "priority": "Prioridade",
    "section_title_placeholder": "Título da seção",
    "section_apps_placeholder": "Selecionar aplicativos…",
    "add_section": "Adicionar seção",
    "logo_url": "URL do logotipo",
    "logo_url_placeholder": "https://example.com/logo.png",
    "background": "Plano de fundo",
    "background_placeholder": "#0b1220 ou https://example.com/background.png",
    "required": "Obrigatório",
    "save": "Salvar",
    "cancel": "Cancelar"
  },
  "browser_url_policies_page": {
    "title": "Políticas de acesso",
    "nav_group_title": "Navegador Tuvis",
    "name": "Nome",
    "action": "Ação",
    "conditions": "Condições",
    "controls": "Controles",
    "order": "Ordem",
    "create_policy": "Nova Política",
    "update_policy": "Editar política",
    "delete_policy": "Excluir política",
    "delete_policy_modal_message": "Tem certeza de que deseja excluir esta política de URL do navegador?",
    "new_policy_title": "Criar política de acesso",
    "edit_policy_title": "Editar política de acesso",
    "action_allow": "Permitir",
    "action_block": "Bloquear",
    "save": "Salvar",
    "cancel": "Cancelar",
    "enabled": "Habilitada",
    "section_details_title": "Detalhes",
    "section_details_desc": "Dê um nome a esta política e escolha se ela permite ou bloqueia o tráfego correspondente.",
    "section_traffic_title": "Tráfego",
    "section_traffic_desc": "Corresponda a navegação por host, URL ou categoria.",
    "section_identity_title": "Identidade",
    "section_identity_desc": "Aplica-se a todos ou restrinja a grupos ou usuários específicos.",
    "section_posture_title": "Postura do dispositivo",
    "section_account_title": "Conta (opcional)",
    "section_account_desc": "Restrinja esta política a um tipo específico de conta com sessão iniciada na aplicação.",
    "account_hint": "Corresponde de acordo com a conta que está com sessão iniciada na aplicação. O Tuvis lê a conta conectada neste dispositivo para decidir qual política se aplica; sua política de DLP decide o que é bloqueado.",
    "account_type_label": "Tipo de conta",
    "account_domain_label": "Domínio da conta",
    "account_type_corporate": "Corporativa",
    "account_type_personal": "Pessoal",
    "account_type_unknown": "Desconhecida (ainda não foi lida neste dispositivo)",
    "unknown_reference": "{{id}} — não existe mais",
    "unknown_reference_count": "{{count}} desconhecido",
    "account_gate_needs_application": "Esta condição precisa de pelo menos uma aplicação selecionada em Tráfego: o Tuvis lê a conta conectada por aplicação, então uma condição de conta não pode ser aplicada sem uma.",
    "account_gate_needs_unknown": "Nenhuma política habilitada admite uma conta desconhecida para {{application}}. Adicione uma política - ou uma condição aqui - que permita uma conta desconhecida (tipo de conta é desconhecido), para que um dispositivo em que a conta ainda não foi lida, ou que acabou de trocar de conta, não seja bloqueado.",
    "account_summary_chip": "Conta",
    "section_controls_title": "Controles",
    "section_controls_desc": "Monitoramento e aplicação aplicados ao tráfego permitido.",
    "priority": "Prioridade",
    "description": "Descrição",
    "summary_title": "Resumo",
    "summary_desc": "Revise a política antes de salvar.",
    "summary_untitled": "Política sem título",
    "summary_sentence": "Esta política vai {{action}} o tráfego que corresponder a {{traffic}} para {{identity}}.",
    "summary_unset": "Não definido",
    "required": "Obrigatório",
    "summary_none": "Nenhum",
    "control_dlp": "Verificação DLP",
    "control_surveillance": "Verificação de vigilância",
    "control_fraud": "Captura de fraude",
    "control_mask": "Mascarar dados sensíveis",
    "control_mask_hint": "Oculta números de cartão, SSN, IBAN, e-mails e números de telefone exibidos na página.",
    "control_watermark": "Marca d'água na página",
    "control_watermark_hint": "Sobrepõe o e-mail do usuário e um carimbo de data/hora em toda a página.",
    "control_protect_download": "Proteger downloads com senha",
    "control_download_password_placeholder": "Senha do download",
    "control_block_print": "Bloquear impressão",
    "control_block_clipboard": "Bloquear área de transferência (copiar/colar)",
    "control_block_microphone": "Bloquear microfone",
    "control_block_camera": "Bloquear câmera",
    "control_block_screen_capture": "Bloquear captura de tela",
    "control_inject_elite_token": "Injetar token de segurança elite",
    "control_inject_elite_token_hint": "Adiciona o cabeçalho do token de segurança elite da organização e o user-agent às solicitações nas páginas correspondentes.",
    "control_dlp_hint": "Analisa uploads, downloads e texto digitado de acordo com suas políticas de DLP e bloqueia o que as violar.",
    "control_surveillance_hint": "Registra o conteúdo da página para revisão de conformidade. Nunca bloqueia o usuário.",
    "control_fraud_hint": "Verifica os arquivos baixados e enviados no serviço de hash de fraude/malware e bloqueia arquivos maliciosos conhecidos.",
    "control_block_print_hint": "Impede imprimir a página: o atalho de impressão, o menu, o clique direito e window.print() ficam desativados.",
    "control_block_clipboard_hint": "Impede copiar da página e colar nela.",
    "control_block_microphone_hint": "Bloqueia o acesso da página ao microfone.",
    "control_block_camera_hint": "Bloqueia o acesso da página à câmera.",
    "control_block_screen_capture_hint": "Bloqueia capturas de tela, gravação de tela e getDisplayMedia enquanto este site for a aba ativa.",
    "control_protect_download_hint": "Reempacota os downloads das páginas correspondentes como um zip criptografado com AES que abre com a senha abaixo.",
    "control_chip_dlp": "DLP",
    "control_chip_surveillance": "Vigil.",
    "control_chip_fraud": "Fraude",
    "control_chip_mask": "Ocultar",
    "control_chip_watermark": "Marca",
    "control_chip_print": "Impr.",
    "control_chip_clipboard": "Áreatr.",
    "control_chip_microphone": "Micro",
    "control_chip_camera": "Câmera",
    "control_chip_screen_capture": "Captura",
    "control_chip_elite": "Elite",
    "control_chip_password": "Senha",
    "disable_request_review": "Desativar a solicitação de acesso",
    "import_desktop": "Importar padrões do desktop",
    "import_desktop_done": "Foram criadas {{created}} políticas de acesso (incluindo {{imported}} das suas políticas de URL existentes), o controlo de navegador com os limites do desktop e uma página inicial correspondente.",
    "import_desktop_exists": "Esta organização já está configurada. Remova primeiro as suas políticas de acesso e controlos de navegador, ou substitua-os.",
    "import_desktop_failed": "Não foi possível importar os padrões do desktop.",
    "import_desktop_replace_title": "Substituir o que esta organização tem?",
    "import_desktop_replace_body": "Esta organização tem {{count}} políticas de acesso. Importar os padrões do desktop remove-as, juntamente com os seus controlos de navegador e páginas iniciais, e cria um conjunto novo.",
    "import_desktop_replace_ok": "Substituir",
    "import_desktop_replace_cancel": "Manter",
    "import_desktop_fresh_body": "Cria uma política de acesso por cada aplicação que a aplicação de desktop da Tuvis permitia - o seu CRM, WhatsApp, Telegram e Tuvis - mais uma regra que bloqueia todo o resto, os controlos de navegador do desktop e uma página inicial com essas aplicações."
  },
  "browser_notifications_page": {
    "title": "Notificações",
    "access_request_title": "Solicitações de acesso",
    "access_request_description": "Enviado por e-mail quando alguém solicita acesso a um site bloqueado. A solicitação aparece na fila de Solicitações de acesso mesmo que ninguém receba e-mail.",
    "recipients_placeholder": "Digite um endereço de e-mail e pressione Enter",
    "nobody_emailed": "Ninguém recebe e-mail. As solicitações continuam aparecendo na fila.",
    "invalid_email": "{{email}} não é um endereço de e-mail válido",
    "save": "Salvar",
    "saved": "Destinatários salvos",
    "save_failed": "Não foi possível salvar os destinatários"
  },
  "dlp_page": {
    "bulk_update": {
      "success": "Atualizados com sucesso {{numOfIncidents}} incidentes",
      "failed": "Falha ao atualizar os incidentes"
    },
    "unassigned": "Não atribuído",
    "is_group": "É Grupo",
    "true": "Verdadeiro",
    "false": "Falso",
    "created_at": "Criado em",
    "updated_at": "Atualizado em",
    "final_action": "Ação final",
    "sent": "Enviado",
    "blocked": "Bloqueado",
    "filters": {
      "title": "Filtrar Incidentes",
      "show_incidents_related_to_me": "Mostrar incidentes relacionados a mim",
      "file_only_corrupted_or_encrypted": "Mostrar incidentes com arquivo corrompido ou criptografado",
      "hide_incidents_with_keyword_campaigns": "Ocultar incidentes que correspondam a palavras-chave"
    },
    "incidents": "Incidentes",
    "pii_categories": {
      "AuthToken": "Token de autenticação",
      "AwsCredentials": "Chaves de acesso à conta da Amazon Web Services (AWS)",
      "AzureAuthToken": "Token de autenticação do Microsoft Azure",
      "BasicAuthHeader": "Cabeçalho de autenticação básica HTTP",
      "EncryptionKey": "Chave de criptografia",
      "GcpApiKey": "Chave de API do Google Cloud Platform (GCP)",
      "GcpCredentials": "Credenciais de conta de serviço do Google Cloud Platform (GCP)",
      "HttpCookie": "Cookie HTTP",
      "JsonWebToken": "Token Web JSON (JWT)",
      "OauthClientSecret": "Segredo do cliente OAuth",
      "Password": "Senha",
      "SslCertificate": "Certificado SSL",
      "StorageSignedPolicyDocument": "Documento de política assinada de armazenamento na nuvem",
      "StorageSignedUrl": "URL assinada de armazenamento na nuvem",
      "WeakPasswordHash": "Hash de senha fraco",
      "XsrfToken": "Token de falsificação de solicitação entre sites (CSRF)",
      "Age": "Idade",
      "Email": "Email",
      "Date": "Data",
      "Organization": "Organização",
      "Person": "Pessoa",
      "PhoneNumber": "Número de Telefone",
      "Address": "Endereço",
      "IPAddress": "Endereço IP",
      "URL": "URL",
      "CreditCardNumber": "Número do Cartão de Crédito",
      "SwiftCode": "Código SWIFT",
      "InternationalBankingAccountNumber": "Número Internacional de Conta Bancária (IBAN)",
      "ABARoutingNumber": "Número de Roteamento ABA",
      "ARNationalIdentityNumber": "Número de Identidade Nacional da Argentina (DNI)",
      "ATIdentityCard": "Cartão de Identidade da Áustria",
      "ATTaxIdentificationNumber": "Número de Identificação Fiscal da Áustria",
      "ATValueAddedTaxNumber": "Número de Identificação Fiscal da Áustria (VAT)",
      "AUBankAccountNumber": "Número da Conta Bancária da Austrália",
      "AUBusinessNumber": "Número da Empresa Australiana",
      "AUCompanyNumber": "Número da Empresa Australiana",
      "AUDriversLicenseNumber": "Número da Carteira de Motorista da Austrália",
      "AUMedicalAccountNumber": "Número da Conta Médica da Austrália",
      "AUPassportNumber": "Número do Passaporte da Austrália",
      "AUTaxFileNumber": "Número do Arquivo Fiscal da Austrália",
      "AzureDocumentDBAuthKey": "Chave de Autenticação do Azure DocumentDB",
      "AzureIaasDatabaseConnectionAndSQLString": "String de Conexão de Banco de Dados Azure IAAS e String de Conexão Azure SQL",
      "AzureIoTConnectionString": "String de Conexão Azure IoT",
      "AzurePublishSettingPassword": "Senha de Configuração de Publicação do Azure",
      "AzureRedisCacheString": "String de Conexão de Cache Azure Redis",
      "AzureSAS": "Azure SAS",
      "AzureServiceBusString": "String de Conexão do Serviço Azure Bus",
      "AzureStorageAccountGeneric": "Chave da Conta de Armazenamento Azure (Genérica)",
      "AzureStorageAccountKey": "Chave da Conta de Armazenamento Azure",
      "BENationalNumber": "Número Nacional da Bélgica",
      "BENationalNumberV2": "Número Nacional da Bélgica V2",
      "BEValueAddedTaxNumber": "Número de Identificação Fiscal da Bélgica (VAT)",
      "BGUniformCivilNumber": "Número Civil Uniforme da Bulgária",
      "BrcpfNumber": "Número CPF do Brasil",
      "BRLegalEntityNumber": "Número da Entidade Legal do Brasil (CNPJ)",
      "BRNationalIdrg": "Número do RG Nacional do Brasil",
      "CABankAccountNumber": "Número da Conta Bancária do Canadá",
      "CADriversLicenseNumber": "Número da Carteira de Motorista do Canadá",
      "CAHealthServiceNumber": "Número do Serviço de Saúde do Canadá",
      "CAPassportNumber": "Número do Passaporte do Canadá",
      "CAPersonalHealthIdentification": "Número de Identificação de Saúde Pessoal do Canadá (PHIN)",
      "CASocialInsuranceNumber": "Número do Seguro Social do Canadá",
      "CHSocialSecurityNumber": "Número de Seguro Social do Chile",
      "CLIdentityCardNumber": "Número do Cartão de Identidade do Chile",
      "CNResidentIdentityCardNumber": "Número do Cartão de Identidade de Residente da China (PRC)",
      "CYIdentityCard": "Cartão de Identidade de Chipre",
      "CYTaxIdentificationNumber": "Número de Identificação Fiscal de Chipre",
      "CZPersonalIdentityNumber": "Número de Identificação Pessoal da República Tcheca",
      "CZPersonalIdentityV2": "Número de Identificação Pessoal da República Tcheca V2",
      "DEDriversLicenseNumber": "Número da Carteira de Motorista Alemã",
      "DEIdentityCardNumber": "Número do Cartão de Identidade da Alemanha",
      "DEPassportNumber": "Número do Passaporte da Alemanha",
      "DETaxIdentificationNumber": "Número de Identificação Fiscal da Alemanha",
      "DEValueAddedNumber": "Número de Identificação Fiscal da Alemanha (VAT)",
      "DKPersonalIdentificationNumber": "Número de Identificação Pessoal da Dinamarca",
      "DKPersonalIdentificationV2": "Número de Identificação Pessoal da Dinamarca V2",
      "DrugEnforcementAgencyNumber": "Número da Agência de Combate às Drogas dos EUA (DEA)",
      "EEPersonalIdentificationCode": "Código de Identificação Pessoal da Estônia",
      "Esdni": "DNI da Espanha",
      "PeruDni": "DNI do Peru",
      "ESSocialSecurityNumber": "Número de Seguro Social da Espanha (SSN)",
      "ESTaxIdentificationNumber": "Número de Identificação Fiscal da Espanha",
      "EUDebitCardNumber": "Número do Cartão de Débito da UE",
      "EUDriversLicenseNumber": "Número da Carteira de Motorista da UE",
      "EugpsCoordinates": "Coordenadas GPS da UE",
      "EUNationalIdentificationNumber": "Número de Identificação Nacional da UE",
      "EUPassportNumber": "Número do Passaporte da UE",
      "EUSocialSecurityNumber": "Número de Seguro Social da UE (SSN) ou ID equivalente",
      "EUTaxIdentificationNumber": "Número de Identificação Fiscal da UE (TIN)",
      "FIEuropeanHealthNumber": "Número Europeu de Saúde da Finlândia",
      "FINationalID": "Cartão de Identidade Nacional da Finlândia",
      "FINationalIDV2": "Cartão de Identidade Nacional da Finlândia V2",
      "FIPassportNumber": "Número do Passaporte da Finlândia",
      "FRDriversLicenseNumber": "Número da Carteira de Motorista da França",
      "FRHealthInsuranceNumber": "Número de Seguro Saúde da França",
      "FRNationalID": "Cartão de Identidade Nacional da França (CNI)",
      "FRPassportNumber": "Número do Passaporte da França",
      "FRSocialSecurityNumber": "Número de Seguro Social da França (INSEE)",
      "FRTaxIdentificationNumber": "Número de Identificação Fiscal da França (Numéro SPI)",
      "FRValueAddedTaxNumber": "Número de Identificação Fiscal da França (VAT)",
      "GRNationalIDCard": "Cartão de Identidade Nacional da Grécia",
      "GRNationalIDV2": "Cartão de Identidade Nacional da Grécia V2",
      "GRTaxIdentificationNumber": "Número de Identificação Fiscal da Grécia",
      "HKIdentityCardNumber": "Número do Cartão de Identidade de Hong Kong (HKID)",
      "HRIdentityCardNumber": "Número do Cartão de Identidade da Croácia",
      "HRNationalIDNumber": "Número Nacional de Identificação da Croácia",
      "HRPersonalIdentificationNumber": "Número de Identificação Pessoal da Croácia",
      "HRPersonalIdentificationOIBNumberV2": "Número de Identificação Pessoal da Croácia (OIB) V2",
      "HUPersonalIdentificationNumber": "Número de Identificação Pessoal da Hungria",
      "HUTaxIdentificationNumber": "Número de Identificação Fiscal da Hungria",
      "HUValueAddedNumber": "Número de Identificação Fiscal da Hungria (VAT)",
      "IDIdentityCardNumber": "Número do Cartão de Identidade da Indonésia (KTP)",
      "IEPersonalPublicServiceNumber": "Número de Serviço Público Pessoal da Irlanda (PPS)",
      "IEPersonalPublicServiceNumberV2": "Número de Serviço Público Pessoal da Irlanda (PPS) V2",
      "ILBankAccountNumber": "Número da Conta Bancária de Israel",
      "ILNationalID": "Identidade Nacional de Israel",
      "INPermanentAccount": "Número de Conta Permanente da Índia (PAN)",
      "INUniqueIdentificationNumber": "Número de Identificação Único da Índia (Aadhaar)",
      "ITDriversLicenseNumber": "Número da Carteira de Motorista da Itália",
      "ITFiscalCode": "Código Fiscal da Itália",
      "ITValueAddedTaxNumber": "Número de Identificação Fiscal da Itália (VAT)",
      "JPBankAccountNumber": "Número da Conta Bancária do Japão",
      "JPDriversLicenseNumber": "Número da Carteira de Motorista do Japão",
      "JPMyNumberCorporate": "\"My Number\" do Japão (Corporativo)",
      "JPMyNumberPersonal": "\"My Number\" do Japão (Pessoal)",
      "JPPassportNumber": "Número do Passaporte do Japão",
      "JPResidenceCardNumber": "Número do Cartão de Residência do Japão",
      "JPResidentRegistrationNumber": "Número de Registro de Residência do Japão",
      "JPSocialInsuranceNumber": "Número de Seguro Social do Japão (SIN)",
      "KRResidentRegistrationNumber": "Número de Registro de Residência da Coreia do Sul",
      "LTPersonalCode": "Código Pessoal da Lituânia",
      "LUNationalIdentificationNumberNatural": "Número de Identificação Nacional de Luxemburgo (Pessoas Naturais)",
      "LUNationalIdentificationNumberNonNatural": "Número de Identificação Nacional de Luxemburgo (Pessoas Jurídicas)",
      "LVPersonalCode": "Código Pessoal da Letônia",
      "MTIdentityCardNumber": "Número do Cartão de Identidade de Malta",
      "MTTaxIDNumber": "Número de Identificação Fiscal de Malta",
      "MYIdentityCardNumber": "Número do Cartão de Identidade da Malásia",
      "NLCitizensServiceNumber": "Número de Serviço aos Cidadãos dos Países Baixos",
      "NLCitizensServiceNumberV2": "Número de Serviço aos Cidadãos dos Países Baixos V2",
      "NLTaxIdentificationNumber": "Número de Identificação Fiscal dos Países Baixos",
      "NLValueAddedTaxNumber": "Número de Identificação Fiscal dos Países Baixos (VAT)",
      "NOIdentityNumber": "Número de Identidade da Noruega",
      "NZBankAccountNumber": "Número da Conta Bancária da Nova Zelândia",
      "NZDriversLicenseNumber": "Número da Carteira de Motorista da Nova Zelândia",
      "NZInlandRevenueNumber": "Número da Receita Interna da Nova Zelândia",
      "NZMinistryOfHealthNumber": "Número do Ministério da Saúde da Nova Zelândia",
      "NZSocialWelfareNumber": "Número do Bem-Estar Social da Nova Zelândia",
      "PHUnifiedMultiPurposeIDNumber": "Número de ID Múltiplo e Unificado das Filipinas",
      "PLIdentityCard": "Cartão de Identidade da Polônia",
      "PLNationalID": "Cartão Nacional de Identificação da Polônia",
      "PLNationalIDV2": "Cartão Nacional de Identificação da Polônia V2",
      "PLPassportNumber": "Número do Passaporte da Polônia",
      "PlregonNumber": "Número REGON da Polônia",
      "PLTaxIdentificationNumber": "Número de Identificação Fiscal da Polônia",
      "PTCitizenCardNumber": "Número do Cartão de Cidadão de Portugal",
      "PTCitizenCardNumberV2": "Número do Cartão de Cidadão de Portugal V2",
      "PTTaxIdentificationNumber": "Número de Identificação Fiscal de Portugal",
      "ROPersonalNumericalCode": "Código Numérico Pessoal da Romênia (CNP)",
      "RUPassportNumberDomestic": "Número do Passaporte Doméstico da Rússia",
      "RUPassportNumberInternational": "Número do Passaporte Internacional da Rússia",
      "SANationalID": "Identidade Nacional da África do sul",
      "SENationalID": "Identidade Nacional da Suécia",
      "SENationalIDV2": "Identidade Nacional da Suécia V2",
      "SEPassportNumber": "Número do Passaporte da Suécia",
      "SETaxIdentificationNumber": "Número de Identificação Fiscal da Suécia",
      "SGNationalRegistrationIdentityCardNumber": "Número do Cartão de Identidade de Registro Nacional de Cingapura",
      "SITaxIdentificationNumber": "Número de Identificação Fiscal da Eslovênia",
      "SIUniqueMasterCitizenNumber": "Número Único de Cidadão Mestre da Eslovênia",
      "SKPersonalNumber": "Número Pessoal da Eslováquia",
      "SQLServerConnectionString": "String de Conexão do SQL Server",
      "THPopulationIdentificationCode": "Código de Identificação da População da Tailândia",
      "TRNationalIdentificationNumber": "Número de Identificação Nacional da Turquia",
      "TWNationalID": "Cartão de Identificação Nacional de Taiwan",
      "TWPassportNumber": "Número do Passaporte de Taiwan",
      "TWResidentCertificate": "Certificado de Residência de Taiwan (ARC/TARC)",
      "UAPassportNumberDomestic": "Número do Passaporte Doméstico da Ucrânia",
      "UAPassportNumberInternational": "Número do Passaporte Internacional da Ucrânia",
      "UKDriversLicenseNumber": "Número da Carteira de Motorista do Reino Unido",
      "UKElectoralRollNumber": "Número do Registro Eleitoral do Reino Unido",
      "UKNationalHealthNumber": "Número do Serviço Nacional de Saúde do Reino Unido (NHS)",
      "UKNationalInsuranceNumber": "Número do Seguro Nacional do Reino Unido (NINO)",
      "UKUniqueTaxpayerNumber": "Número Único do Contribuinte do Reino Unido",
      "USBankAccountNumber": "Número da Conta Bancária dos EUA",
      "USDriversLicenseNumber": "Número da Carteira de Motorista dos EUA",
      "USIndividualTaxpayerIdentification": "Número de Identificação do Contribuinte Individual dos EUA (ITIN)",
      "USSocialSecurityNumber": "Número de Seguro Social dos EUA (SSN)",
      "UsukPassportNumber": "Número do Passaporte dos EUA ou do Reino Unido",
      "ZAIdentificationNumber": "Número de Identificação da África do sul"
    },
    "search_placeholder": "Pesquisar...",
    "title": "Data Loss Protection",
    "policy_name": "Nome da política",
    "export_yes": "Sim",
    "export_no": "Não",
    "export_rule_id": "ID da regra",
    "export_expressions": "Expressões",
    "export_pii": "Categorias de PII",
    "export_metadata": "Metadados",
    "export_create_incident": "Criar incidente",
    "export_scope": "Escopo",
    "export_message_type": "Tipo de mensagem",
    "export_file_conditions": "Condições de arquivo",
    "export_rules": "Regras",
    "rule_name": "Nome da regra",
    "severity": "Gravidade",
    "include": "Incluir",
    "exclude": "Excluir",
    "file_warning": "Aviso de arquivo",
    "create_an_incident": "Criar um incidente",
    "incident_severity": "Gravidade do incidente",
    "should_attach_msg_content": "Anexar conteúdo da mensagem e/ou arquivo",
    "custom_alert_message": "Mensagem de alerta personalizada",
    "custom_alert_message_placeholder": "Digite uma mensagem personalizada para exibir quando esta política bloquear uma mensagem",
    "priority": "Prioridade",
    "description": "Descrição",
    "comment": "Comentário",
    "action": "Ação",
    "action_taken": "Ação Tomada",
    "content": "Conteúdo da Mensagem",
    "created_by": "Criado por",
    "sender": "Remetente",
    "senderEmail": "E-mail do Remetente",
    "senderLogin": "Usuário do Remetente",
    "assignee": "Responsável designado",
    "senderPhone": "Número de Telefone do Remetente",
    "recipient": "Destinatário",
    "status": "Status",
    "createdAt": "Data de Criação do Incidente",
    "messageSentAt": "Mensagem Enviada em",
    "recipientPhone": "Número de Telefone do Destinatário",
    "attachment": "Anexos",
    "file_corrupted_or_encrypted": "Arquivo corrompido ou criptografado",
    "matched_expressions": "Expressões Correspondentes",
    "unique_matches_identified": "Correspondências Únicas Identificadas",
    "fileName": "Nome do Arquivo",
    "fileSize": "Tamanho do Arquivo",
    "fileType": "Tipo de Arquivo",
    "update_incident_status": "Estado do Incidente",
    "update_incident_status_desc": "Por favor, explique por que este incidente está {{ status }}:",
    "low": "Baixo",
    "medium": "Médio",
    "high": "Alto",
    "critical": "Crítico",
    "resolved": "Resolvido",
    "dismissed": "Dispensado",
    "new": "Novo",
    "enabled": "Ativado",
    "action_ALLOW": "Permitir",
    "action_BLOCK": "Bloquear",
    "delete_rule": "Excluir Regra",
    "delete_rule_modal_message": "Tem certeza de que deseja excluir esta regra de DLP?",
    "rule_in_use": "Regra em uso",
    "rule_in_use_description": "Esta regra está atualmente em uso por {{policies}} políticas e não pode ser excluída.",
    "update_rule": "Editar Regra",
    "create_rule": "Nova Regra",
    "delete_policy": "Excluir Política",
    "delete_policy_modal_message": "Tem certeza de que deseja excluir esta política de DLP?",
    "update_policy": "Editar Política",
    "create_policy": "Nova Política",
    "catch_all_policy_description": "Capturar tudo",
    "search_policies": "Pesquisar políticas",
    "no_policies_found": "Nenhuma política encontrada",
    "search_rules": "Pesquisar regras",
    "no_rules_found": "Nenhuma regra encontrada",
    "subscriptions": "Destinatários da notificação, separados por \",\"",
    "notify_by_email_when_policy_is_triggered": "Notificar por e-mail quando a política for acionada",
    "email_attachment_size_limit_tooltip": "Limite de anexos por e-mail: 5 MB.",
    "tabs": {
      "policies": "Políticas",
      "rules": "Regras"
    },
    "conditions": {
      "title": "Condições",
      "expressions": "Expressão",
      "user": "Usuário",
      "user_description": "Usuário == {{user}}",
      "user_all": "Todos os usuários",
      "group": "Grupo",
      "group_description": "Grupo == {{group}}",
      "mime_type": "Tipo de Arquivo",
      "mime_type_description": "Tipo de Arquivo == {{mimeType}}",
      "file_size": "Tamanho do Arquivo",
      "file_size_description": "Tamanho do Arquivo {{operator}} {{size}}",
      "file_size_placeholder": "Tamanho em bytes",
      "template": "Template de mensagem",
      "template_description": "Templates de mensagem criados através da Tuvis",
      "devtools": "Acesso ao DevTools",
      "devtools_description": "Tentativa de acesso às ferramentas de desenvolvedor",
      "and_between_conditions": "E",
      "direction_all": "Todas as mensagens",
      "direction_OUTBOUND": "Enviar Mensagens ⇨",
      "direction_OUTBOUND_description": "Mensagem {{msgType}} enviada",
      "direction_INBOUND": "Texto Recebido ⇦",
      "direction_INBOUND_description": "Texto da mensagem recebida",
      "direction_DOWNLOAD": "Baixar anexo ⇩",
      "direction_DOWNLOAD_description": "Anexo baixado",
      "direction_UPLOAD": "Enviar anexo ⇧",
      "direction_UPLOAD_description": "Anexo enviado",
      "PII": "Informação Pessoal Identificável (PII)",
      "rule": "DLP Regra",
      "image_unappropriate": "Imagem Inapropriada",
      "has_expression": "Contém expressão",
      "import_expression_csv": "Importar expressões de CSV",
      "expression": "Expressão",
      "expression_casesensitive": "Sensível a maiúsculas e minúsculas",
      "pii_category": "PII Categoria",
      "max_occurrences": "Ocorrências máximas",
      "count_unique_values_only": "Contar apenas valores únicos",
      "metadata": "Metadados",
      "metadata_key": "Chave de metadados",
      "metadata_value": "Valor",
      "delete_expression": "Excluir",
      "test_condition": "Testar",
      "or_between_expression": "OU",
      "description": "Descrição",
      "invalid_expression": "Expressão inválida",
      "internal_users": "Usuários Internos",
      "internal_users_description": "{{include}} Usuários Internos"
    },
    "operators": {
      "gt": "maior que (>)",
      "lt": "menor que (<)",
      "gte": "maior ou igual (≥)",
      "lte": "menor ou igual (≤)"
    },
    "outbound_message_types": {
      "text": "Texto",
      "event": "Evento",
      "order": "Pedido",
      "poll": "Enquete",
      "contact": "Contato"
    },
    "builder": {
      "create_title": "Criar Política de DLP",
      "edit_title": "Editar Política de DLP",
      "cancel": "Cancelar",
      "save_policy": "Salvar Política",
      "load_failed": "Falha ao carregar esta política.",
      "aria_clear": "Limpar {{label}}",
      "aria_open": "Abrir {{label}}",
      "steps": {
        "details": {
          "title": "Detalhes da Política",
          "description": "Defina as informações básicas, ação, notificações e comportamento de incidente para esta política."
        },
        "scope": {
          "title": "Escopo",
          "description": "Escolha a quem esta política se aplica."
        },
        "conditions": {
          "title": "Condições",
          "description": "Defina quando esta política deve ser acionada."
        },
        "summary": {
          "title": "Resumo da Política",
          "description": "Revise a política resultante antes de salvar."
        }
      },
      "scope": {
        "senderScopeLabel": "Escopo do remetente",
        "contactScopeLabel": "Escopo do contato",
        "allUsers": {
          "title": "Todos os Usuários",
          "description": "Aplique esta política a todos na organização."
        },
        "specificUsers": {
          "title": "Usuários Específicos",
          "description": "Aplique esta política apenas a usuários selecionados.",
          "selector": "Selecionar usuários"
        },
        "specificGroups": {
          "title": "Grupos de Usuários",
          "description": "Aplique esta política apenas a grupos selecionados.",
          "selector": "Selecionar grupos"
        },
        "anyContact": {
          "title": "Todos os Contatos",
          "description": "Aplique esta política ao falar com qualquer contato."
        },
        "internalUsers": {
          "title": "Usuários Internos",
          "description": "Aplique esta política ao falar com usuários internos (Tuvis)."
        },
        "externalContacts": {
          "title": "Contatos Externos",
          "description": "Aplique esta política ao falar com contatos externos."
        }
      },
      "message_type": {
        "title": "Tipo de Mensagem",
        "description": "Escolha a direção principal da mensagem que esta política deve inspecionar.",
        "outbound_selector": "Tipos de mensagens enviadas"
      },
      "file_conditions": {
        "title": "Condições de Arquivo",
        "description": "Restrinja a política a tipos ou tamanhos de arquivo específicos quando relevante."
      },
      "rules": {
        "title": "Regras de DLP",
        "description": "Combine regras de DLP existentes. Regras dentro de um grupo são OR. Grupos separados são AND.",
        "group_title": "Grupo de Regras {{number}}",
        "group_help": "Selecionar várias regras em um grupo significa lógica OR dentro desse grupo.",
        "add_group": "Adicionar Grupo de Regras"
      },
      "advanced": {
        "title": "Outras Condições",
        "description": "Aplique esta política a contextos adicionais de mensagens, como modelos e atividade do DevTools."
      },
      "summary": {
        "untitled_policy": "Política sem título",
        "policy_sentence": "Esta política vai {{action}} mensagens para {{scope}} quando {{conditions}}.",
        "surveillance_policy_sentence": "Esta política monitorará mensagens para {{scope}} quando {{conditions}}.",
        "no_scope_selection": "Nenhum usuário selecionado ainda",
        "no_conditions": "Nenhuma condição definida - esta política se aplica a todas as mensagens.",
        "no_notifications": "Sem e-mails de notificação",
        "outbound_types": "Tipos de mensagens enviadas: {{types}}",
        "file_types": "Tipos de arquivo: {{types}}",
        "file_size": "Tamanho do arquivo {{operator}} {{size}}"
      }
    },
    "rule_modal": {
      "steps": {
        "details": {
          "title": "Detalhes da regra",
          "description": "Defina as informações básicas desta regra."
        },
        "conditions": {
          "title": "Condições",
          "description": "Escolha e configure as verificações que esta regra deve executar."
        }
      },
      "condition_types": {
        "add_label": "Tipos de condição",
        "empty": "Selecione um tipo de condição para começar.",
        "has_expression": "Corresponde texto usando expressões regulares.",
        "PII": "Detecta categorias integradas de dados pessoais ou sensíveis.",
        "metadata": "Corresponde mensagens usando pares de chave e valor de metadados.",
        "image_unappropriate": "Sinaliza imagens inadequadas em conteúdo compartilhado."
      }
    },
    "required": "Obrigatório",
    "rules_load_failed": "Erro ao carregar as regras"
  },
  "submit": "Enviar",
  "download_tuvispace_page": {
    "description": "Faça o download do tuvis® e garanta a segurança, a eficiência e a conformidade de suas comunicações.\n",
    "download_mac": "Baixar para MacOS ({{appleType}})",
    "download_windows": "Ou baixar para Windows",
    "download_for": "Ou baixar para",
    "already_installed": "App tuvis® já instalado? Entre no seu espaço de trabalho agora!",
    "open_tuvispace": "Abrir tuvis®",
    "title": "tuvis®"
  },
  "sidecarNotifications": {
    "sidecar_disconnected": "Dispositivo desconectado",
    "sidecar_paired": "Dispositivo emparelhado",
    "sidecar_invited": "Convite enviado",
    "sidecar_phone_mismatch": "Número de telefone não correspondente",
    "title": "Notificações",
    "saveSettings": "Salvar configurações",
    "subHeader": "Notifique-me sobre...",
    "recipients": "Destinatários:",
    "recipients_text": "Adicione digitando o endereço de email ou procurando por nome (Use “,” para adicionar vários membros)",
    "saved_successfully": "As configurações de notificações foram salvas com sucesso",
    "saved_failed": "Falha ao salvar as configurações de notificações",
    "customInviteEmail": {
      "title": "Personalize sua invitação por e-mail",
      "description": "Personalize a invitação por e-mail para seu time. Você pode usar as seguintes variáveis no corpo do e-mail. As variáveis marcadas com * são obrigatórias.",
      "preview": "Visualizar e-mail",
      "dropzone": "Arraste e solte um arquivo HTML ou selecione um",
      "variables": {
        "invite_link": "Link de convite",
        "inviter_name": "Nome do convite",
        "inviter_email": "E-mail do convite",
        "channel_name": "Nome do canal",
        "expected_phone": "Telefone esperado"
      },
      "errors": {
        "invalid_html": "HTML inválido",
        "missing_variables": "Seu e-mail está faltando as seguintes variáveis obrigatórias: {{variables}}"
      }
    },
    "invite_email_first_connection_template": {
      "title": "Plantilla de invitação por e-mail para a primeira conexão",
      "description": "Selecione um arquivo HTML para usar como modelo de e-mail enviado como convite por e-mail para a primeira conexão."
    },
    "invite_email_reconnection_template": {
      "title": "Plantilla de invitação por e-mail para a reconexão",
      "description": "Selecione um arquivo HTML para usar como modelo de e-mail enviado como convite por e-mail para a reconexão."
    },
    "invite_email_first_connection_subject": {
      "title": "Assunto do E-mail de Primeiro Convite",
      "description": "Defina o assunto do e-mail de convite enviado pela primeira vez."
    },
    "invite_email_reconnection_subject": {
      "title": "Assunto do E-mail de Reconexão",
      "description": "Defina o assunto do e-mail de convite de reconexão."
    },
    "remove": "Remover",
    "select_file": "Selecione um arquivo",
    "default_support_email": {
      "title": "Email de suporte padrão",
      "description": "Se definido, este email será usado como o email de suporte padrão para convites do sidecar em vez do email do convite."
    },
    "orgConfigs": {
      "inviter_name": {
        "title": "Nome do convidante",
        "description": "Nome exibido como convidante nos e-mails de convite do Remote Sync. Deixe em branco para usar o nome do usuário que convida."
      }
    }
  },
  "sidecarCustomizations": {
    "title": "Personalizações",
    "saveSettings": "Salvar configurações",
    "saved_successfully": "Personalizações salvas com sucesso",
    "saved_failed": "Falha ao salvar personalizações",
    "remote_sync_custom_error_text": {
      "title": "Mensagem de erro personalizada de sincronização",
      "description": "Se definido, este texto será exibido abaixo do erro padrão do Remote Sync (ex.: Falha na sincronização) para direcionar os usuários ao contato de conformidade ou suporte."
    }
  },
  "sf_email_domain": {
    "update_successfully": "Atualizado com sucesso",
    "duplicate_domains_error": "Domínio de e-mail já existe. Por favor, use um domínio diferente.",
    "update_failure": "Falha ao atualizar",
    "partial_success": "{{insertedCount}} domínio(s) adicionado(s) com sucesso, {{duplicateCount}} duplicata(s) foram ignoradas"
  },
  "users_management": {
    "user_messages": "Mensagens do Usuário",
    "invite_to_remote_sync": "Convidar para o Tuvis Remote Sync",
    "invite_to_platform": "Convidar para a plataforma Tuvis",
    "invite_to_platform_tooltip": "Quando habilitado, os usuários receberão um convite por e-mail para participar da plataforma",
    "invite_to_desktop_and_extensions": "Convidar para os aplicativos de desktop e extensões do Tuvis",
    "invite_to_desktop_and_extensions_tooltip": "Quando habilitado, os usuários receberão um convite por e-mail para participar do aplicativo de desktop e das extensões do navegador do Tuvis"
  },
  "actions_find_accounts": "Encontrar Conta",
  "actions_create_new": "Criar Novo",
  "actions_create_button": "Criar",
  "super_admin_org_configs": {
    "generate": "Gerar",
    "last_updated_at": "Última atualização em",
    "title": {
      "entity": "Entity",
      "autoSync": "Auto Sync",
      "search": "Search",
      "layout": "Layout",
      "layoutLimits": "Limite de campos",
      "actions": "Actions",
      "apps": "Apps",
      "notifications": "Notifications",
      "security": "Security",
      "analytics": "Dashboard",
      "sidecars": "Remote Sync",
      "superAdmin": "Super Admin",
      "page_title": "Organization Settings",
      "general": "General Settings",
      "incidents_summary_email": "Resumo de incidentes",
      "org_admin": "Administrador da organização",
      "orgAdminMessageSync": "Sincronização de mensagens",
      "orgAdminRules": "Regras",
      "orgAdminUserManagement": "Gestão de usuários",
      "tuvisAdminChannels": "Canais",
      "tuvisAdminFeatures": "Recursos",
      "tuvisAdminMessagesSync": "Sincronização de mensagens",
      "tuvisAdminSecurity": "Segurança",
      "autoSyncCases": "Sincronização automática de casos",
      "autoSyncActivities": "Sincronização automática de atividades"
    },
    "confirm_changes": "Tem certeza de que deseja aplicar as seguintes alterações?",
    "reason_label": "Motivo das alterações",
    "reason_placeholder": "ex., Testando recurso para cliente X, Melhoria de desempenho...",
    "who_requested_label": "Quem solicitou",
    "who_requested_placeholder": "ex., Nome do cliente, ID do ticket...",
    "one_change_at_a_time_toast": "Apenas uma configuração pode ser alterada por vez. Reverta as outras alterações e tente novamente.",
    "view_opportunity_link": "Ver oportunidade",
    "view_opportunity_link_url": "#",
    "opportunity_link_label": "Link da oportunidade",
    "opportunity_link_placeholder": "Cole a URL da oportunidade do Salesforce",
    "import_configuration": "Importar Configuração",
    "importing_configuration": "Importando configuração de {{ orgName }}",
    "import_configuration_failed": "Falha ao importar configuração",
    "import_configuration_success": "Configuração importada com sucesso, clique em 'Salvar' para aplicar as alterações",
    "conflicts_with": "Conflita com",
    "conflict_banner": {
      "title": "Conflitos de Configuração Detectados",
      "description": "Ao habilitar {{enabled}}, as seguintes configurações foram desativadas:"
    },
    "configs": {
      "names": {
        "identityMergeKey": "Chave de mesclagem de identidade",
        "sf": "Salesforce",
        "msd": "Microsoft Dynamics",
        "allow_elite_token": "Permitir Token de Segurança Elite",
        "allow_im_templates": "Permitir modelos de mensagens",
        "show_only_wap_channels_in_desktop": "Exibir apenas canais do WhatsApp na área de trabalho",
        "hide_wap_channels_button_in_desktop": "Oculta o botão 'Canais' do WhatsApp",
        "hide_delete_conversation_button": "Oculta o botão 'Excluir conversa' do WhatsApp",
        "hide_block_contact_button": "Oculta o botão 'Bloquear contato' do WhatsApp",
        "limit_date_range_of_messages": "Período de histórico de mensagens",
        "org_partner": "Parceiro Organização",
        "phones_blocked_from_sync": "Bloquear números de telefone específicos",
        "available_crm": "CRM Disponível",
        "organizationName": "Nome da organização",
        "orgType": "Tipo de Organização",
        "description": "Descrição",
        "isActive": "Is Organization Active",
        "paidLicences": "Licenças Tuvis Desktop - Adquiridas",
        "exceededLicences": "Licenças Tuvis desktop - Permitidas",
        "isPOC": "Is In POC Trial",
        "POCExpiration": "POC Trial Expiration Date",
        "leadsdisplay": "Leads - Exibir",
        "leadscreate": "Leads - Criar",
        "contactscreate": "Contatos - Criar",
        "contactsdisplay": "Contatos - Exibir",
        "casesdisplay": "Casos - Exibir",
        "activitiesdisplay": "Atividades - Exibir",
        "hideleadprogresstopbar": "Leads - Ocultar barra superior de progresso",
        "enableautosynchidebutton": "Chat Sync - Ocultar botão",
        "enableautosyncfiles": "Arquivos - Ativar sincronização automática",
        "autosynclimittomaxfilesize": "Arquivos - Tamanho máximo de sincronização",
        "activitiescreate": "Atividades - Criar",
        "hidesearchonmessenger": "Hide Search on Messenger",
        "tasksdisplay": "Tarefas - Exibir",
        "appshidegooglemeet": "Ocultar Google Meet",
        "appshidemsteams": "Ocultar MS Teams",
        "taskscreate": "Tarefas - Criar",
        "casescreate": "Casos - Criar",
        "hideopportunitytopbar": "Oportunidades - Ocultar barra de progresso superior",
        "hidesearchongoogle": "Hide Search on Google",
        "hidesearchonlinkedin": "Hide Search on LinkedIn",
        "appshidedocusign": "Ocultar DocuSign",
        "enableautosyncalwayson": "Chat Sync - Ligado por padrão",
        "appshideall": "Ocultar diretório de aplicativos",
        "appshideallvideoapps": "Ocultar todos os aplicativos de vídeo",
        "allowuserstograntsupportaccess": "Allow users to grant support access",
        "appshidezoom": "Ocultar Zoom",
        "serverlocation": "Server Location",
        "hideedittemplatesbuttons": "Modelos dinâmicos - Ocultar Editar",
        "hidenewtemplatebutton": "Modelos dinâmicos - Ocultar Criar",
        "sendalertsuserloggedout": "Send Alerts - USER_LOGGED_OUT",
        "sendalertsuseruninstalledextension": "Send Alerts - USER_UNINSTALLED_EXTENSION",
        "sentalertsuserturnedautosyncoff": "Send Alerts - USER_TURNED_AUTO_SYNC_OFF",
        "sentalertsuserturnedautosyncon": "Sent Alerts - USER_TURNED_AUTO_SYNC_ON",
        "sentalertsapicurrentlydisabled": "Send Alerts - API_CURRENTLY_DISABLED",
        "sentalertsapexrestservicesdisabled": "Send Alerts - APEX_REST_SERVICES_DISABLED",
        "fileuploadshidecompletely": "File Uploads to CRM - Hide Option Completely",
        "hideaccountbox": "Contatos - Ocultar informações da conta",
        "hidetemplatesbutton": "Modelos dinâmicos - Ocultar",
        "multichannellimitchannels": "Limite de múltiplos canais",
        "hidenavigatetoaddress": "Hide Navigate to Address",
        "hidesearchonfacebook": "Hide Search on Facebook",
        "hidecallbutton": "Hide Call button",
        "auto_sync_groups_default": "Grupos - Sincronização automática sempre ativada",
        "hide_whatsapp_filters": "Hide WhatsApp Filters",
        "block_unknown_person_per_role": "Bloquear pessoa desconhecida por função",
        "allow_inviting_users": "Permitir o convite de usuários",
        "show_chat_now_action": "Converse agora - Habilitar",
        "auto_sync_activities__enabled": "Sincronização automática de Atividades - Ativada",
        "auto_sync_activities__show_run_now_button": "Sincronização automática de Atividades - Mostrar botão \"Executar agora\"",
        "auto_sync_activities__task_completed_status": "Sincronização automática de Atividades - Alterar status",
        "auto_sync_activities__task_subject": "Sincronização Automática de Atividades - Assunto",
        "show_auto_sync_button_per_profile": "Show Auto Sync Button Per Profile",
        "show_edit_layout_per_profile": "Show Edit Layout Per Profile",
        "show_chat_summarize_action": "AI - Show Chat Summarize Action",
        "enable_widget_ai_assistant": "Assistente de IA VIS",
        "create_case_opportunity_field_name": "Casos - Oportunidade Relacionada",
        "allow_edit_layout_drag_and_drop": "Allow edit layout drag and drop",
        "show_admin_notifications_tab": "Aba de notificações do administrador",
        "allow_desktop_lite": "Desktop Lite",
        "disable_save_as_at_desktop": "Restringir downloads de arquivos",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "block_whatsapp_calls": "WhatsApp - Bloquear chamadas no Android",
        "delete_crm_session_on_logout_in_desktop": "Outros - Excluir sessão do CRM ao deslogar",
        "layout_limits_case": "Limite de campos - Caso",
        "layout_limits_lead": "Limite de campos - Lead",
        "layout_limits_contact": "Limite de campos - Contato",
        "layout_limits_task": "Limite de campos - Nova atividade",
        "layout_limits_activity": "Limite de campos - Atividade",
        "layout_limits_account": "Limite de campos - Conta",
        "layout_limits_person_account": "Limite de campos - Conta pessoal",
        "layout_limits_event": "Limite de campos - Evento",
        "layout_limits_opportunity": "Layout Limits - Opportunity",
        "layout_limits__new_activity": "Limite de campos - Nova atividade",
        "layout_limits__new_case": "Limite de campos - Novo caso",
        "set_whatid__accountid__new_task_and_activity": "Outros - Definir AccountId como WhatId",
        "allow_platform_integrations": "Integrações",
        "layout_limits__new_event": "Limite de campos - Novo evento",
        "layoutlimitsnewopportunity": "Layout Limits - New Opportunity",
        "layout_limits__new_person_account": "Limite de campos - Nova conta pessoal",
        "opps__display__per_profile": "Opps - Display - Per Profile",
        "enable_auto_sync__always_on__per_profile": "Enable Auto-Sync - Always On - Per Profile",
        "contacts__create__per_profile": "Contacts - Create - Per Profile",
        "enable_groups_auto_sync__always_on__per_profile": "Enable Groups Auto-Sync - Always On - Per Profile",
        "leads__display__per_profile": "Leads - Display - Per Profile",
        "leads__create__per_profile": "Leads - Create - Per Profile",
        "contacts__display__per_profile": "Contacts - Display - Per Profile",
        "activities__display__per_profile": "Activities - Display - Per Profile",
        "activities__create__per_profile": "Activities - Create - Per Profile",
        "create_person_account__per_profile": "Create Person Account - Per Profile",
        "tasks__display__per_profile": "Tasks - Display - Per Profile",
        "tasks__create__per_profile": "Tasks - Create - Per Profile",
        "cases__create__per_profile": "Cases - Create - Per Profile",
        "cases__display__per_profile": "Cases - Display - Per Profile",
        "show_person_account__per_profile": "Show Person Account - Per Profile",
        "auto_sync_files__allow_message_types": "Arquivos - Validação por tipo",
        "auto_sync_files__allow_media_mime_types": "Arquivos - Validação por tipos MIME",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "Arquivos - Não sincronizar se não passar na validação",
        "use_new_message_sync_code": "Use New Message Sync Code",
        "ignore_chat_now_logic": "Ignore Chat Now Logic",
        "auto_sync_message_updates": "Sincronização ao atualizar mensagens",
        "auto_sync_message_on_status_change": "Sincronização ao alterar o status da mensagem",
        "default_notifications_over_due_only": "Default Notifications Over Due Only",
        "prefix_phone_number_to_remove": "Outros - Remover número de telefone com prefixo",
        "chat_now_modal_no_contact": "Chat Now Modal No Contact",
        "allow_platform_settings": "Allow Platform Settings",
        "allow_create_support_case": "Allow Create Support Case",
        "blur_contact_on_block_unknown_person": "Desfocar conversa de pessoa desconhecida",
        "allow_platform_global_layout": "Layout global",
        "allow_platform_admin_notifications": "Notificações para administrador",
        "show_chat_now_action_per_profile": "Show Chat Now Action Per Profile",
        "show_add_to_phone_action_per_profile": "Show Add To Phone Action Per Profile",
        "show_new_event_action_per_profile": "Show New Event Action Per Profile",
        "show_calendar_per_profile": "Show Calendar Per Profile",
        "extra_search_account_name_field": "Contatos - Pesquisar conta por campo adicional",
        "auto_sync_activities__limit_to_profile": "Sincronização automática de Atividades - Limitar ao perfil",
        "allow_link_unknown_person": "Contatos - Vincular Pessoa desconhecida",
        "access_audit_log": "Registros de auditoria",
        "auto_sync_activities__hide_message_content": "Sincronização automática de Atividades - Ocultar conteúdo da mensagem",
        "force_saml_login": "Force SAML Login",
        "elite_security_token__user_agent_header": "Token de segurança Elite - Cabeçalho do agente do usuário",
        "layoutlimitsnewtask": "Limite de campos - Nova tarefa",
        "layoutlimitsnewaccount": "Limite de campos - Nova conta",
        "layoutlimitsnewcontact": "Limite de campos - Novo contato",
        "layoutlimitsnewlead": "Limite de campos - Novo lead",
        "hidesaveasmobilecontact": "Hide Save as Mobile Contact",
        "appshidemsoutlook": "Ocultar MS Outlook",
        "showselectivechatsync": "Chat-Sync - Mostrar opção Selective",
        "sendalertsnewusercreated": "Send Alerts - NEW_USER_CREATED",
        "hidesendemail": "Hide Send Email",
        "hidescheduleeventsaction": "Hide Schedule Events Action",
        "hidecalendar": "Hide Calendar",
        "sendalertsuserloggedin": "Send Alerts - USER_LOGGED_IN",
        "hideglobalsearch": "Ocultar pesquisa global",
        "hidecrmlinks": "Outros - Ocultar links do CRM",
        "oppsdisplay": "Oportunidades - Exibir",
        "showwhatsllytask": "Show Whatslly Task",
        "showwhatsllytasksicon": "Show Whatslly Tasks Icon",
        "showblurmode": "Desfocar todas mensagens",
        "ignoreaddleadsourcecreatecontact": "Contatos - Ignorar \"Adicionar LeadSource\"",
        "ignoreaddleadsourcecreatelead": "Leads - Ignorar \"Adicionar LeadSource\"",
        "trackanalytics": "Dashboard - Permitir coleta de dados",
        "contactoppsdisplay": "Contatos - Exibir Oportunidades de Contato",
        "hide_create_business_account": "Contas - Ocultar criação",
        "search_business_account__name_field": "Contas - Pesquisar",
        "status_bar__allow_change_opp_stage": "Oportunidades - Permitir estágio de mudança na barra de status",
        "hide_mark_task_as_completed": "Tarefas - Ocultar \"Marcar como concluída\"\"",
        "new_lead__phone_field": "Leads - Substituir Campo de Telefone",
        "new_contact__phone_field": "Contatos - Substituir campo de telefone",
        "never_blocklist_users": "Never Blocklist Users",
        "allow_to_sync_group": "Grupos - Permitir sincronização de grupos",
        "sent_alerts__user_turned_group_auto_sync_on": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_ON",
        "sent_alerts__user_turned_group_auto_sync_off": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_OFF",
        "new_lead__phone_field_prefix": "Leads - Criar com prefixo telefônico personalizado",
        "new_contact__phone_field_prefix": "Contatos - Criar com prefixo de telefone personalizado",
        "block_browser_extension": "Bloquear extensão Tuvis no navegador",
        "elite_security_token": "Token de segurança Elite",
        "show_favorite_templates": "Show Favorite Templates",
        "block_unknown_person": "Bloquear pessoa desconhecida",
        "block_groups_with_unknown_contacts": "Bloquear grupos com contatos desconhecidos",
        "enable_dependent_picklist": "Enable Dependent Picklist",
        "disable_generate_reminder_params": "Outros - Desativar data da atividade/tarefa e data do lembrete",
        "allow_only_invited_users": "Permitir somente usuários convidados",
        "limit_sf_open_url": "Outros - Bloquear URLs que não sejam da Salesforce",
        "limit_open_external_url": "Restrição de links externos",
        "show_person_account": "Conta pessoal - Exibir",
        "create_person_account": "Conta pessoal - Criar",
        "limit_login_via_sf_mobile_phone": "Validação de telefone CRM/SSO",
        "block_change_profile_image": "Block Change Profile Image",
        "sidecars_enabled": "Remote Sync - Habilitar",
        "inviter_name": "Nome do Convidante",
        "max_sidecars": "Quantidade máxima de dispositivos sidecar",
        "max_devices_whatsapp": "WhatsApp - Máximo de Dispositivos",
        "max_devices_telegram": "Telegram - Máximo de Dispositivos",
        "max_devices_line": "Line - Máximo de Dispositivos",
        "max_devices_signal": "Signal - Máximo de Dispositivos",
        "default_sidecar_frequency": "Remote Sync - Frequência",
        "show_im_groups_ui": "Grupos de WhatsApp - Metadados",
        "show_analytics_ui": "Dashboard - Conversas",
        "show_dashboards_ui": "Visão Customizada no Desktop",
        "show_custom_filters_ui": "Mostrar filtros personalizados",
        "use_sf_mega_describe": "Use SF Mega Describe",
        "custom_error_failed_to_query": "Outros - Erro personalizado: Falha ao consultar",
        "show_record_type_layout": "Outros - Mostrar layout do tipo de registro",
        "auto_sync_to_duplicate_records": "Sincronização para registros duplicados",
        "multi_channel_limit_channels_per_profile": "Multi-Channel Limit Channels Per Profile",
        "block_unknown_person_per_profile": "Block Unknown Person Per Profile",
        "hide_all_create_actions_per_profile": "Hide All Create Actions Per Profile",
        "show_global_search_per_profile": "Show Global Search Per Profile",
        "enable_record_types_pick_list": "Outros - Ativar lista de seleção de tipos de registro",
        "enable_create_entities_to_not_focused_contact": "Outros - Criar tarefas/atividades para um registro não pré-selecionado",
        "show_saml_settings": "Configurações SAML",
        "filter_analytics_by_profile": "Dashboard - Filtrar por perfil",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Global Layout Per Profile",
        "return_selective_to_prev": "Chat Sync - Restaurar estado anterior (modo seletivo)",
        "business_account__create": "Contas - Criar",
        "disable_retroactive_synchronization": "Desativar sincronização retroativa",
        "syncronizeLastDays": "Sincronizar mensagens dos últimos dias",
        "scroll_to_earliest_message": "Retornar para a mensagem mais antiga",
        "contact__allow_add_to_campaign_button": "Contact - Allow Add to Campaign Button",
        "disable_contact_require_account": "Contatos - Desativar Conta como campo obrigatório",
        "edit_lead": "Leads - Editar",
        "edit_contact": "Contatos - Editar",
        "edit_task": "Tarefas - Editar",
        "edit_activity": "Atividades - Editar",
        "edit_case": "Casos - Editar",
        "edit_person_account": "Conta pessoal - Editar",
        "edit_business_account": "Contas - Editar",
        "edit_opportunity": "Oportunidades - Editar",
        "show_create_account_under_create_contact": "Contatos - Criar contato com Conta",
        "show_create_account_under_edit_contact": "Contatos - Mostrar Criar conta",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Notification Recipients",
        "enabledNotifications": "Enabled Notifications",
        "use_only_wap_special_link": "Converse agora - Usar links nativos do WhatsApp",
        "query_cache_ttl": "Cache Query results TTL",
        "allow_dlp": "DLP - Habilitar",
        "enable_surveillance": "Surveillance",
        "allow_dlp_ai": "DLP com IA",
        "dlp_audio": "DLP com áudio",
        "allow_waba": "WhatsApp Business API",
        "allow_messages_analytics": "Conversas na Plataforma",
        "allow_twilio": "Gravação de chamadas - Habilitar",
        "allow_imessage": "iMessage",
        "allow_telegram": "Telegram - Ativar versão para desktop",
        "hide_telegram_channel": "Ocultar canal do Telegram",
        "new_agent_mode": "Modo Agente",
        "hide_widget_close_button": "Ocultar widget Fechar",
        "hide_forward_button": "Hide WhatsApp forward message button",
        "hide_bulk_messages": "Hide bulk messages button",
        "block_extension_sidebar_in_desktop": "CRM somente para login",
        "defaultLanguage": "Default Language for new users",
        "allow_embedded_signup_with_partner": "WhatsApp Business API via Smarters",
        "hide_intro_video": "Hide Intro Video",
        "wa_custom_notification_sound__enabled": "Allow Custom WhatsApp Notification Sound",
        "default_favorite_actions": "Ações favoritas padrão",
        "use_apex_upload_files": "Outros - Usar o arquivo de upload do SF Apex",
        "periodicAutoSync": "Sincronizar todas as mensagens periodicamente",
        "periodicAutoSyncInterval": "Sincronizar todas as mensagens periodicamente",
        "periodicGroupSync": "Grupos - Sincronizar metadados de grupos",
        "periodicGroupSyncInterval": "Grupos - Sincronizar metadados de grupos (intervalo)",
        "allow_customer_facing_settings": "Configurações voltadas para o cliente",
        "allow_public_api": "API pública Tuvis",
        "created_entities_title_prefix": "Outros - Criar entidades com prefixo de título",
        "force_user_phone": "Validação do telefone da plataforma",
        "desktop_add_paired_phone_on_login": "Adicionar telefone ao iniciar sessão",
        "max_paired_phones_on_login": "Número máximo de telefones emparelhados",
        "replace_phone_on_limit_exceeded": "Substituir o telefone se o limite for excedido.",
        "enable_limit_number_of_contacts_engaged": "Restringir contatos engajados por dia",
        "limit_number_of_contacts_engaged": "Limite de contatos permitidos por dia",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Restringir número de mensagens enviadas a contatos que não respondem",
        "limit_number_of_msgs_to_unresponsive_contact": "Limite de mensagens permitidas para contatos que não respondem.",
        "hide_logout": "Ocultar botão de logout",
        "hide_edit_user": "Ocultar botão de edição de usuário no menu do usuário",
        "desktopForceNewTab": "Abrir links em nova aba no Desktop",
        "fraud_detection": "Detecção de Fraude - Habilitar",
        "allow_keyword_insights": "Rastreador de palavras-chave",
        "allow_keyword_insights_report_message_content": "Rastreador de palavras-chave - Exibir mensagem original",
        "allow_user_analytics": "Dashboard - Análise de usuários",
        "analytics_compliance": "Dashboard - Compliance",
        "enable_call_recording_disclaimer": "Gravação de chamadas - Aviso legal",
        "allow_phones_whitelist": "Lista de contatos permitidos (Allow list)",
        "allow_phones_blocklist": "Lista de telefones privados",
        "allow_blocked_phones": "Bloquear telefones (chat)",
        "blocked_phones_create_incidents": "Bloquear telefones (incidentes)",
        "allow_tuvis_contacts": "Contatos da Tuvis",
        "custom_user_fields": "Campos personalizados do perfil do usuário",
        "collect_messages_group_participants": "Coletar telefones de participantes em grupos",
        "disable_opportunities_default_layout_field_for_entities": "Outros - Ocultar Oportunidade relacionada",
        "dlp_show_false_positive_incidents": "DLP Incidentes - Mostrar falsos positivos",
        "dlp_notify_email_on_false_positive": "DLP Incidentes-  Notificar por e-mail sobre falsos positivos",
        "query_cache_ttl_per_user": "TTL de caché de consulta por usuario",
        "allow_whatsapp_channels": "WhatsApp Canais - Sincronizar mensagens",
        "sidecar_ebs_size_in_gb": "Remote Sync - Tamanho total",
        "incidents_filter_matched_keyword_campaigns_default_value": "DLP - Ocultar incidentes que correspondam a palavras-chave",
        "sidecar_ebs_size_in_gb_per_user": "Remote Sync - Tamanho por usuário",
        "collect_whatsapp_status_messages": "WhatsApp - Mensagens de status",
        "block_copy_paste": "Bloquear copiar e colar no aplicativo Tuvis",
        "salesforce_use_browser": "Outros - Abrir autenticação do Salesforce no navegador padrão",
        "sidecar_snapshot_keep_count": "Remote Sync - Quantidade de Snapshots",
        "sidecar_snapshot_ttl_days": "Remote Sync - Dias de Snapshots",
        "remote_sync_custom_error_text": "Mensagem de erro personalizada do Remote Sync",
        "restrict_to_direct_reports": "Restringir o escopo dos dados aos subordinados diretos.",
        "restrict_to_direct_reports_bypass_list": "Restringir a subordinados diretos - Lista de exceções",
        "view_only_own_messages": "Ver apenas as minhas mensagens",
        "enable_hybrid_analysis_scan_url": "Detecção de Fraude - Hybrid Analysis",
        "fraud_detection_create_incidents": "Criar incidentes de detecção de fraude",
        "fraud_detection_incident_email_recipients": "Destinatários de e-mail de incidentes de fraude",
        "allow_slack_platform": "WhatsApp Business API com Slack",
        "allow_teams_platform": "WhatsApp Business APIcom o MS Teams",
        "allow_archive": "Habilitar arquivo",
        "allow_teams_archive": "Habilitar arquivamento do Teams",
        "disable_internal_messages_sync": "Desativar a sincronização de mensagens internas",
        "activitieshideuserassignmentfield": "Atividades - Ocultar atribuição do usuário",
        "auto_sync_cases_case_subject": "Sincronização automática de Casos - Assunto",
        "auto_sync_cases_case_completed_status": "Sincronização automática de Casos - Alterar status de concluído",
        "auto_sync_cases_enabled": "Sincronização automática de Casos - Ativada",
        "auto_sync_cases_hide_message_content": "Sincronização automática de Casos - Ocultar conteúdo da mensagem",
        "auto_sync_cases_limit_to_profile": "Sincronização automática de Casos - Restringir ao perfil",
        "auto_sync_cases_show_run_now_button": "Sincronização automática de Casos - Mostrar botão \"Executar agora\"",
        "find_account_record_types": "Contatos - Pesquisar contas relacionadas a um tipo de registro",
        "load_record_type_on_find_account": "Outros - Carregar contas relacionadas a um tipo de registro",
        "taskshideuserassignmentfield": "Tarefas - Ocultar Atribuição a um Usuário",
        "line_sidecars_enabled": "Line - Habilitar Remote Sync",
        "signal_sidecars_enabled": "Signal - Habilitar Remote Sync",
        "telegram_sidecars_enabled": "Telegram - Ativar sincronização remota",
        "whatsapp_sidecars_enabled": "WhatsApp - Ativar sincronização remota",
        "allow_audio_transcribes": "Habilitar transcrição de áudio",
        "track_filter_analytics": "Dashboard  - Status de Conversas",
        "analytics_filter_show_related_to_me": "Dashboard  - Mostrar apenas subordinados diretos do gerente",
        "enable_whatsapp_voice_video": "WhatsApp - Ativar chamadas no computador",
        "sync_whatsapp_voice_video": "WhatsApp - Sincronização de Voz/Vídeo",
        "phishing_fraud_detection": "Detecção de Fraude - URLs de phishing",
        "enable_virustotal_scan_url": "Detecção de Fraude - VirusTotal",
        "allow_url_policy": "Políticas de desktop - Ativar",
        "terms_of_use_enabled": "Termos de Uso Obrigatórios",
        "terms_of_use_text": "Termos de Uso",
        "terms_of_use_version": "Versão dos Termos de Uso",
        "allow_tuvis_browser": "Tuvis Browser - Ativar",
        "allow_bot_builder": "Permitir o criador de bots",
        "hide_meta_ai_button_in_desktop": "Oculta o botão 'Meta AI' do WhatsApp",
        "activeUsersCount": "Número de usuários ativos (30 dias)",
        "show_email_attachment": "Anexo de e-mail",
        "multiple_records_extra_fields": "Outros: campos adicionais para registros",
        "show_default_auto_sync_config": "Mostrar a configuração padrão de sincronização automática",
        "fraud_detection_mode": "Modo de detecção de fraude",
        "sidecar_invite_from_address": "Sincronização remota: endereço de e-mail",
        "sidecar_invite_from_name": "Sincronização remota: nome do convite"
      },
      "options": {
        "default_sidecar_frequency": {
          "0 * * * *": "Every hour",
          "0 */3 * * *": "Every 3 hours",
          "0 */6 * * *": "Every 6 hours",
          "0 */12 * * *": "Every 12 hours",
          "permanent": "Permanent"
        },
        "default_favorite_actions": {
          "view": "Visualizar",
          "call": "Ligar",
          "meeting": "Reunião",
          "messenger": "Mensageiro",
          "email": "E-mail",
          "navigate": "Navegar",
          "refresh": "Atualizar",
          "facebook": "Facebook",
          "linkedin": "Linkedin",
          "google": "Google",
          "find": "Encontrar",
          "addToPhone": "Adicionar ao telefone",
          "createCustomObject": "Criar objeto personalizado",
          "createCase": "Criar caso",
          "createTask": "Criar tarefa",
          "createActivity": "Criar atividade",
          "createLead": "Criar líder",
          "createContact": "Criar contato",
          "createPersonAccount": "Criar conta de pessoa",
          "chatNow": "Conversar agora",
          "showChatSummarizeAction": "Mostrar ação de resumo do chat",
          "createBusinessAccount": "Criar conta empresarial",
          "showAiChat": "Chat com VIS"
        },
        "showselectivechatsync": {
          "Hide": "Esconder",
          "Enabled": "Ativado",
          "Disabled": "Desativado",
          "Enable_Without_Auto": "Ativar sem a opção de sincronização automática"
        }
      },
      "help_text": {
        "show_only_wap_channels_in_desktop": "Oculta todas as abas, exceto os canais do WhatsApp, e impede que o usuário mude para outras abas",
        "periodicAutoSyncInterval": "Sincronizar automaticamente todas as mensagens a cada X milissegundos (1000 ms = 1 segundo). O padrão é 86400000 ms (24 horas).",
        "periodicGroupSyncInterval": "Sincronizar automaticamente os metadados de todos os grupos a cada X milissegundos (1000 ms = 1 segundo). O padrão é 3600000 ms (1 hora).",
        "limit_date_range_of_messages": "Limitar o histórico de mensagens aos últimos X meses. Os usuários verão apenas as mensagens desse período.",
        "phones_blocked_from_sync": "Números de telefone separados por vírgulas",
        "force_user_phone": "Restringe o login do WhatsApp com base no número de telefone específico definido na página de gerenciamento de usuários do Tuvis.",
        "desktop_add_paired_phone_on_login": "Ao efetuar o login, o número do WhatsApp associado ao usuário é salvo automaticamente no campo \"Telefone\" do perfil do usuário.",
        "max_paired_phones_on_login": "Número máximo de contas exclusivas do WhatsApp que um único usuário pode emparelhar.",
        "replace_phone_on_limit_exceeded": "Substitui automaticamente o telefone emparelhado mais antigo pelo mais recente quando o limite de dispositivos é excedido.",
        "leadsdisplay": "Exibir o objeto Lead padrão no painel.",
        "contactsdisplay": "Exibir o objeto Contatos padrão no painel.",
        "casesdisplay": "Exibir o objeto Case padrão no painel.",
        "activitiesdisplay": "Exibir o objeto Atividades padrão no painel.",
        "autosynclimittomaxfilesize": "Alterar o tamanho máximo de upload para sincronização automática Observação: o Salesforce não suporta arquivos com mais de 4,4 MB",
        "tasksdisplay": "Exibir o objeto Tarefas padrão no painel.",
        "hidesearchongoogle": "Hide \"Search on Google\" action from panel",
        "hidesearchonlinkedin": "Hide \"Search on Linkedin\" action in panel",
        "fileuploadshidecompletely": "Hide upload file from create task/activity/case page",
        "hidesearchonfacebook": "Hide \"Search on Facebook\" action in panel",
        "hidecallbutton": "Hide \"Call\" action button from actions panel",
        "allow_inviting_users": "Permitir enviar convites para novos usuários e atribuir permissões e licenças pela página de Gestão de usuários.",
        "show_chat_now_action": "Exibir a opção \"Converse agora\" no painel Ações",
        "auto_sync_activities__enabled": "Ative a opção \"Sincronização automática de atividades\" no Salesforce.",
        "auto_sync_activities__show_run_now_button": "Exibir o botão \"Executar agora\" na guia \"Sincronização automática de atividades\".",
        "auto_sync_activities__task_completed_status": "Por padrão, a tarefa criada com a Sincronização Automática de Atividades tem o status \"Concluída\". Defina outro status abaixo:",
        "auto_sync_activities__task_subject": "Definir o assunto das atividades criadas automaticamente pela sincronização de conversas. Por padrão, utilizamos \"Tuvis Chat\" para diferenciar essas atividades das criadas manualmente.",
        "show_chat_summarize_action": "Show the \"Chat Summarize\" action in the panel",
        "enable_widget_ai_assistant": "Ativar a função de Assistente de IA no painel de ações.",
        "create_case_opportunity_field_name": "Adicione um campo de seleção \"Oportunidade Relacionada\" na página de criação de caso. É necessário definir o nome do campo na API do CRM.",
        "allow_edit_layout_drag_and_drop": "Allow to change edit layout field order by drag and drop",
        "show_admin_notifications_tab": "Exibir a aba de notificações do administrador nas configurações do Salesforce Tuvis.",
        "allow_desktop_lite": "Habilita uma versão simplificada do Tuvis Desktop para organizações que não necessitam de integrações com CRM ou do painel lateral.",
        "delete_crm_session_on_logout_in_desktop": "Se a opção estiver ATIVADA, todas as sessões do CRM serão excluídas ao fazer logout do usuário. Se a opção estiver DESATIVADA, todas as sessões do CRM serão compartilhadas entre as sessões.",
        "layout_limits_case": "Alterar o número máximo de campos para o caso",
        "layout_limits_lead": "Alterar o número máximo de campos para o lead",
        "layout_limits_contact": "Alterar o número máximo de campos para contato",
        "layout_limits_task": "Alterar o número máximo de campos para a tarefa",
        "layout_limits_activity": "Alterar o número máximo de campos para a atividade",
        "layout_limits_account": "Alterar o número máximo de campos para a conta",
        "layout_limits_person_account": "Alterar o número máximo de campos para uma conta de pessoa (somente Salesforce)",
        "layout_limits_event": "Alterar o número máximo de campos para o evento",
        "layout_limits_opportunity": "Change maximum number of fields for opportunity",
        "layout_limits__new_activity": "Alterar o número máximo de campos para uma nova atividade",
        "layout_limits__new_case": "Alterar o número máximo de campos para um novo caso",
        "set_whatid__accountid__new_task_and_activity": "Ao criar uma tarefa/atividade, por padrão, permitimos selecionar uma Oportunidade e salvá-la no campo WhatId. Com essa opção, usamos o AccountId para esse campo WhatId.",
        "allow_platform_integrations": "Ativar a página de Integrações da plataforma para visualizar e gerenciar os serviços conectados.",
        "layout_limits__new_event": "Alterar o número máximo de campos para um novo evento",
        "layoutlimitsnewopportunity": "Change maximum number of fields for new opportunity",
        "layout_limits__new_person_account": "Alterar o número máximo de campos para uma nova conta de usuário.",
        "auto_sync_files__allow_message_types": "Limitar a sincronização de arquivos apenas a tipos de mídia específicos. Para mais de um, separe os tipos com ponto-e-vírgula. \nEx.: image; document\n\nTipos: sticker, video, image, document",
        "auto_sync_files__allow_media_mime_types": "Limitar a sincronização de arquivos apenas a tipos MIME de mídia específicos. Para mais de um, separe os tipos com ponto-e-vírgula. \n\nEx.: audio/ogg;application/vnd.openxmlformats-officedocument.wordprocessingml.document;application/msword\n\nTipos MIME comuns: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "Não sincroniza mensagens quando o arquivo de mídia não puder ser validado (por tipo MIME ou tipo de mensagem)",
        "ignore_chat_now_logic": "Ignore chat now logic and return phone number as is",
        "auto_sync_message_updates": "Isso fará com que uma mensagem que tenha atualizações (mensagem editada ou deletada) sincronize as atualizações novamente.",
        "auto_sync_message_on_status_change": "Sincronização automática de novas mensagens se o status da mensagem (enviada, lida) for alterado.",
        "default_notifications_over_due_only": "Change default notifications filter to show over due only",
        "prefix_phone_number_to_remove": "Ao criar uma conta de Lead/Contato/Pessoa no CRM, defina um prefixo de telefone que deve ser removido da inserção automática (por exemplo, remova o código do país 972, 55).",
        "chat_now_modal_no_contact": "Show chat now modal if the chat now number not found in WhatsApp contact list",
        "allow_platform_settings": "Allow access to instance to platform settings page",
        "allow_create_support_case": "Allow Create Support Case In JIra",
        "blur_contact_on_block_unknown_person": "Quando a opção Bloquear pessoa desconhecida está ativada, a pré-visualização da mensagem na lista de contatos fica automaticamente desfocada também.",
        "block_groups_with_unknown_contacts": "Impede a interação com grupos do WhatsApp caso nenhum membro seja identificado como registro existente no CRM.",
        "allow_platform_global_layout": "Permitir que a instância configure o Layout global dentro da plataforma Tuvis.",
        "allow_platform_admin_notifications": "Ativar alertas e atualizações do sistema.",
        "extra_search_account_name_field": "Ao criar um novo contato, exiba informações adicionais na lista suspensa de pesquisa de conta. É necessário definir o nome da API do campo que você deseja exibir.",
        "auto_sync_activities__limit_to_profile": "A sincronização automática de atividades será aplicada apenas a perfis específicos.",
        "allow_link_unknown_person": "Se o número do WhatsApp for desconhecido, ele poderá ser vinculado a um contato ou lead.",
        "access_audit_log": "Exibir a página de registros de auditoria com histórico de ações realizadas na plataforma.",
        "auto_sync_activities__hide_message_content": "Ocultar o conteúdo da mensagem ao criar atividades de sincronização automática",
        "force_saml_login": "Decline any login method besides SAML",
        "elite_security_token__user_agent_header": "Adicionar token de elite ao agente do usuário",
        "new_lead__phone_field": "Substituir o campo Telefone padrão no novo layout de lead Formato: Nome da API do campo, Rótulo do campo (separados por vírgula) Ex.: Celular, Celular",
        "new_contact__phone_field": "Ao criar um contato, o campo padrão é Telefone. Com esta opção, você pode salvar o WhatsApp em outro campo (ex.: Celular).",
        "block_browser_extension": "Bloquear o uso da extensão Tuvis no navegador padrão e permita o uso do Tuvis somente pelo aplicativo para desktop.",
        "elite_security_token": "Gerar uma sequência única com pelo menos 25 caracteres através do site https://1password.com/password-generator/ (sem símbolos especiais).",
        "limit_login_via_sf_mobile_phone": "Restringe o login do WhatsApp com base no número de telefone armazenado nos atributos do Salesforce (Mobile Phone) ou do Active Directory (Phone).",
        "sidecars_enabled": "Ativar o recurso de sincronização de aplicativos mobile.",
        "show_analytics_ui": "Exibir a aba Conversas na página de Dashboard da plataforma.",
        "show_dashboards_ui": "Exibir a Visão Customizada (reportes e widgets criados no CRM) comp página principal no Tuvis Desktop.",
        "show_custom_filters_ui": "Permitir que a instância exiba Filtros personalizados (filtrar conversas por resultados de relatórios do Salesforce) na plataforma e no desktop",
        "show_im_groups_ui": "Coleta informações de grupos do WhatsApp, como membros e configurações de convite.",
        "show_record_type_layout": "Exibir o menu suspenso superior ao criar um registro.",
        "enable_record_types_pick_list": "Ative para obter opções de lista suspensa de acordo com o tipo de registro selecionado. Se desativado, a seleção fica desabilitada.",
        "enable_create_entities_to_not_focused_contact": "Ao criar uma tarefa ou atividade, o usuário deve selecionar um contato, lead ou conta pessoa.",
        "show_saml_settings": "Ativar a página de configurações de SSO para gerenciar a autenticação de identidade baseada em SAML.",
        "filter_analytics_by_profile": "Filtrar os dados analíticos para usuários somente de perfis específicos do Salesforce.",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Allow to define global layout per profile",
        "return_selective_to_prev": "Ao ligar o modo “Selective” , retorna-se ao estado anterior.",
        "business_account__create": "Habilite para criar uma conta comercial.",
        "disable_retroactive_synchronization": "Sincronizar apenas as mensagens enviadas após a criação do usuário no Tuvis.",
        "syncronizeLastDays": "As mensagens serão sincronizadas se tiverem sido enviadas nos últimos X dias (máx 90 dias)",
        "scroll_to_earliest_message": "Rolar a tela no Tuvis Desktop ou extensão para carregar todas as mensagens de acordo com os últimos dias configurados.",
        "contact__allow_add_to_campaign_button": "Show \"Add to Campaign\" button under contact object - SF only",
        "disable_contact_require_account": "Durante a criação do contato, a seleção da conta não será obrigatória.",
        "edit_lead": "Permitir a edição de leads mesmo sem a funcionalidade \"Criar lead\"",
        "edit_contact": "Permitir a edição de contatos mesmo sem a opção \"Criar contato\"",
        "edit_task": "Permitir a edição de tarefas mesmo sem a funcionalidade \"Criar tarefa\"",
        "edit_activity": "Permitir a edição de atividades mesmo sem o recurso \"Criar atividade\"",
        "edit_case": "Permitir a edição de casos mesmo sem a funcionalidade \"Criar caso\"",
        "edit_person_account": "Permitir a edição da conta pessoal mesmo sem a funcionalidade \"Criar conta pessoal\"",
        "edit_business_account": "Permitir a edição da conta comercial, mesmo sem a funcionalidade \"Criar conta comercial\"",
        "edit_opportunity": "Enable to edit opportunity even without \"create opportunity\" feature",
        "show_create_account_under_edit_contact": "Ao editar um contato, habilite a opção para criar uma conta no menu suspenso.",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Insert email addresses (comma separated)",
        "enabledNotifications": "Insert email addresses (comma separated)",
        "allow_dlp_ai": "Permitir o uso de IA para identificar informações de identificação pessoal e extrair dados de anexos usando OCR.",
        "dlp_audio": "As políticas de Proteção contra Perda de Dados também podem ser aplicadas a áudios enviados via Desktop (requer integração).",
        "desktopForceNewTab": "Os links no aplicativo serão abertos em uma nova aba dentro do aplicativo Tuvis para desktop.",
        "enable_call_recording_disclaimer": "Reproduzir um aviso de gravação de chamada quando uma chamada de saída for atendida ou quando uma chamada de entrada for discada.",
        "custom_user_fields": "Permite até cinco campos de texto personalizados na seção de perfil do usuário, separados por vírgulas.",
        "collect_messages_group_participants": "Quando ativado, os números de telefone de todos os participantes do grupo são coletados a cada mensagem enviada no grupo.",
        "disable_opportunities_default_layout_field_for_entities_description": "Desabilite o campo \"Oportunidade Relacionada\" nas páginas de criação de tarefas, atividades e casos.\r\nÉ necessário definir as entidades para as quais você deseja desabilitar o campo",
        "dlp_show_false_positive_incidents": "Exibir incidentes DLP reavaliados como falsos positivos na lista de incidentes.",
        "dlp_notify_email_on_false_positive": "Enviar e-mail  para os endereços definidos no campo de destinatários da notificação quando um incidente DLP falso positivo for criado.",
        "query_cache_ttl_per_user": "Se estiver habilitado, a caché de consulta será habilitada para o usuário",
        "allow_whatsapp_channels": "Se esta opção estiver ativada, os usuários começarão a sincronizar e executar o DLP nos canais do WhatsApp, caso a sincronização e o DLP estejam habilitados.",
        "new_agent_mode": "Quando ativada, os usuários desta organização terão acesso ao modo com agentes e filas de atendimento no Tuvis Messaging.",
        "incidents_filter_matched_keyword_campaigns_default_value": "Se esta opção estiver ativada, os incidentes de DLP que correspondem a palavras-chave serão ocultados por padrão.",
        "sidecar_ebs_size_in_gb_per_user": "Espaço em GB de armazenamento EBS disponível para cada usuário na sincronização remota.",
        "collect_whatsapp_status_messages": "Coletar os status publicados pelo usuário.",
        "block_copy_paste": "Quando habilitado, a cópia e a colagem serão bloqueadas no aplicativo Tuvis",
        "salesforce_use_browser": "Se selecionada, a autenticação do Salesforce será aberta no navegador padrão do usuário em vez de no aplicativo Tuvis para desktop. Essa configuração não tem efeito nos clientes web com extensão ou Remote Sync.",
        "sidecar_snapshot_keep_count": "O número de cópias de segurança (snapshots) armazenadas para o processo de sincronização remota de cada usuário.",
        "sidecar_snapshot_ttl_days": "O número de dias que um snapshot é mantido antes de ser excluído automaticamente.",
        "remote_sync_custom_error_text": "Se definido, este texto será exibido abaixo do erro padrão do Remote Sync (ex.: Falha na sincronização) para direcionar os usuários ao contato de conformidade ou suporte (ex.: e-mail ou ramal).",
        "restrict_to_direct_reports": "Limita a visibilidade dos dados do usuário em toda a plataforma exclusivamente às informações de seus subordinados diretos.",
        "restrict_to_direct_reports_bypass_list": "Define quais usuários não serão afetados pela regra de restrição de dados somente de seus subordinados diretos e que, portanto, poderão visualizar dados de todos.",
        "view_only_own_messages": "Restringe os usuários a visualizarem apenas seu próprio histórico de mensagens dentro da plataforma.",
        "enable_hybrid_analysis_scan_url": "Analise URLs usando a API de Hybrid Analysis para detecção de malware e phishing.",
        "fraud_detection_create_incidents": "Quando ativado, incidentes são criados automaticamente ao detectar hashes ou URLs maliciosas nas mensagens.",
        "fraud_detection_incident_email_recipients": "Selecione os usuários que devem receber alertas por e-mail quando um incidente de detecção de fraude for criado.",
        "allow_slack_platform": "Habilitar o aplicativo Tuvis nos Canais do Slack, permitindo que a organização vincule um número da API do WhatsApp para comunicação centralizada via Slack.",
        "allow_teams_platform": "Habilitar o aplicativo Tuvis no Microsoft Teams, permitindo que a organização vincule um número WhatsApp API para centralizar a comunicação via Teams.",
        "allow_archive": "Habilitar para permitir as funcionalidades de arquivamento de mensagens",
        "allow_teams_archive": "Habilitar para permitir o arquivamento do Teams",
        "disable_internal_messages_sync": "Impede a sincronização de mensagens enviadas entre membros da equipe interna.",
        "activitiescreate": "Habilitar a criação de atividades",
        "activitieshideuserassignmentfield": "Ocultar campo Proprietário da atividade (atribuir ao usuário)",
        "auto_sync_cases_case_subject": "Definir o assunto dos Casos criadas automaticamente pela sincronização de conversas. Por padrão, utilizamos \"Tuvis Chat\" para diferenciar esses Casos daqueles criadaos manualmente.",
        "auto_sync_cases_case_completed_status": "Alterar o status padrão da tarefa de concluída para outro status personalizado",
        "auto_sync_cases_enabled": "Ativar a criação automática de casos",
        "auto_sync_cases_hide_message_content": "Ocultar o conteúdo da mensagem ao criar casos de sincronização automática.",
        "auto_sync_cases_limit_to_profile": "Lista de nomes de perfil dos quais coletamos mensagens: Ex.: Administrador do Sistema; Usuário de Demonstração; Prr",
        "auto_sync_cases_show_run_now_button": "Exibir o botão \"Executar agora\" na guia \"Sincronização automática de casos\".",
        "hide_create_business_account": "Desativar a opção Criar conta comercial.",
        "search_business_account__name_field": "A pesquisa padrão é por nome da conta; outros campos podem ser adicionados abaixo.",
        "casescreate": "Habilitar a criação de casos",
        "contactscreate": "Habilitar para criar contatos",
        "show_create_account_under_create_contact": "Exibir o menu suspenso \"Criar conta\" na opção \"Criar contato\".",
        "new_contact__phone_field_prefix": "Por padrão, copiamos o número do WhatsApp para criar um novo contato no CRM. Com essa opção, podemos adicionar um prefixo (exemplo: +).",
        "contactoppsdisplay": "Exibir oportunidades de contato, além das oportunidades de conta padrão.",
        "hideaccountbox": "Na visualização de contato, remover a caixa de exibição da conta",
        "ignoreaddleadsourcecreatecontact": "Por padrão, LeadSource: \"WhatsApp Web\". Com essa opção, não preenchemos este campo.",
        "find_account_record_types": "Ao criar um novo contato, o campo Conta carregará apenas as contas que também estejam relacionadas a um tipo de registro específico, por ID ou nome do desenvolvedor.",
        "layoutlimitsnewaccount": "Alterar o número máximo de campos para uma nova conta.",
        "layoutlimitsnewcontact": "Alterar o número máximo de campos para novo contato",
        "layoutlimitsnewlead": "Alterar o número máximo de campos para um novo lead",
        "layoutlimitsnewtask": "Alterar o número máximo de campos para uma nova tarefa",
        "leadscreate": "Habilitar para criar leads",
        "new_lead__phone_field_prefix": "Por padrão, copiamos o número do WhatsApp para criar um novo lead no CRM. Com essa opção, podemos adicionar um prefixo (exemplo: +).",
        "hideleadprogresstopbar": "Ocultar barra superior de progresso do Lead.",
        "ignoreaddleadsourcecreatelead": "Ignore \"Adicionar LeadSource\" ao criar um contato.",
        "status_bar__allow_change_opp_stage": "Permitir a alteração do status nas Oportunidades",
        "oppsdisplay": "Exibir o objeto Oportunidade padrão no painel.",
        "hideopportunitytopbar": "Ocultar barra superior de progresso da oportunidade",
        "limit_sf_open_url": "Ao usar o Tuvis Desktop, qualquer link que não seja do Salesforce será restrito.",
        "created_entities_title_prefix": "Quando um registro é criado, o título começa com [Tuvis]. O prefixo do título pode ser alterado com esta opção.",
        "disable_generate_reminder_params": "Não adicione os campos ReminderDateTime e IsReminderSet.",
        "disable_opportunities_default_layout_field_for_entities": "Oculte o campo \"Oportunidade relacionada\" nas páginas de criação de tarefas, atividades e casos. Selecione as entidades para as quais você deseja desabilitar o campo.",
        "load_record_type_on_find_account": "Primeiro, o usuário escolhe o tipo de registro no widget do CRM e, em seguida, a pesquisa de contas carregará apenas as contas de acordo com essa seleção.",
        "use_apex_upload_files": "Quando uma tarefa/atividade/caso é criado, por padrão usamos a API de anexos oficial do Salesforce. Se habilitada, usaremos o Apex do Salesforce da Tuvis.",
        "create_person_account": "Habilitar para criar conta pessoal",
        "show_person_account": "Exibir o objeto Conta de Pessoa padrão no painel.",
        "taskscreate": "Habilitar a criação de tarefas",
        "hide_mark_task_as_completed": "Impede que os usuários marquem a tarefa como concluída.",
        "taskshideuserassignmentfield": "Ocultar campo Responsável pela Tarefa (atribuir ao usuário)",
        "auto_sync_to_duplicate_records": "Sincronização automática do chat com todos os registros correspondentes do CRM se um contato estiver associado a várias entradas.",
        "enableautosyncalwayson": "Ativa a sincronização automática de chat por padrão sempre que uma nova conversa é iniciada. Essa configuração pode ser alterada se os controles de Modo de Chat Sync estiverem visíveis no Desktop.",
        "enableautosynchidebutton": "Ocultar os botões de ativação e desativação da sincronização automática de mensagens.",
        "enableautosyncfiles": "Permite a sincronização automática de arquivos do usuário, incluindo áudios, documentos e outras mídias.",
        "allow_to_sync_group": "Permite a sincronização de chats em grupo.",
        "auto_sync_groups_default": "Garante que a sincronização automática permaneça ativa por padrão para grupos e que os usuários não possam alterá-la.",
        "showselectivechatsync": "O usuário pode escolher manualmente quais mensagens devem ser armazenadas no CRM.",
        "block_unknown_person": "Impede que os usuários enviem mensagens para qualquer contato que não tenha um registro correspondente no CRM.",
        "block_unknown_person_per_role": "Impede que usuários com funções específicas do Salesforce enviem mensagens para qualquer contato que não tenha um registro correspondente no CRM.",
        "showblurmode": "Desfoca todo o conteúdo da mensagem na interface de chat, revelando o texto apenas quando o usuário passa o cursor sobre a mensagem.",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Permite restringir o número de mensagens que podem ser enviadas a um contato que não respondeu.",
        "enable_limit_number_of_contacts_engaged": "Permite restringir o número de contatos únicos com os quais um usuário pode interagir por dia para evitar spam.",
        "limit_open_external_url": "Impede que os usuários abram URLs externas diretamente do aplicativo Tuvis",
        "hideglobalsearch": "Remove a barra de pesquisa global do painel superior para impedir que os usuários pesquisem contatos do CRM.",
        "allow_keyword_insights_report_message_content": "Permite visualizar a mensagem completa onde a palavra-chave foi identificada, na seção de ocorrências.",
        "limit_number_of_contacts_engaged": "Define o número máximo de contatos únicos com os quais um usuário pode interagir a cada 24 horas.",
        "limit_number_of_msgs_to_unresponsive_contact": "Defina o número máximo de mensagens enviadas a um contato antes de receber uma resposta.",
        "disable_save_as_at_desktop": "Desativa a opção \"Salvar como\" para arquivos dentro da plataforma, impedindo que os usuários os baixem.",
        "allow_only_invited_users": "Os usuários só podem fazer login no Tuvis após um convite. Essa opção deve ser definida como VERDADEIRA se o mesmo domínio de e-mail for usado para SSO em organizações diferentes.",
        "block_extension_sidebar_in_desktop": "Utiliza as credenciais do CRM apenas para autenticação, mas oculta o painel lateral do CRM no aplicativo Tuvis Desktop.",
        "hide_logout": "Remove o botão de logout do menu do usuário.",
        "allow_twilio": "Ativar gravação de chamadas pelo aplicativo da Tuvis e exibir o dashboard correspondente na plataforma.",
        "exceededLicences": "Define o máximo de usuários, que pode corresponder ao número exato de licenças adquiridas ou incluir uma margem adicional.",
        "paidLicences": "Licenças adquiridas pela organização. Por padrão, concedemos uma margem de tolerância de 10% acima do limite de licenças.",
        "line_sidecars_enabled": "Ativar a Sincronização Remota para o Line. Observação: o Line não possui versão Desktop.",
        "max_devices_line": "Licenças de Sincronização Remota para Line.",
        "default_sidecar_frequency": "Frequência de sincronização de mensagens",
        "sidecar_ebs_size_in_gb": "Espaço total em GB de armazenamento EBS disponível para a sincronização remota.",
        "signal_sidecars_enabled": "Ativar a Sincronização Remota para o aplicativo Signal no celular",
        "max_devices_signal": "Licenças adquiridas do Remote Sync para Signal.",
        "allow_telegram": "Ative o Telegram no Tuvis Desktop.",
        "hide_telegram_channel": "Quando ativado, oculta a opção do canal do Telegram no Tuvis Desktop.",
        "telegram_sidecars_enabled": "Ative a sincronização remota para o aplicativo Telegram no celular.",
        "max_devices_telegram": "Licenças adquiridas do Remote Sync para Telegram",
        "whatsapp_sidecars_enabled": "Ativar a sincronização remota para o aplicativo WhatsApp no ​​celular.",
        "max_devices_whatsapp": "Licenças de Sincronização Remota para WhatsApp.",
        "allow_waba": "Permitir a integração da API do WhatsApp Business",
        "allow_embedded_signup_with_partner": "Habilitar o Embedded Signup  (cadastro incorporado) para conectar um número de WhatsApp API.",
        "allow_audio_transcribes": "Requer integração com ferramenta de transcrição de áudio (Amazon ou Azure)",
        "allow_messages_analytics": "Exibir a página de Conversas no menu principal para monitorar mensagens sincronizadas e gravações de chamadas.",
        "allow_customer_facing_settings": "Permite que os administradores da organização gerenciem configurações específicas da plataforma.",
        "trackanalytics": "Permitir a coleta de dados para serem exibidos em Dashboards.",
        "analytics_compliance": "Exibir a aba Compliance na página de Dashboard da plataforma.",
        "track_filter_analytics": "Exibir a aba Status de Conversas no Dashboard, que atualiza o volume de conversas por status (não lidas, aguardando resposta e precisa de resposta) com atualização de hora em hora.",
        "analytics_filter_show_related_to_me": "Restringir a visibilidade do dashboard apenas aos subordinados diretos do gerente, desabilitando o acesso a dados de outros departamentos ou usuários.",
        "allow_user_analytics": "Exibir a aba Análises do Usuário no Dashboard da plataforma.",
        "allow_keyword_insights": "Habilitar o Rastreador de Palavras-chave e exibir a aba Análise de Palavras-chave no Dashboard da plataforma.",
        "multichannellimitchannels": "Limitar o número máximo de canais que podem ser conectados pelos usuários",
        "periodicAutoSync": "Programar sincronização completa de todo o histórico de conversas para usuários ativos.",
        "allow_phones_whitelist": "Ativar um modo de monitoramento restrito, no qual apenas as conversas com números de telefone especificamente adicionados à lista de permissões são sincronizadas.",
        "allow_phones_blocklist": "Isenta números de telefone específicos de todo o rastreamento e sincronização da plataforma para garantir a privacidade do usuário.",
        "allow_blocked_phones": "Bloqueia a conversa na extensão para números de telefone específicos, exibindo uma sobreposição de contato bloqueado.",
        "blocked_phones_create_incidents": "Cria um incidente de fraude quando um usuário envia uma mensagem para um número de telefone bloqueado, incluindo mensagens enviadas fora do Tuvis. Requer Bloquear telefones (chat).",
        "allow_public_api": "Permitir que a organização se conecte e troque dados com a API pública da Tuvis.",
        "allow_tuvis_contacts": "Permitir que o Tuvis Contacts seja o CRM do cliente (somente SAML)",
        "block_whatsapp_calls": "Impede que os usuários iniciem ou recebam chamadas do WhatsApp no ​​aplicativo Android.",
        "enable_whatsapp_voice_video": "Se ativada, a função de chamadas de voz e vídeo do WhatsApp estará disponível apenas para conversas individuais (não em grupos) pelo computador.",
        "sync_whatsapp_voice_video": "Se ativada, a sincronização de mensagens de voz e vídeo do WhatsApp será feita pelo computador.",
        "periodicGroupSync": "Ativar para sincronizar periodicamente os metadados de todos os grupos.",
        "allow_dlp": "Exibe a página de Data Loss Protection (Proteção contra Perda de Dados) para usuários com as respectivas permissões criarem regras de monitoramento de segurança.",
        "fraud_detection": "Exibir a página de Detecção de Fraudes na plataforma Tuvis para identificar links de phishing e hashes maliciosos em arquivos anexados.",
        "enable_virustotal_scan_url": "Ativar VirusTotal para verificação de links.",
        "allow_url_policy": "Ativar a página de Políticas de desktop na plataforma Tuvis, para configurar funcionalidades aplicáveis por canais, sites gerenciados e outros links.",
        "terms_of_use_enabled": "Torna obrigatório o aceite dos Termos de Uso logo após o login no aplicativo desktop.",
        "terms_of_use_text": "Texto opcional que os usuários devem aceitar. Deixe vazio para exibir apenas os links dos Termos de Serviço e da Política de Privacidade da Tuvis. Ao editá-lo, todos os usuários precisarão aceitar novamente.",
        "terms_of_use_version": "Gerenciado automaticamente. Aumenta a cada alteração do texto dos Termos de Uso.",
        "allow_tuvis_browser": "Ativar a seção Tuvis Browser (Políticas de Acesso + Controles do Navegador) para esta organização.",
        "multiple_records_extra_fields": "Quando o número de telefone corresponde a vários Leads, Contatos ou Contas pessoais, informe os API_names dos campos adicionais a serem exibidos.",
        "use_only_wap_special_link": "Quando ativado, o botão \"Chat now\" usará links nativos do WhatsApp para iniciar a conversa, em vez do método padrão.",
        "default_favorite_actions": "Selecione as ações favoritas padrão para os atalhos rápidos do painel"
      }
    },
    "preview": "Visualizar",
    "show_changed_configs": "Mostrar configurações alteradas",
    "changes": "Alterações",
    "nav": {
      "system_notifications": "Notificações do sistema",
      "api_keys": "Chaves de API",
      "sso_settings": "Configurações de SSO",
      "incidents_summary_email": "E-mail de resumo de incidentes",
      "elite_token": "Token de Segurança Elite"
    }
  },
  "user_page": {
    "remove_waba": "Tem certeza de que deseja remover o número de telefone do WhatsApp Business API?",
    "remove_twilio": "Tem certeza de que deseja remover o número de telefone do Twilio?",
    "assign_phone": "Adicionar número de telefone",
    "unassign_phone": "Remover número de telefone",
    "assign_sidecar": "Adicionar dispositivo",
    "unassign_sidecar": "Remover dispositivo",
    "choose_phone": "Escolha o número de telefone",
    "enabled": "Ativado",
    "waba": "WhatsApp Business API (aplicativo de desktop)"
  },
  "incidents_summary_email": {
    "title": "E-mail de resumo de incidentes",
    "discription_text": "Configure quem recebe os resumos por e-mail e sobre quais incidentes cada destinatário é notificado.",
    "send_summary_to": "Enviar resumo para",
    "which_incidents": "Quais incidentes?",
    "scope_all": "Todos os incidentes da plataforma",
    "scope_user": "Incidentes de um usuário específico",
    "scope_manager": "Incidentes de um manager específico",
    "for": "para",
    "select_user": "Selecionar usuário",
    "select_manager": "Selecionar manager",
    "add_recipient": "Adicionar destinatário",
    "remove_row": "Remover destinatário",
    "saved_successfully": "As configurações de e-mail de resumo de incidentes foram salvas com sucesso",
    "saved_failed": "Falha ao salvar as configurações de e-mail de resumo de incidentes",
    "validation_email_required": "O e-mail é obrigatório para cada destinatário",
    "validation_reference_required": "Selecione um usuário ou manager para este destinatário",
    "loading": "Carregando...",
    "saveSettings": "Salvar configurações"
  },
  "incidents_page": {
    "open_in_new_page": "Abrir em nova página",
    "change_assignee": "Mudar Responsável",
    "assignee": "Responsável",
    "change_status": "Alterar Status",
    "select_status": "Selecionar status",
    "matched_keyword_campaigns": "Critérios de Palavras-chave"
  },
  "messages_analytics_page": {
    "title": "Conversações",
    "sent_date": "Data de envio",
    "type": "Tipo",
    "sender": "Remetente",
    "receiver": "Destinatário",
    "message": "Mensagem",
    "attachment": "Anexo",
    "fileName": "Nome do arquivo",
    "fileType": "Tipo de arquivo",
    "no_valid_integrations": "Nenhuma integração válida foi encontrada (S3, Azure, SFTP, GCP)",
    "no_messages": "Nenhuma mensagem foi encontrada",
    "tabs": {
      "messages": "Mensagens",
      "calls": "Chamadas"
    },
    "edited": "Editado",
    "deleted": "Deletado",
    "message_history": "Histórico de mensagens"
  },
  "test_regex_modal": {
    "test_regex_modal_title": "Testar Regex",
    "test_regex_settings": "Configurações de Regex",
    "test_regex_expression": "Expressão",
    "text_to_test_placeholder": "Texto para Testar",
    "test_button": "Testar",
    "not_case_sensitive": "Não diferencia maiúsculas de minúsculas",
    "failed_to_test_regex": "Falha ao testar a expressão regular"
  },
  "test_pii_modal": {
    "test_pii_modal_title": "Testar PII",
    "test_pii_settings": "Configurações de PII",
    "pii_category": "Categoria de PII",
    "text_to_test_placeholder": "Texto para Testar",
    "test_button": "Testar",
    "failed_to_test_pii": "Falha ao testar PII"
  },
  "test_rule_modal": {
    "failed_to_test": "Falha ao testar",
    "texts_to_test": "Textos para Testar",
    "test_metadata_title": "Testar Metadados",
    "upload_file_to_test_metadata": "Envie um ficheiro e clique em Carregar para extrair os metadados",
    "load": "Carregar",
    "test_metadata_phase": "Testar a condição de metadados com os metadados extraídos acima",
    "metadata_match": "Corresponde",
    "metadata_no_match": "Não corresponde",
    "extracted_metadata": "Metadados extraídos"
  },
  "account_admin": {
    "title": "Administração da Conta",
    "users_page": {
      "title": "Usuários da Conta",
      "toasts": {
        "invite_failed_user_exists": "O endereço de e-mail já existe, reenvie o convite em vez disso"
      },
      "add_button": "Adicionar usuário",
      "assign_permissions_modal": {
        "button": "Atribuir Permissões",
        "title": "Atribuir Permissões de Usuário",
        "description": "Atribuir permissões de organização para <1>{{name}}</1>.",
        "select_user": "Selecionar Usuário",
        "search_users": "Buscar Usuários",
        "permissions_for_in": "Permissões para <1>{{name}}</1> em <1>{{orgName}}</1>",
        "indication": {
          "own_org": "{{name}} faz parte desta organização",
          "has_permission": "{{name}} pode visualizar esta organização porque tem pelo menos uma permissão atribuída"
        },
        "error_message": "Não foi possível atribuir permissões ao usuário",
        "no_instance_configs": "Nenhuma configuração de instância encontrada",
        "no_instance_configs_description": "Nenhuma configuração de instância encontrada para esta organização. Por favor, contate seu administrador."
      },
      "account_admin_modal": {
        "assign_title": "Atribuir Administrador da Conta",
        "assign_description": "Tem certeza que deseja atribuir <1>{{name}}</1> como Administrador da Conta?",
        "assign_confirm": "Sim, atribuir",
        "remove_title": "Remover Administrador da Conta",
        "remove_description": "Tem certeza que deseja remover <1>{{name}}</1> como Administrador da Conta?",
        "remove_confirm": "Sim, remover",
        "error_message": "Não foi possível alterar o status de administrador do usuário"
      },
      "cannot_change_own_admin": "Você não pode alterar seu próprio status de administrador",
      "is_account_admin": "É Administrador da Conta",
      "invite_external_user_success": "Convite enviado com sucesso",
      "invite_external_user_error": "Falha ao enviar o convite",
      "from_user": "De um usuário da organização",
      "from_external": "De um usuário externo"
    },
    "overview_page": {
      "title": "Visão Geral da Conta",
      "account_name": "Nome da Conta",
      "account_id": "ID da Conta"
    },
    "no_access_overlay": {
      "title": "Nenhuma Conta Selecionada",
      "text": "Por favor, selecione uma conta no menu suspenso acima para visualizar esta página.",
      "button": "Voltar"
    },
    "account_orgs": {
      "title": "Organizações da Conta",
      "columns": {
        "registered_users": "Usuários Registrados",
        "consumed_licences": "Licenças Consumidas"
      },
      "summary": {
        "purchased_licences": "Licenças Compradas"
      },
      "assign_orgs_modal": {
        "title": "Atribuir Organizações",
        "description": "Selecione as organizações que deseja atribuir a esta conta.",
        "trigger": "Atribuir Organizações",
        "success_message": "Organizações atribuídas à conta",
        "error_message": "Não foi possível atribuir organizações à conta"
      },
      "remove_org_modal": {
        "title": "Remover Organização da Conta",
        "description": "Tem certeza que deseja remover a organização da conta?",
        "success_message": "Organização removida da conta",
        "error_message": "Não foi possível remover a organização da conta",
        "trigger": "Desatribuir"
      },
      "view_org": "Ver organização",
      "create_org": "Criar organização"
    }
  },
  "keyword_insights_occurrence": {
    "header": "Detalhes de ocorrência"
  },
  "keyword_insights": {
    "title": "Rastreador de Palavras-chave",
    "dashboard_page": {
      "title": "Análise de Keywords",
      "date_range": "Intervalo de Datas",
      "kpis": {
        "active_agents": {
          "label": "Agentes Ativos",
          "tooltip": "Número total de usuários conectados"
        },
        "campaigns_created": {
          "label": "Critérios Criados",
          "tooltip": "Quantos critérios diferentes foram criados"
        },
        "campaigns_sent": {
          "label": "Critérios Enviados",
          "tooltip": "Quantos critérios diferentes foram enviados"
        },
        "reach": {
          "label": "Alcance",
          "tooltip": "Quantos contatos receberam pelo menos um dos critérios"
        },
        "impressions": {
          "label": "Impressões Totais",
          "tooltip": "Quantas mensagens contendo critérios foram enviadas. A mesma pessoa pode receber múltiplos critérios ou o mesmo critério mais de uma vez"
        },
        "avg_impressions_per_agent": {
          "label": "Média de Impressões por Agente",
          "tooltip": "Impressões Totais / Agentes Ativos"
        },
        "avg_reach_per_agent": {
          "label": "Média de Alcance por Agente",
          "tooltip": "Alcance / Agentes Ativos"
        },
        "avg_reach_per_sent_campaign": {
          "label": "Média de Alcance por Critério",
          "tooltip": "Alcance / Critérios Enviados"
        }
      },
      "charts": {
        "impressions": {
          "title": "Impressões ao Longo do Tempo",
          "legend": "Impressões"
        },
        "campaigns": {
          "title": "Critérios vs Critérios Enviados",
          "legendCampaigns": "Critérios",
          "legendCampaignsSent": "Critérios Enviados"
        },
        "period": "Últimos {{months}} meses"
      },
      "export_kpis": "Exportar KPIs",
      "export_charts": "Exportar Gráficos"
    },
    "campaigns_page": {
      "title": "Critérios",
      "upsert_campaign_modal": {
        "create_trigger": "Criar Critério",
        "create_title": "Criar Critério de Palavra-chave",
        "create_loading_message": "Criando critério...",
        "create_error_message": "Erro! Não foi possível criar o critério",
        "create_success_message": "Critério criado",
        "update_trigger": "Atualizar Critério",
        "update_title": "Atualizar Critério de Palavra-chave",
        "update_loading_message": "Atualizando critério...",
        "update_error_message": "Erro! Não foi possível atualizar o critério",
        "update_success_message": "Critério atualizado",
        "name": "Nome do Critério",
        "description": "Descrição",
        "conditions": "Condições do Critério",
        "conditions_description": "Se qualquer uma das expressões abaixo for atendida, o critério será acionado.",
        "add_condition_tooltip": "Adicionar Condição",
        "delete_condition_tooltip": "Excluir Condição"
      },
      "delete_campaign_modal": {
        "trigger": "Excluir Critério",
        "title": "Excluir Critério",
        "description": "Tem certeza que deseja excluir este critério?",
        "confirm": "Sim, excluir",
        "success_message": "Critério excluído",
        "error_message": "Não foi possível excluir o critério",
        "loading_message": "Excluindo critério..."
      },
      "cols": {
        "name": "Nome do Critério",
        "description": "Descrição",
        "conditions": "Condições",
        "created_at": "Criado em",
        "updated_at": "Atualizado em",
        "enabled": "Ativado"
      },
      "stop_tracking_campaign_modal": {
        "title": "Parar de Rastrear Critério",
        "description": "Tem certeza que deseja parar de rastrear este critério de palavras-chave?",
        "submit": "Sim"
      },
      "toggle_campaign": {
        "enabled_success_message": "Rastreamento do critério retomado",
        "disabled_success_message": "Rastreamento do critério interrompido",
        "error_message": "Não foi possível atualizar o critério"
      },
      "search_campaigns_placeholder": "Pesquisar critérios..."
    },
    "occurrences_page": {
      "title": "Ocorrências",
      "date_range": "Data de Criação do Registro",
      "yes": "Sim",
      "no": "Não",
      "cols": {
        "created_at": "Criado em",
        "campaign_name": "Nome do Critério",
        "campaign_id": "ID do Critério",
        "content": "Mensagem",
        "matched_keywords": "Palavras-chave Correspondentes",
        "sender": "Remetente",
        "sender_phone": "Telefone do Remetente",
        "receiver": "Receptor",
        "recipient_phone": "Telefone do Receptor",
        "is_group": "É Grupo"
      }
    }
  },
  "search_accounts": {
    "search_accounts": "Pesquisar Contas",
    "create_new_account": "Criar Nova Conta",
    "create_new_account_success": "Conta criada com sucesso: {{accountName}}",
    "create_new_account_error": "Não foi possível criar a conta",
    "change_account_name": "Alterar Nome da Conta",
    "change_account_name_success": "Nome da conta alterado com sucesso para: {{accountName}}",
    "change_account_name_error": "Não foi possível alterar o nome da conta"
  },
  "surveillance_page": {
    "title": "Surveillance",
    "tabs": {
      "policies": "Políticas",
      "rules": "Regras",
      "incidents": "Incidentes"
    },
    "create_policy": "Criar Política",
    "create_rule": "Criar Regra",
    "update_policy": "Editar Política",
    "update_rule": "Editar Regra",
    "delete_policy": "Excluir Política",
    "delete_policy_modal_message": "Tem certeza de que deseja excluir esta política?",
    "delete_rule": "Excluir Regra",
    "delete_rule_modal_message": "Tem certeza de que deseja excluir esta regra?",
    "rule_in_use": "Regra em Uso",
    "rule_in_use_description": "Esta regra está sendo usada nas seguintes políticas: {{policies}}",
    "incident_header": "Incidente de Surveillance",
    "builder": {
      "create_title": "Criar Política de Surveillance",
      "edit_title": "Editar Política de Surveillance",
      "rules": {
        "title": "Regras de Surveillance"
      }
    }
  },
  "field_is_required": "Campo obrigatório",
  "im_templates": {
    "title": "Templates",
    "create_template": "Novo Template",
    "edit_template": "Editar Template",
    "delete_template": "Excluir Template",
    "delete_template_confirm": "Tem certeza que deseja excluir este template?",
    "name": "Nome",
    "content": "Mensagem",
    "status": "Status",
    "status_active": "Ativo",
    "status_stopped": "Inativo",
    "created_at": "Criado em",
    "updated_at": "Atualizado em",
    "attachments": "Anexos",
    "attachment_size_error": "O tamanho total dos anexos não deve ultrapassar 10MB"
  },
  "terms_of_use": {
    "title": "Termos e condições",
    "close": "Fechar",
    "agree_to_tuvis": "Ao aceitar, você também concorda com os da Tuvis",
    "terms_of_service": "Termos de Serviço",
    "and": "e",
    "privacy_policy": "Política de privacidade"
  },
  "branding_page": {
    "name": "Nome",
    "priority": "Prioridade",
    "create_branding": "Adicionar marca",
    "update_branding": "Editar marca",
    "delete_branding": "Excluir marca",
    "delete_branding_modal_message": "Tem certeza de que deseja excluir esta marca?",
    "new_branding_title": "Nova marca",
    "edit_branding_title": "Editar marca",
    "identity_everyone": "Todos",
    "summary_title": "Marca",
    "summary_logo_set": "Logotipo definido",
    "section_details_title": "Detalhes",
    "section_details_desc": "Nomeie esta marca.",
    "section_identity_title": "Identidade",
    "section_identity_desc": "Aplicar a todos, ou restringir a grupos ou usuários específicos.",
    "section_title": "Marca",
    "section_desc": "Personalize o logotipo, o nome da empresa e o plano de fundo exibidos na página inicial para esta identidade.",
    "company_name": "Nome da empresa",
    "company_name_placeholder": "ex.: Acme Corp (exibido quando não há logotipo)",
    "company_name_help": "Usado como marca nominativa da página inicial apenas quando não há logotipo. Se você adicionar um logotipo abaixo, ele substitui o nome da empresa na nova aba.",
    "logo": "Logotipo",
    "logo_remove": "Remover",
    "logo_upload": "Enviar logotipo",
    "logo_uploading": "A enviar…",
    "logo_help": "O Tuvis armazena o ficheiro e disponibiliza-o aos navegadores dos seus utilizadores.",
    "logo_drop_hint": "Arraste uma imagem para aqui, ou clique para procurar",
    "logo_formats": "PNG, JPG, WEBP, GIF ou SVG · até 1 MB",
    "logo_replace": "Substituir",
    "logo_preview_caption": "Pré-visualização - como aparece na página inicial",
    "logo_bad_type": "Esse tipo de ficheiro não é suportado. Use PNG, JPG, WEBP, GIF ou SVG.",
    "logo_too_large": "Essa imagem tem mais de 1 MB. Envie um ficheiro menor.",
    "logo_upload_failed": "Não foi possível enviar a imagem. Tente novamente.",
    "background": "Plano de fundo",
    "background_placeholder": "#0b1220 ou https://…/imagem.jpg",
    "required": "Obrigatório",
    "save": "Salvar",
    "cancel": "Cancelar"
  },
  "block_page_tab": {
    "name": "Nome",
    "priority": "Prioridade",
    "create_block_page": "Adicionar página de bloqueio",
    "update_block_page": "Editar página de bloqueio",
    "delete_block_page": "Excluir página de bloqueio",
    "delete_block_page_modal_message": "Tem certeza de que deseja excluir esta página de bloqueio?",
    "new_block_page_title": "Nova página de bloqueio",
    "edit_block_page_title": "Editar página de bloqueio",
    "identity_everyone": "Todos",
    "summary_title": "Página de bloqueio",
    "section_details_title": "Detalhes",
    "section_details_desc": "Nomeie esta página de bloqueio.",
    "section_identity_title": "Identidade",
    "section_identity_desc": "Aplicar a todos, ou restringir a grupos ou usuários específicos.",
    "section_title": "Página de bloqueio",
    "section_desc": "Conteúdo exibido aos usuários quando o Tuvis Browser bloqueia uma navegação.",
    "heading": "Título",
    "heading_placeholder": "ex.: Este site está bloqueado",
    "message": "Mensagem",
    "message_placeholder": "ex.: O acesso a este site é restrito pela política da sua organização.",
    "contact": "Contato",
    "contact_placeholder": "admin@example.com ou https://…",
    "required": "Obrigatório",
    "save": "Salvar",
    "cancel": "Cancelar"
  },
  "access_requests_page": {
    "title": "Solicitações de acesso",
    "col_requester": "Solicitante",
    "col_host": "Host",
    "col_note": "Nota",
    "col_created": "Solicitado",
    "col_actions": "Ações",
    "allow": "Permitir",
    "requester_count_one": "{{count}} pessoa",
    "requester_count_other": "{{count}} pessoas",
    "allow_for_requesters_one": "Permitir {{target}} - para este solicitante",
    "allow_for_requesters_other": "Permitir {{target}} - para estes {{count}} solicitantes",
    "allow_for_everyone": "Permitir {{target}} - para todos",
    "allow_in_builder": "Abrir no editor de políticas…",
    "granted_policy_name": "{{target}} - pedido aprovado",
    "granted_toast_everyone": "{{target}} permitido para todos.",
    "granted_toast_requesters_one": "{{target}} permitido para este solicitante.",
    "granted_toast_requesters_other": "{{target}} permitido para estes {{count}} solicitantes.",
    "granted_toast_edit": "Editar política",
    "confirm_grant_title": "Permitir este pedido?",
    "confirm_grant_everyone": "Será criada uma política de acesso que permite {{target}} para todos, e o pedido fica aprovado.",
    "confirm_grant_requesters_one": "Será criada uma política de acesso que permite {{target}} para este solicitante, e o pedido fica aprovado.",
    "confirm_grant_requesters_other": "Será criada uma política de acesso que permite {{target}} para estes {{count}} solicitantes, e os pedidos ficam aprovados.",
    "confirm_grant_ok": "Permitir",
    "confirm_dismiss_title": "Descartar este pedido?",
    "confirm_dismiss_body_one": "{{target}} continua bloqueado para o solicitante. Não é informado de que o pedido foi descartado.",
    "confirm_dismiss_body_other": "{{target}} continua bloqueado para os {{count}} solicitantes. Não são informados de que o pedido foi descartado.",
    "confirm_dismiss_ok": "Descartar",
    "log": "Registo",
    "refresh": "Atualizar",
    "dismiss": "Descartar",
    "status_pending": "Pendente",
    "status_approved": "Aprovado",
    "status_dismissed": "Descartado"
  },
  "minimum_letters": "Mínimo de {{minimumLettersToSearch}} letras",
  "archive_teams_settings_page": {
    "title": "Arquivar mensagens do Teams",
    "description": "Conecte o seu tenant do Microsoft Teams para arquivar todas as mensagens de chat. As mensagens são capturadas em tempo real por meio de assinaturas do Microsoft Graph.",
    "connect_button": "Ativar arquivamento",
    "disconnect_button": "Desativar arquivamento",
    "connecting": "Conectando...",
    "connection_failed": "Falha ao ativar o arquivamento do Teams",
    "connected_success": "Arquivamento do Teams ativado com sucesso",
    "certificate_required": "Gere um certificado primeiro",
    "download_certificate_failed": "Falha ao baixar o certificado",
    "step1_certificate": "Etapa 1: baixar o certificado",
    "step1_description": "Baixe um certificado para autenticação segura com o Microsoft Azure. Envie-o para o seu App Registration do Azure em Certificates & Secrets. Verifique se o aplicativo tem a permissão de aplicativo Chat.Read.All com consentimento do administrador.",
    "download_certificate": "Baixar certificado",
    "step2_azure_config": "Etapa 2: configuração do Azure",
    "step2_description": "Informe os dados do seu App Registration do Azure. O aplicativo precisa ter a permissão Chat.Read.All concedida com consentimento do administrador.",
    "client_id": "ID do aplicativo (cliente)",
    "client_id_placeholder": "Informe o ID do aplicativo (cliente) do Azure",
    "tenant_id": "ID do diretório (tenant)",
    "tenant_id_placeholder": "Informe o ID do diretório (tenant) do Azure",
    "installed": {
      "title": "O arquivamento do Teams está ativo",
      "description": "As mensagens de chat do Teams estão sendo arquivadas em tempo real.",
      "subscription_expires": "A assinatura é renovada automaticamente (validade atual: {{date}})"
    },
    "uninstall_modal": {
      "title": "Desativar o arquivamento do Teams",
      "description": "Tem certeza de que deseja desativar o arquivamento de mensagens do Teams? Isso removerá a assinatura do webhook.",
      "warning": "As mensagens arquivadas serão mantidas, mas nenhuma mensagem nova será capturada.",
      "confirm": "Desativar arquivamento",
      "cancel": "Cancelar",
      "success": "Arquivamento do Teams desativado com sucesso",
      "error": "Falha ao desativar o arquivamento do Teams"
    }
  },
  "default_channels": {
    "whatsapp-web": "WhatsApp (aplicativo de desktop Tuvis)",
    "imessage": "iMessage",
    "telegram": "Telegram"
  }
}
